// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * flight.css
 *
 * Scoped styles for FlightBookingDetailsComponent.
 * All selectors use the "fbd-" prefix to avoid collisions with
 * shared classes used by hotels, excursions, and other pages.
 *
 * DO NOT rename or override any class that does not use "fbd-".
 * Shared classes (hw-table--default, hw-form--input, hw-modal*, etc.)
 * are intentionally left untouched.
 */

/* ─────────────────────────────────────────────────────────────────────────────
   CSS Custom Properties (design tokens)
   ───────────────────────────────────────────────────────────────────────────── */
:root {
    --fbd-primary: #2563eb;
    --fbd-primary-light: #eff6ff;
    --fbd-primary-mid: #93c5fd;
    --fbd-blue-dark: #1e40af;
    --fbd-surface: #ffffff;
    --fbd-surface-alt: #f8fafc;
    --fbd-surface-hover: #f1f5f9;
    --fbd-border: #e2e8f0;
    --fbd-border-focus: #93c5fd;
    --fbd-text-strong: #1e293b;
    --fbd-text-body: #334155;
    --fbd-text-muted: #64748b;
    --fbd-text-subtle: #94a3b8;
    --fbd-radius-sm: 6px;
    --fbd-radius-md: 6px;
    --fbd-radius-lg: 6px;
    --fbd-shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.08);
    --fbd-shadow-md: 0 4px 12px rgba(15, 23, 42, 0.10);
    --fbd-shadow-lg: 0 8px 24px rgba(15, 23, 42, 0.12);
    --fbd-gap-xs: 4px;
    --fbd-gap-sm: 8px;
    --fbd-gap-md: 12px;
    --fbd-gap-lg: 16px;
    --fbd-gap-xl: 20px;
    --fbd-gap-2xl: 24px;
    /* Match Hotels module typography (titles vs details stay separate) */
    --fbd-font: "DM Sans", sans-serif;
    --fbd-title-size: 18px;
    --fbd-title-weight: 700;
    --fbd-title-tracking: -0.01em;
    --fbd-text-size: 14.5px;
    --fbd-text-weight: 600;
}

/* Titles — section / card headings. Do not mix with .fbd-text. */
.fbd-title,
.fbd-card__title,
.fbd-section__title,
.fbd-route-city,
.fbd-tl-place__city,
.fbd-contact-badge__head,
.fbd-services-toggle__label,
.fbd-seat-segment-route,
.fbd-fb-connector__airline-name,
.fbd-select-pay-methods__title,
.fbd-pay-methods__title,
.fbd-pay-card__title,
.hw-exchk--methodName,
.fbd-baggage-modal .hw-modal-headerTitle,
.fbd-sidebar .hw-passenger--head h2,
.fbd-stripe .hw-modal-headerTitle,
.hw-exchk--panelTitle,
.hw-bkovl--title {
    font-family: var(--fbd-font);
    font-size: var(--fbd-title-size);
    font-weight: var(--fbd-title-weight);
    letter-spacing: var(--fbd-title-tracking);
}

/* Details / body copy. Do not mix with .fbd-title. */
.fbd-text,
.fbd-contact-row__val,
.fbd-contact-badge__field,
.fbd-airline-name,
.fbd-tl-time,
.fbd-info-list__item,
.fbd-hold-confirm,
.fbd-sidebar .hw-passenger--fareSummary__thead,
.fbd-sidebar .hw-passenger--fareSummary__tbodyTR,
.fbd-pax-table-wrap .fbd-pax-table tbody td {
    font-family: var(--fbd-font);
    font-size: var(--fbd-text-size);
    font-weight: var(--fbd-text-weight);
}

.fbd-page,
.fbd-sidebar,
.fbd-guestCard {
    font-family: var(--fbd-font);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Page wrapper
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-page {
    display: flex;
    flex-direction: column;
    /* no gap between the booking sections — they join into one continuous card
       (like the hotel's single guest card); only the flight box keeps a gap. */
    gap: 0;
}

/* beat the shared .hw-passenger--listShow { row-gap: 2rem } on the flight page only */
.hw-passenger--listShow.fbd-page {
    row-gap: 0;
}

/* the flight box (fbd-flightGroup) keeps a gap below it */
.fbd-page > .fbd-flightGroup {
    margin-bottom: 10px;
}

/* Booking sections live inside ONE card (like the hotel's .hw-hotel--guestCard):
   the wrapper is the card, the inner .fbd-section widgets are flattened, and a
   single divider sits between consecutive sections. */
.fbd-guestCard {
    background: var(--fbd-surface);
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-lg);
    box-shadow: var(--fbd-shadow-sm);
    padding: 20px;
}

.fbd-guestCard > .fbd-section {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    background: transparent;
    overflow: visible;
}

.fbd-guestCard > .fbd-section + .fbd-section {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--fbd-border);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Section widget card
   Replaces: hw-passenger--listShow__widget / hw-nav--tabContentRound /
             hw-nav--tabContentRoundWidget
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-card {
    background: var(--fbd-surface);
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-lg);
    box-shadow: var(--fbd-shadow-sm);
    overflow: hidden;
}

.fbd-card--flight {
    /* wrapper only — visual card is fbd-flight-box inside */
    background: transparent;
    border: none;
    box-shadow: none;
    border-radius: 0;
    overflow: visible;
}

/* Compound selector (0,2,0) beats the shared single-class
   .hw-passenger--listShow__widget { border-radius: 0.5rem } (0,1,0),
   regardless of CSS load order, so section cards match .fbd-flight-box (16px). */
.hw-passenger--listShow__widget.fbd-card {
    /* border-radius: var(--fbd-radius-lg); */
}

.hw-passenger--fareShow__widget.fbd-card {
    /* border-radius: var(--fbd-radius-lg); */
}

/* ─────────────────────────────────────────────────────────────────────────────
   Section header inside a card
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 14px;
    border-bottom: 1px solid var(--fbd-border);
    background: var(--fbd-surface-alt);
}

.fbd-card__title {
    color: var(--fbd-text-strong);
}

.fbd-card__body {
    padding: 20px;
}

.fbd-card__body--tight {
    padding: 14px 20px;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Section header inside a padded widget (Traveller Details, etc.)
   Sits INSIDE .hw-passenger--listShow__widget's own padding — no full-bleed bar.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-section__header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 20px;
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-section__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 6px;
    background: var(--fbd-primary-light);
    color: var(--fbd-primary);
}

.fbd-section__icon svg {
    width: 18px;
    height: 18px;
}

.fbd-section__title {
    color: var(--fbd-text-strong);
}

/* "(optional)" tag next to a section title */
.fbd-section__optional {
    font-size: 13px;
    font-weight: 500;
    color: var(--fbd-text-muted);
    margin-left: 4px;
}

/* content directly under a section header (spacing comes from the header's margin) */
.fbd-section__body {
    padding-top: 0;
}

/* padding for section cards whose widget has no built-in padding (e.g. fareShow) */
.fbd-section--pad {
    padding: 24px;
}

/* Contact Information review rows (step 2) — stacked label/value rows that
   mirror the hotel's contact details (.hw-hotel--reviewRow), flight-scoped. */
.fbd-contact-rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.fbd-contact-row {
    display: flex;
    align-items: baseline;
    gap: 12px;
}

.fbd-contact-row__lbl {
    font-size: 13px;
    font-weight: 500;
    color: var(--fbd-text-muted);
    min-width: 62px;
    flex: none;
}

.fbd-contact-row__val {
    color: var(--fbd-text-strong);
    word-break: break-word;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Gender/title custom dropdown (Traveller Details) — styled box + options panel.
   Control matches .hw-form--input dimensions; panel is a styled menu.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-gender {
    position: relative;
    width: 100%;
}

.fbd-gender__control {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 4.4rem;
    padding: 1rem 1.2rem;
    background: #fff;
    border: 1px solid var(--hw-gray-600);
    border-radius: 6px;
    /* match .hw-form--input typography so the height matches First/Last Name */
    font-size: 1.4rem;
    line-height: 1.5;
    color: var(--fbd-text-strong);
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

/* .hw-form--input bumps to 1.6rem/1.75 at >=992px, which makes the inputs taller;
   mirror it so the Gender control keeps the same height as the name fields. */
@media (min-width: 992px) {
    .fbd-gender__control {
        font-size: 1.6rem;
        line-height: 1.75;
    }
}

.fbd-gender.is-open .fbd-gender__control,
.fbd-gender__control:hover {
    border-color: var(--fbd-primary);
}

.fbd-gender.is-open .fbd-gender__control {
    box-shadow: 0 0 0 3px var(--fbd-primary-light);
}

.fbd-gender__control.is-error {
    border-color: red;
}

.fbd-gender__placeholder {
    color: var(--fbd-text-muted);
}

.fbd-gender__value {
    color: var(--fbd-text-strong);
}

.fbd-gender__chev {
    display: inline-flex;
    flex: 0 0 auto;
    color: var(--fbd-text-muted);
}

.fbd-gender__chev svg {
    width: 18px;
    height: 18px;
}

.fbd-gender__menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    z-index: 20;
    margin: 0;
    padding: 6px;
    list-style: none;
    background: #fff;
    border: 1px solid var(--fbd-border);
    border-radius: 8px;
    box-shadow: var(--fbd-shadow-md);
}

.fbd-gender__option {
    padding: 10px 12px;
    font-size: 14px;
    color: var(--fbd-text-strong);
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.12s ease;
}

.fbd-gender__option:hover {
    background: var(--fbd-surface-alt);
}

.fbd-gender__option.is-selected {
    background: var(--fbd-primary-light);
    color: var(--fbd-primary);
    font-weight: 600;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Booking processing overlay — styles for the shared BookingProcessingOverlay
   component (used by hotel/excursion checkouts). Copied here so the flight page
   renders it styled without depending on Excursion.css being loaded. These
   .hw-bkovl* classes are used only by that overlay, so no other page is affected.
   ───────────────────────────────────────────────────────────────────────────── */
.hw-bkovl { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(20,28,48,.55); -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px); }
.hw-bkovl--card { width: 100%; max-width: 380px; background: #fff; border-radius: 18px; padding: 30px 26px 22px; box-shadow: 0 26px 64px -22px rgba(16,24,40,.45); text-align: center; animation: hwBkPop .28s ease; }
@keyframes hwBkPop { from { opacity: 0; transform: translateY(10px) scale(.97); } to { opacity: 1; transform: none; } }
.hw-bkovl--ring { position: relative; width: 74px; height: 74px; margin: 0 auto 16px; }
.hw-bkovl--spinner { width: 74px; height: 74px; animation: hwBkRotate 1.3s linear infinite; }
.hw-bkovl--track { fill: none; stroke: #eaf0ff; stroke-width: 4; }
.hw-bkovl--path { fill: none; stroke: #3264FF; stroke-width: 4; stroke-linecap: round; stroke-dasharray: 85 160; }
.hw-bkovl--lock { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #283D6B; }
@keyframes hwBkRotate { to { transform: rotate(360deg); } }
.hw-bkovl--title { color: #1b2439; }
.hw-bkovl--sub { margin-top: 4px; color: #6b7280; font-size: 13px; }
.hw-bkovl--steps { list-style: none; margin: 18px 0 0; padding: 0; display: grid; gap: 11px; text-align: left; }
.hw-bkovl--step { display: flex; align-items: center; gap: 11px; color: #98a2b6; font-size: 14px; font-weight: 600; transition: color .3s; }
.hw-bkovl--step.is-active { color: #1b2439; }
.hw-bkovl--step.is-done { color: #137333; }
.hw-bkovl--dot { width: 21px; height: 21px; border-radius: 50%; border: 2px solid #dfe4ee; display: inline-flex; align-items: center; justify-content: center; flex: none; color: #fff; transition: all .3s; }
.hw-bkovl--dot svg { opacity: 0; transition: opacity .2s; }
.hw-bkovl--step.is-active .hw-bkovl--dot { border-color: #3264FF; box-shadow: 0 0 0 4px rgba(50,100,255,.12); animation: hwBkPulse 1.2s ease-in-out infinite; }
.hw-bkovl--step.is-done .hw-bkovl--dot { background: #137333; border-color: #137333; }
.hw-bkovl--step.is-done .hw-bkovl--dot svg { opacity: 1; }
@keyframes hwBkPulse { 0%,100% { box-shadow: 0 0 0 4px rgba(50,100,255,.12); } 50% { box-shadow: 0 0 0 7px rgba(50,100,255,.05); } }
.hw-bkovl--note { margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef1f7; color: #6b7280; font-size: 12.5px; }

/* ─────────────────────────────────────────────────────────────────────────────
   Flight route header (City → City + meta line)
   Replaces: hw-inner--flightBookingBox header area
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-route-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--fbd-gap-sm);
    padding: 16px 20px 0;
}

.fbd-route-cities {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-sm);
}

.fbd-route-city {
    color: var(--fbd-text-strong);
}

.fbd-route-arrow {
    color: var(--fbd-text-muted);
    display: inline-flex;
}

.fbd-route-meta {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
    flex-wrap: wrap;
    margin-top: 4px;
    font-size: 13px;
    color: var(--fbd-text-muted);
}

.fbd-route-meta__dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--fbd-text-subtle);
    display: inline-block;
}

.fbd-fare-rules-link {
    font-size: 13px;
    font-weight: 600;
    color: var(--fbd-primary);
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
    padding: 6px 12px;
    border-radius: var(--fbd-radius-sm);
    border: 1px solid var(--fbd-primary-mid);
    background: var(--fbd-primary-light);
    transition: background 0.15s ease, color 0.15s ease;
}

.fbd-fare-rules-link:hover {
    background: var(--fbd-primary);
    color: #fff;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Airline info bar (logo + name + code + fare identifier)
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-airline-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--fbd-gap-sm);
    padding: 12px 20px;
    background: var(--fbd-surface-alt);
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-airline-info {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-lg);
}

.fbd-airline-logo {
    display: flex;
    align-items: center;
    border-radius: var(--fbd-radius-sm);
    overflow: hidden;
    background: #fff;
    border: 1px solid var(--fbd-border);
    padding: 2px;
}

.fbd-airline-logo img {
    display: block;
    object-fit: contain;
}

.fbd-airline-name {
    color: var(--fbd-primary);
}

.fbd-airline-code {
    font-size: 13px;
    font-weight: 600;
    color: var(--fbd-text-muted);
    margin-top: 2px;
}

.fbd-fare-identifier {
    font-size: 13px;
    font-weight: 700;
    color: var(--fbd-text-strong);
    background: #dbeafe;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    padding: 4px 10px;
    white-space: nowrap;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Flight timeline
   Replaces: hw-flight--timeline, hw-flight--listOut, hw-flight--segment,
             hw-flight--marker, hw-flight--timelineDetails,
             f-timeDate, f-timeDate--inline, f-place, f-dot, dot, line
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-timeline {
    display: flex;
    flex-direction: column;
    padding: 16px 20px 0;
    gap: 0;
}

.fbd-timeline__row {
    display: flex;
    gap: var(--fbd-gap-md);
    position: relative;
}

.fbd-timeline__marker {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: 18px;
    padding-top: 5px;
}

.fbd-timeline__dot {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    border: 2px solid var(--fbd-primary);
    background: var(--fbd-surface);
    flex-shrink: 0;
}

.fbd-timeline__line {
    flex: 1;
    width: 2px;
    background: linear-gradient(to bottom, var(--fbd-primary-mid), #e0e7ff);
    margin: 2px 0;
    min-height: 40px;
}

.fbd-timeline__details {
    flex: 1;
    padding-bottom: 20px;
}

.fbd-tl-time {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
    color: var(--fbd-primary);
    margin-bottom: 4px;
}

.fbd-tl-time__sep {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--fbd-primary-mid);
    display: inline-block;
    flex-shrink: 0;
}

.fbd-tl-place {
    color: var(--fbd-primary);
}

.fbd-tl-place__city {
    display: inline;
}

.fbd-tl-place__sub {
    font-size: 12px;
    color: var(--fbd-text-muted);
    margin-top: 2px;
}

.fbd-tl-duration {
    font-size: 12px;
    font-weight: 600;
    color: var(--fbd-primary);
    background: var(--fbd-primary-light);
    border-radius: 6px;
    padding: 3px 8px;
    display: inline-flex;
    margin: 6px 0 4px;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Baggage line
   Replaces: hw-baggage--line
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-baggage-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--fbd-gap-sm);
    padding: 10px 20px 14px;
    background: var(--fbd-surface-alt);
    border-top: 1px solid var(--fbd-border);
    margin-top: 4px;
}

.fbd-baggage-bar__items {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--fbd-gap-lg);
    font-size: 13px;
}

.fbd-baggage-bar__item {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
    flex-wrap: wrap;
}

.fbd-baggage-bar__icon {
    color: var(--fbd-primary);
    display: inline-flex;
}

.fbd-baggage-bar__label {
    font-weight: 600;
    color: var(--fbd-text-strong);
}

.fbd-baggage-bar__value {
    color: var(--fbd-text-body);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Layover / connection badge
   Replaces: hw-search--innerflight__divider, divider-badge
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-layover {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-sm);
    padding: 8px 20px;
    background: #fef9ec;
    border-top: 1px dashed #fbbf24;
    border-bottom: 1px dashed #fbbf24;
}

.fbd-layover__badge {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-sm);
    font-size: 12px;
    color: #92400e;
    font-weight: 600;
    flex-wrap: wrap;
}

.fbd-layover__line {
    flex: 1;
    height: 1px;
    background: #fde68a;
}

/* Show more/less button for multi-segment */
.fbd-segment-toggle {
    display: flex;
    justify-content: center;
    padding: 8px 20px 12px;
}

.fbd-segment-toggle__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid var(--fbd-border);
    background: var(--fbd-surface-alt);
    color: var(--fbd-text-muted);
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
}

.fbd-segment-toggle__btn:hover {
    background: var(--fbd-primary-light);
    color: var(--fbd-primary);
    border-color: var(--fbd-primary-mid);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Passenger accordion card
   Replaces: hw-passenger--detailsGroupItem, fare-toggle-parent,
             hw-passenger--fareShowToggle, hw-passenger--fareShowToggleContent,
             hw-passenger--detailsGroup
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-pax-group {
    display: flex;
    flex-direction: column;
    gap: var(--fbd-gap-md);
    margin-top: var(--fbd-gap-lg);
}

.fbd-pax-card {
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    overflow: hidden;
    transition: box-shadow 0.15s ease;
}

.fbd-pax-card.active {
    box-shadow: none;
}

.fbd-pax-card__toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    cursor: pointer;
    /* background: var(--fbd-surface-alt); */
    user-select: none;
    transition: background 0.15s ease;
}

.fbd-pax-card__toggle:hover {
    background: var(--fbd-surface-hover);
}

.fbd-pax-card.active .fbd-pax-card__toggle {
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-pax-card__name {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-sm);
    font-weight: 700;
    color: var(--fbd-primary);
}

/* beat the shared \`.hw-passenger--listShow__widget .hw-text18\` (0,2,0) that
   otherwise forces this to 1.8rem; !important keeps it 1.4rem at every width. */
.fbd-pax-card__name {
    font-size: 1.4rem !important;
}

.fbd-pax-card__chevron {
    color: var(--fbd-text-muted);
    display: inline-flex;
    transition: transform 0.2s ease;
}

.fbd-pax-card.active .fbd-pax-card__chevron {
    transform: rotate(180deg);
}

.fbd-pax-card__body {
    padding: 18px;
    background: var(--fbd-surface);
}

/* Sub-section label (Passport Details) */
.fbd-subsection-label {
    font-size: 13px;
    font-weight: 700;
    color: var(--fbd-text-strong);
    letter-spacing: 0.04em;
    margin: 14px 0 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--fbd-border);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Meals & Baggage section
   Replaces: hw-passenger-meal-baggage and surrounding structure
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-services-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    cursor: pointer;
    background: var(--fbd-surface-alt);
    border-bottom: 1px solid var(--fbd-border);
    transition: background 0.15s ease;
}

.fbd-services-toggle:hover {
    background: var(--fbd-surface-hover);
}

.fbd-services-toggle__label {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-sm);
    color: var(--fbd-text-strong);
}

.fbd-services-toggle__icon {
    color: var(--fbd-primary);
    display: inline-flex;
}

.fbd-services-toggle__chevron {
    color: var(--fbd-text-muted);
    display: inline-flex;
    transition: transform 0.2s ease;
}

.fbd-services-toggle.open .fbd-services-toggle__chevron {
    transform: rotate(180deg);
}

.fbd-services-body {
    padding: 18px 20px;
}

.fbd-services-segment {
    margin-bottom: 20px;
}

.fbd-services-segment:last-child {
    margin-bottom: 0;
}

.fbd-services-segment__title {
    font-size: 13px;
    font-weight: 700;
    color: var(--fbd-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 10px;
}

.fbd-services-pax-row {
    display: flex;
    align-items: flex-start;
    gap: var(--fbd-gap-md);
    flex-wrap: wrap;
    padding: 10px 0;
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-services-pax-row:last-child {
    border-bottom: none;
}

.fbd-services-pax-row__label {
    font-size: 13px;
    font-weight: 600;
    color: var(--fbd-text-body);
    min-width: 100px;
    padding-top: 8px;
}

.fbd-services-select-group {
    display: flex;
    gap: var(--fbd-gap-md);
    flex: 1;
    flex-wrap: wrap;
}

.fbd-services-select-wrap {
    flex: 1;
    min-width: 160px;
}

.fbd-services-select-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--fbd-text-muted);
    margin-bottom: 4px;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Seat selection section
   Replaces: hw-segment--data, hw-segment-text,
             hw-btn hw-btn--primary hw-btn--mn140 (only for seat btn)
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-seat-segment-list {
    display: flex;
    flex-direction: column;
    gap: var(--fbd-gap-sm);
}

.fbd-seat-segment-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--fbd-gap-md);
    flex-wrap: wrap;
    padding: 14px 16px;
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    background: var(--fbd-surface-alt);
    transition: box-shadow 0.15s ease;
}

.fbd-seat-segment-row:hover {
    box-shadow: var(--fbd-shadow-sm);
}

.fbd-seat-segment-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.fbd-seat-segment-route {
    color: var(--fbd-text-strong);
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
}

.fbd-seat-segment-meta {
    font-size: 12px;
    color: var(--fbd-text-muted);
}

.fbd-seat-selected-tag {
    display: inline-flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
    font-size: 12px;
    font-weight: 600;
    color: #16a34a;
    background: #dcfce7;
    border: 1px solid #86efac;
    border-radius: 6px;
    padding: 4px 10px;
}

.fbd-btn-seat {
    display: inline-flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
    padding: 8px 20px;
    min-width: 130px;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    border-radius: var(--fbd-radius-sm);
    cursor: pointer;
    border: none;
    background: var(--fbd-primary);
    color: #fff;
    transition: background 0.15s ease, box-shadow 0.15s ease;
}

.fbd-btn-seat:hover {
    background: var(--fbd-blue-dark);
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.30);
}

.fbd-btn-seat--edit {
    background: var(--fbd-surface);
    color: var(--fbd-primary);
    border: 1.5px solid var(--fbd-primary-mid);
}

.fbd-btn-seat--edit:hover {
    background: var(--fbd-primary-light);
    box-shadow: none;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Contact Information section
   Replaces: hw-contact--inputSingleField, hw-inner--fullWidth, input-m--field
   ───────────────────────────────────────────────────────────────────────────── */
/* Phone code + mobile number as ONE joined field (same as the hotel's
   .hw-contact--inputSingleField): one outer border, a grid of
   [phone-code auto | number 1fr], and borderless inner inputs. The
   HwPhoneCodeSelect control supplies the "|" divider via its own right border. */
.fbd-contact-phone-row {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: stretch;
    border: 1px solid var(--hw-gray-600);
    border-radius: 6px;
    /* reserve room for the absolutely-positioned phone-code / number errors so the
       card (overflow:hidden) doesn't clip them when the email is valid */
    margin-bottom: 2.4rem;
}

.fbd-contact-phone-row > div {
    position: relative;
}

/* inner inputs have no border — the row provides the single border */
.fbd-contact-phone-row .hw-form--input {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
}

/* separator line between phone code and mobile number */
.fbd-contact-phone-row .fbd-contact-phone-code {
    border-right: 1px solid var(--hw-gray-600) !important;
}

.fbd-contact-phone-row .fbd-contact-phone-code .hw-pcsel--control {
    border-right: none !important;
}

/* keep the number input snug to the divider, like the hotel's input-m--field */
.fbd-contact-phone-row .input-m--field .hw-form--input {
    padding-left: 1.2rem;
}

/* inline errors float below the field */
.fbd-contact-phone-row .hw-p-error-cls {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    white-space: nowrap;
    z-index: 5;
}

/* fixed phone-code width like the hotel (.hw--hotel-phonecode: 18rem / 14rem) so
   it doesn't grow to its content and squeeze the mobile number. display:flex lets
   the HwPhoneCodeSelect (flex:1) fill it. */
.fbd-contact-phone-code {
    display: flex;
    width: 18rem;
    min-width: 14rem;
}

.fbd-contact-phone-code p.hw-p-error-cls {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px !important;
    white-space: nowrap;
}

.fbd-contact-phone-number {
    min-width: 0;
}

.fbd-contact-phone-number p.hw-p-error-cls {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px !important;
    white-space: nowrap;
}

/* At desktop the shared .hw-passenger--list gets \`height:100%; overflow-y:auto\`,
   turning the flight's left column into a scroll container that CLIPS absolutely
   positioned dropdown menus (the phone-code list gets cut off and scrolls).
   Flight-scoped (under .fbd-overlap-wrap): let the column grow naturally so menus
   overflow freely — the page scrolls instead. */
.fbd-overlap-wrap .hw-passenger--list {
    height: auto;
    overflow: visible;
}

/* Contact Info badge (Tab 2 read-only view)
   Replaces: hw-contact--badge, hw-contact--badgeHead, hw-contact--badgeBody */
.fbd-contact-badge {
    background: var(--fbd-surface);
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    overflow: hidden;
    box-shadow: var(--fbd-shadow-sm);
}

.fbd-contact-badge__head {
    padding: 12px 18px;
    color: var(--fbd-text-strong);
    background: var(--fbd-surface-alt);
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-contact-badge__body {
    padding: 16px 18px;
}

.fbd-contact-badge__field {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-sm);
}

.fbd-contact-badge__key {
    font-weight: 700;
    color: var(--fbd-text-strong);
}

.fbd-contact-badge__val {
    color: var(--fbd-primary);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Address Details section
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-address-section {
    /* container for the address fields — uses standard .row/.col Bootstrap grid */
    margin-top: 14px;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Booking Reference widget
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-booking-ref {
    padding: 0;
}

/* thin divider between payment methods and Booking Reference — mirrors the
   hotel's .hw-hotel--guestDivider (kept flight-scoped, in flight.css). */
.fbd-divider {
    height: 1px;
    background: var(--fbd-border);
    margin: 16px 0;
}

/* Booking Reference label — mirrors the hotel/excursion .hw-exchk--label
   (.hw-exchk--field.hw-exchk--bookingRef) so both modules read identically.
   Kept flight-scoped here rather than reusing the shared class. */
.fbd-booking-ref__label {
    display: block;
    font-family: var(--fbd-font);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: normal;
    color: #1b2439;
    margin-bottom: 6px;
}

/* "(optional)" tag — matches .hw-exchk--optional (inherits the 14px label size) */
.fbd-booking-ref__label .fbd-section__optional {
    font-size: inherit;
    font-weight: 500;
    color: #98a2b6;
    margin-left: 0;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Traveller summary table wrapper
   The inner table keeps hw-table--default (shared); only the outer wrapper
   and the section heading get new classes.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-summary-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: var(--fbd-radius-md);
    border: 1px solid var(--fbd-border);
}

.fbd-summary-wrap .hw-table--default {
    /* ensure table sits flush inside the rounded wrapper */
    border-radius: 0;
    border: none;
    margin-bottom: 0;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Important Information list
   Replaces: hw-list--circleSmall (flight-specific usage only)
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-info-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--fbd-gap-sm);
}

.fbd-info-list__item {
    display: flex;
    align-items: flex-start;
    gap: var(--fbd-gap-sm);
    color: var(--fbd-text-body);
    line-height: 1.5;
}

.fbd-info-list__item::before {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--fbd-primary);
    flex-shrink: 0;
    margin-top: 6px;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Seat map legend (inside CommonPopup)
   Replaces: hw-seatmap-legend, hw-seat-selected, hw-seat-not-selected
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-seat-legend {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--fbd-gap-lg);
    padding: 10px 0;
}

.fbd-seat-legend__item {
    display: flex;
    align-items: center;
    gap: var(--fbd-gap-xs);
    font-size: 12px;
    color: var(--fbd-text-body);
    font-weight: 500;
}

.fbd-seat-legend__swatch {
    width: 16px;
    height: 16px;
    border-radius: 6px;
    border: 1px solid var(--fbd-border);
}

.fbd-seat-legend__swatch--unavailable {
    background: #e2e8f0;
}

.fbd-seat-legend__swatch--premium {
    background: #fde68a;
    border-color: #fbbf24;
}

.fbd-seat-legend__swatch--selected {
    background: var(--fbd-primary);
    border-color: var(--fbd-blue-dark);
}

/* ─────────────────────────────────────────────────────────────────────────────
   Section spacing helper
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-pt16 {
    padding-top: 16px;
}

.fbd-pt20 {
    padding-top: 20px;
}

.fbd-mt10 {
    margin-top: 10px;
}

.fbd-mt16 {
    margin-top: 16px;
}

.fbd-mt20 {
    margin-top: 20px;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Responsive overrides
   ───────────────────────────────────────────────────────────────────────────── */
@media (max-width: 768px) {

    .fbd-card__body,
    .fbd-card__body--tight {
        padding: 14px;
    }

    .fbd-route-header {
        padding: 12px 14px 0;
    }

    .fbd-airline-bar {
        padding: 10px 14px;
    }

    .fbd-timeline {
        padding: 12px 14px 0;
    }

    .fbd-baggage-bar {
        padding: 10px 14px 12px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .fbd-seat-segment-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .fbd-btn-seat {
        width: 100%;
    }

    /* Seat Selection: stack the flight info + Select Seats button so the info
       doesn't squish into a narrow column on small screens. */
    .fbd-seatsel-row {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .fbd-seatsel-row .hw-segment--data {
        flex-wrap: wrap;
    }

    .fbd-seatsel-row .hw-btn {
        width: 100%;
    }

    /* keep the phone code + number joined on mobile too, just a touch narrower */
    .fbd-contact-phone-code {
        width: 13rem;
        min-width: 11rem;
    }

    .fbd-contact-phone-code p{
    margin-top: 48px !important;
}

    .fbd-pax-card__body {
        padding: 14px;
    }

    .fbd-services-body {
        padding: 14px;
    }

    .fbd-services-pax-row {
        flex-direction: column;
    }

    .fbd-services-pax-row__label {
        padding-top: 0;
    }

    .fbd-route-city,
    .fbd-card__title {
        font-size: var(--fbd-title-size);
    }
}

/* ─────────────────────────────────────────────────────────────────────────────
   fbd-flight-box  — ticket-style flight card (reference UI redesign)
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-flight-box {
    background: #fff;
    border: 1px solid #dbeafe;
    border-radius: 0;
    box-shadow: 0 2px 12px rgba(15, 23, 42, 0.07);
    overflow: hidden;
    /* margin-bottom: 12px; */
}

/* ── top meta row: date + stops/duration on left, fare rules link on right ── */
.fbd-fb-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 6px;
    padding: 12px 20px;
    border-bottom: 1px dashed #bfdbfe;
    background: #f0f7ff;
}

.fbd-fb-meta__left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475569;
    font-weight: 500;
    flex-wrap: wrap;
}

.fbd-fb-meta__sep {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #94a3b8;
    display: inline-block;
    flex-shrink: 0;
}

.fbd-fb-meta__pipe {
    color: #cbd5e1;
    font-weight: 300;
}

.fbd-fb-meta__fare-link {
    font-size: 13px;
    font-weight: 600;
    color: #2563eb;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
    transition: opacity 0.15s;
}

.fbd-fb-meta__fare-link:hover {
    opacity: 0.75;
}

/* ── main body: IATA codes + dotted line + plane ── */
.fbd-fb-body {
    padding: 20px 24px 16px;
}

.fbd-fb-route {
    display: flex;
    align-items: center;
    gap: 0;
    width: 100%;
}

.fbd-fb-iata {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 70px;
    flex-shrink: 0;
}

.fbd-fb-iata--right {
    align-items: flex-end;
}

.fbd-fb-iata__code {
    font-size: 27px;
    font-weight: 800;
    color: #1e293b;
    letter-spacing: -1px;
    line-height: 1;
}

.fbd-fb-iata__time {
    font-size: 12px;
    color: #64748b;
    font-weight: 500;
    margin-top: 4px;
}

/* center: dotted connector line with plane icon */
.fbd-fb-connector {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 0 12px;
}

.fbd-fb-connector__line-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 0;
}

.fbd-fb-connector__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #2563eb;
    flex-shrink: 0;
}

.fbd-fb-connector__dashed {
    flex: 1;
    height: 2px;
    background: repeating-linear-gradient(to right,
            #93c5fd 0px,
            #93c5fd 6px,
            transparent 6px,
            transparent 12px);
}

.fbd-fb-connector__plane {
    flex-shrink: 0;
    color: #2563eb;
    display: inline-flex;
    align-items: center;
    margin: 0 4px;
    rotate: 45deg;
}

.fbd-fb-connector__plane svg {
    width: 22px;
    height: 22px;
}

.fbd-fb-connector__arrow {
    flex: 1;
    height: 2px;
    background: repeating-linear-gradient(to right,
            #93c5fd 0px,
            #93c5fd 6px,
            transparent 6px,
            transparent 12px);
}

.fbd-fb-connector__info {
    font-size: 12px;
    color: #64748b;
    font-weight: 500;
    text-align: center;
    margin-top: 2px;
}

/* airline row: flight-no on the LEFT, logo + name on the RIGHT */
.fbd-fb-connector__airline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    text-align: left;
    margin-bottom: 16px;
}

/* right group: logo + airline name */
.fbd-fb-connector__airline-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.fbd-fb-connector__logo {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    object-fit: contain;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    background: #fff;
    padding: 2px;
}

.fbd-fb-connector__airline-name {
    color: #1e293b;
}

/* right: flight number + fare */
.fbd-fb-connector__flight-no {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    text-align: right;
}

/* ── duration labels on each side ── */
.fbd-fb-iata__duration {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 2px;
}

/* ── city names below IATA codes ── */
.fbd-fb-iata__city {
    font-size: 13px;
    color: #64748b;
    font-weight: 600;
    margin-top: 6px;
}

/* ── baggage strip ── */
.fbd-fb-baggage {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 20px 14px;
    border-top: 1px solid #f1f5f9;
}

.fbd-fb-baggage__pills {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.fbd-fb-baggage__pill {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #334155;
    font-weight: 500;
}

.fbd-fb-baggage__pill-icon {
    color: #2563eb;
    display: inline-flex;
    align-items: center;
}

.fbd-fb-baggage__pill-label {
    font-weight: 600;
    color: #475569;
}

.fbd-fb-baggage__pill-value {
    color: #1e293b;
}

.fbd-fb-baggage__link {
    font-size: 13px;
    font-weight: 600;
    color: #2563eb;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    background: none;
    border: none;
    padding: 0;
    transition: opacity 0.15s;
}

.fbd-fb-baggage__link:hover {
    opacity: 0.75;
}

/* ── responsive ── */
@media (max-width: 600px) {
    .fbd-fb-iata__code {
        font-size: 23px;
    }

    .fbd-fb-meta {
        padding: 10px 14px;
    }

    .fbd-fb-body {
        padding: 16px 14px 12px;
    }

    .fbd-fb-baggage {
        padding: 10px 14px 12px;
    }
}


/* ─────────────────────────────────────────────────────────────────────────────
   Baggage Details modal (BaggageDetailsPopup)
   Scoped under .fbd-baggage-modal so the shared .hw-modal* / .hw-table* classes
   used by other popups are NOT affected.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-baggage-modal {
    --bs-modal-width: 52rem;
}

.fbd-baggage-modal .hw-modal-dialog {
    max-width: 520px !important;
    width: 92% !important;
    margin-left: auto;
    margin-right: auto;
}

.fbd-baggage-modal .hw-modal-content {
    border-radius: var(--fbd-radius-lg);
    border: 1px solid var(--fbd-border);
    box-shadow: var(--fbd-shadow-lg);
    overflow: hidden;
}

.fbd-baggage-modal .hw-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background: var(--fbd-surface-alt);
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-baggage-modal .hw-modal-headerTitle {
    color: var(--fbd-text-strong);
}

.fbd-baggage-modal .hw-modal-body {
    padding: 18px 20px 22px !important;
}

.fbd-baggage-modal .hw-modal--close {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: var(--fbd-text-muted);
    transition: color 0.15s ease;
}

.fbd-baggage-modal .hw-modal--close:hover {
    color: var(--fbd-text-strong);
}

/* airline logo + route summary band */
.fbd-baggage-modal .fbd-bag-summary {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: var(--fbd-primary-light);
    border: 1px solid var(--fbd-primary-mid);
    border-radius: var(--fbd-radius-md);
    margin-bottom: 16px;
}

.fbd-baggage-modal .fbd-bag-summary img {
    border-radius: 6px;
    border: 1px solid var(--fbd-border);
    background: #fff;
    padding: 2px;
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.fbd-baggage-modal .fbd-bag-summary .h4 {
    font-size: 15px;
    font-weight: 700;
}

/* baggage table */
.fbd-baggage-modal .hw-table--baggage {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    overflow: hidden;
}

.fbd-baggage-modal .hw-table--baggage thead th {
    background: var(--fbd-surface-alt);
    color: var(--fbd-text-strong);
    font-size: 13px;
    font-weight: 700;
    padding: 10px 14px;
    text-align: left;
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-baggage-modal .hw-table--baggage tbody td {
    padding: 10px 14px;
    font-size: 13.5px;
    color: var(--fbd-text-body);
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-baggage-modal .hw-table--baggage tbody tr:last-child td {
    border-bottom: none;
}

.fbd-baggage-modal .hw-table--baggage tbody tr:nth-child(even) td {
    background: var(--fbd-surface-alt);
}

/* ── responsive (phones): the 3-column baggage table + header icons overflow a
   ~334px popup and the last column gets clipped. Tighten padding/font, drop the
   header icons, and let the table scroll horizontally as a safety net. ── */
@media (max-width: 600px) {
    .fbd-baggage-modal .hw-modal-body {
        padding: 14px 14px 18px !important;
    }

    .fbd-baggage-modal .hw-table--responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .fbd-baggage-modal .hw-table--baggage thead th,
    .fbd-baggage-modal .hw-table--baggage tbody td {
        padding: 8px 9px;
        font-size: 12px;
        white-space: nowrap;
    }

    /* the Check-In / Cabin header icons eat width on tiny screens */
    .fbd-baggage-modal .hw-table--baggage thead th svg {
        display: none;
    }

    .fbd-baggage-modal .fbd-bag-summary .h4 {
        font-size: 14px;
    }
}


/* ─────────────────────────────────────────────────────────────────────────────
   Fare Summary sidebar (BookingDetailsSideBarComponent — flight only)
   Scoped under .fbd-sidebar so shared .hw-passenger--fareSummary* used elsewhere
   is NOT affected. Amount colors (.hw-blue etc.) are left as-is on purpose.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-sidebar {
    background: var(--fbd-surface);
    border: 1px solid var(--fbd-border);
    box-shadow: var(--fbd-shadow-sm);
    overflow: hidden;
}

.hw-passenger--fareSummary.fbd-sidebar {
    border-radius: 6px !important;
}

/* Tab 3: shared rule zeroes the fare-summary radius with !important
   (.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary).
   Restore 16px for the flight sidebar only (it carries .fbd-sidebar). */
/* On the confirmation page the children are already self-contained
   .hw-after--bookingWidget cards, so the outer frame only shows as a faint
   hairline around them — drop the border/shadow there (tab 3 only). */
.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary.fbd-sidebar {
    border-radius: 6px !important;
    border: 0;
    box-shadow: none;
}

/* header band */
.fbd-sidebar .hw-passenger--head {
    padding: 16px 20px;
    background: var(--fbd-surface-alt);
    border-bottom: 1px solid var(--fbd-border);
}

.fbd-sidebar .hw-passenger--head h2 {
    color: var(--fbd-text-strong);
}

.fbd-sidebar .hw-passenger--fareSummary__box {
    padding: 20px;
}

/* fare rows: match the hotel's .hw-passenger--fareSummary body rows, which are
   marked up as \`hw-text14 hw-fontBold\` (14px / bold / 1.71429) rather than the
   flight module's 14.5px / 600 body text. */
.fbd-sidebar .hw-passenger--fareSummary__thead,
.fbd-sidebar .hw-passenger--fareSummary__tbodyTR {
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.71429;
}

.fbd-sidebar .hw-passenger--fareSummary__thead > span,
.fbd-sidebar .hw-passenger--fareSummary__tbodyTR > span {
    font-size: 14px;
    font-weight: 700;
}

/* amounts: the hotel renders these in --hw-black (hw-black), not the brand blue.
   .hw-blue sets color with !important, so match that weight to win. */
.fbd-sidebar .hw-passenger--fareSummary__thead > span.hw-blue,
.fbd-sidebar .hw-passenger--fareSummary__tbodyTR > span.hw-blue {
    color: var(--hw-black) !important;
}

/* total footer emphasis — separation comes from the border + padding alone,
   so no extra margin above the Total row */
.fbd-sidebar .hw-passenger--fareSummary__tfoot {
    border-top: 1px solid var(--fbd-border);
    padding: 10px 0 0;
    /* margin-top: 0 !important; */
    align-items: center;
}

/* "Price Breakup" panel heading only — the Download Tickets title is left on
   the shared .h4 styling. */
.fbd-sidebar .hw-after--bookingWidget.price-backup .h4 {
    font-size: 16px;
    font-weight: 700;
}

.fbd-sidebar .hw-after--bookingWidget.tickets .h4 {
    font-size: 18px;
}

/* .fbd-sidebar .hw-passenger--fareSummary__tfoot span {
    font-size: 18px;
} */

/* section dividers for coupon / payment blocks */
.fbd-sidebar .hw-apply--coupen,
.fbd-sidebar .hw-select--payment {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px dashed var(--fbd-border);
}

/* payment method radio cards */
.fbd-sidebar .hw-radio--btnIcon {
    border-radius: var(--fbd-radius-md);
    transition: border-color 0.15s ease, background 0.15s ease;
}


/* ─────────────────────────────────────────────────────────────────────────────
   Booking step progress (BookingStepProgress — flight only)
   Scoped under .fbd-steps. Highlights the current step, shows completed steps
   with a filled connector, and dims upcoming steps.
   ───────────────────────────────────────────────────────────────────────────── */
/* step number bubble — default (upcoming) */
.fbd-steps .lm-i {
    background-color: var(--fbd-surface);
    color: var(--fbd-text-subtle);
    border: 2px solid var(--fbd-border);
    width: 34px;
    height: 34px;
    font-size: 15px;
    font-weight: 700;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

/* step label — default (upcoming) */
.fbd-steps .hw-step .lm-icon--grid .hw-text14 {
    color: var(--fbd-text-subtle);
    font-weight: 600;
    transition: color 0.2s ease;
}

/* ACTIVE step */
.fbd-steps .hw-step.active .lm-i {
    background-color: var(--fbd-primary);
    border-color: var(--fbd-primary);
    color: #fff;
    box-shadow: 0 0 0 4px var(--fbd-primary-light);
}

.fbd-steps .hw-step.active .lm-icon--grid .hw-text14 {
    color: var(--fbd-text-strong);
    font-weight: 700;
}

/* COMPLETE step — shared rule paints the white check via background-image;
   we only recolor the bubble (never use the background shorthand or the check disappears) */
.fbd-steps .hw-step.complete .lm-i {
    background-color: var(--fbd-primary);
    border-color: var(--fbd-primary);
}

.fbd-steps .hw-step.complete .lm-icon--grid .hw-text14 {
    color: var(--fbd-text-body);
    font-weight: 600;
}

/* connector line between steps */
.fbd-steps .row>.hw-step:not(:last-child)::after {
    background-color: var(--fbd-border);
    height: 2px;
    border-radius: 6px;
}

.fbd-steps .row>.hw-step.complete:not(:last-child)::after {
    background-color: var(--fbd-primary);
}

/* session-expiry timer pill */
.fbd-steps__timer {
    display: flex;
    justify-content: center;
    margin-top: 12px;
}

.fbd-steps__timer>div {
    background: var(--fbd-primary-light);
    border: 1px solid var(--fbd-primary-mid);
    color: var(--fbd-blue-dark);
    padding: 6px 14px;
    border-radius: 999px;
}


/* ─────────────────────────────────────────────────────────────────────────────
   Flight modal body (Fare Rules raw modals + Seat Selection CommonPopups)
   Renamed off the shared .hw-modal-body so the shared
   ".hw-modal-dialog-scrollable .hw-modal-body { overflow-y:auto }" no longer
   stacks with the seat map's own scroll (was causing two scrollbars).
   Here the modal body is the SINGLE scroll container.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-modal-body {
    padding: 1.2rem 1.6rem 1.6rem 1.6rem;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--fbd-text-subtle) transparent;
}

/* Seat Selection: keep the seat map's own framed internal scroll (the good
   design) and stop the modal body from scrolling too — so only ONE scrollbar
   (the seat map) shows instead of two. Fare Rules keep .fbd-modal-body's scroll. */
.fbd-modal-body.fbd-modal-body--seat {
    overflow: visible;
}


/* ─────────────────────────────────────────────────────────────────────────────
   Confirm Hold Booking modal (BookingDetailsSideBarComponent, via CommonPopup)
   ───────────────────────────────────────────────────────────────────────────── */
/* Confirm Hold Booking popup — compact width (overrides shared 90% dialog width).
   Compound selector beats ".hw-modal-dialog { max-width: var(--bs-modal-width) }". */
.hw-modal-dialog.fbd-hold-dialog {
    max-width: 680px;
}

.fbd-hold-modal {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* non-refundable fee warning callout */
.fbd-hold-note {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: var(--fbd-radius-md);
}

.fbd-hold-note__icon {
    color: #dc2626;
    flex-shrink: 0;
    display: inline-flex;
    margin-top: 1px;
}

.fbd-hold-note__text {
    font-size: 14px;
    line-height: 1.6;
    color: #7f1d1d;
}

.fbd-hold-note__text strong {
    color: #b91c1c;
    font-weight: 700;
}

.fbd-hold-confirm {
    margin: 0;
    color: var(--fbd-text-strong);
}

.fbd-hold-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid var(--fbd-border);
}

.fbd-hold-actions .hw-btn {
    min-width: 120px;
}


/* ─────────────────────────────────────────────────────────────────────────────
   Traveller Details summary table (Tab 2 / Tab 3, read-only)
   Scoped under .fbd-pax-table-wrap so the shared .hw-table--default used on
   other pages is untouched. Selectors are prefixed to beat the shared rules.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-pax-table-wrap {
    margin-top: 0;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    display: block !important;
    box-sizing: border-box !important;
}

.fbd-pax-table-wrap .fbd-pax-table {
    width: 100%;
    min-width: 540px;
    border: 1px solid var(--fbd-border);
    border-collapse: separate;
    border-spacing: 0;
    border-radius: var(--fbd-radius-md);
    overflow: hidden;
}

.fbd-pax-table-wrap .fbd-pax-table thead th {
    background: var(--fbd-surface-alt);
    color: var(--fbd-text-strong);
    font-size: 14.5px;
    font-weight: 700;
    text-align: left;
    padding: 12px 16px;
    border-bottom: 1px solid var(--fbd-border);
    white-space: nowrap;
}

.fbd-pax-table-wrap .fbd-pax-table tbody td {
    padding: 12px 16px;
    color: var(--fbd-text-body);
    border-bottom: 1px solid var(--fbd-border);
    vertical-align: top;
}

.fbd-pax-table-wrap .fbd-pax-table tbody tr:last-child td {
    border-bottom: none;
}

.fbd-pax-table-wrap .fbd-pax-table tbody tr:nth-child(even) td {
    background: var(--fbd-surface-alt);
}


/* ─────────────────────────────────────────────────────────────────────────────
   Review Booking blue banner (flight booking page, tabs 1-2)
/* ─────────────────────────────────────────────────────────────────────────────
   Hero Banner & Stepper (hw-exchk--hero, hw-hotel--hero, hw-flight--hero, hw-cfhero)
   Exact match with Excursion and Hotel checkout hero components.
   ───────────────────────────────────────────────────────────────────────────── */
.hw-exchk--heroInner {
    max-width: 144rem;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1.5rem;
}
@media (min-width: 600px) { .hw-exchk--heroInner { padding-left: 3rem; padding-right: 3rem; } }
@media (min-width: 1200px) { .hw-exchk--heroInner { padding-left: 5rem; padding-right: 5rem; } }
@media (min-width: 1300px) { .hw-exchk--heroInner { padding-left: 6rem; padding-right: 6rem; } }
@media (min-width: 1400px) { .hw-exchk--heroInner { padding-left: 10rem; padding-right: 10rem; } }

.hw-exchk--hero {
    background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);
    border-radius: 0;
    padding: 18px 0 60px;
    margin: 0;
    color: #fff;
    box-shadow: 0 10px 26px -18px rgba(40,61,107,.5);
    min-height: 147px;
}

.hw-hotel--hero,
.hw-flight--hero {
    padding: 16px 0 60px;
}

.hw-exchk--hero .hw-exchk--back {
    color: rgba(255, 255, 255, 0.85);
}
.hw-exchk--hero .hw-exchk--back:hover {
    color: #fff;
}

.hw-exchk--back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    color: #556;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 600;
    cursor: pointer;
    padding: 6px 8px 6px 0;
    transition: color 0.15s ease;
}
.hw-exchk--back:hover {
    color: #3264FF;
}

.hw-exchk--heroBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 4px;
}
.hw-hotel--hero .hw-exchk--heroBar,
.hw-flight--hero .hw-exchk--heroBar {
    gap: 16px 24px;
}

.hw-exchk--heroTitle {
    margin: 0;
    color: #fff;
    font-weight: 700;
    font-size: clamp(20px, 2.4vw, 27px);
}

.hw-hotel--heroTimer {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    min-width: 250px;
}
.hw-hotel--heroTimer svg {
    color: #fff;
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
}

/* Stepper styles */
.hw-exchk--steps {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
}
.hw-exchk--step {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #98a2b6;
    font-weight: 600;
    font-size: 14px;
}
.hw-exchk--step:not(:last-child)::after {
    content: "";
    width: 30px;
    height: 2px;
    background: #e2e6ee;
    margin: 0 6px;
    border-radius: 2px;
}
.hw-exchk--step.is-done:not(:last-child)::after {
    background: #b8d8c3;
}
.hw-exchk--stepNum {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #eef1f7;
    color: #98a2b6;
    font-size: 13px;
    font-weight: 700;
}
.hw-exchk--step.is-active {
    color: #1b2439;
}
.hw-exchk--step.is-active .hw-exchk--stepNum {
    background: #3264FF;
    color: #fff;
}
.hw-exchk--step.is-done {
    color: #283D6B;
    cursor: pointer;
}
.hw-exchk--step.is-done .hw-exchk--stepNum {
    background: #137333;
    color: #fff;
}

.hw-exchk--hero .hw-exchk--step {
    color: rgba(255, 255, 255, 0.6);
}
.hw-exchk--hero .hw-exchk--step:not(:last-child)::after {
    background: rgba(255, 255, 255, 0.28);
}
.hw-exchk--hero .hw-exchk--step.is-done:not(:last-child)::after {
    background: rgba(255, 255, 255, 0.55);
}
.hw-exchk--hero .hw-exchk--stepNum {
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    border: 1.5px solid rgba(255, 255, 255, 0.5);
}
.hw-exchk--hero .hw-exchk--step.is-active {
    color: #fff;
}
.hw-exchk--hero .hw-exchk--step.is-active .hw-exchk--stepNum {
    background: #fff;
    color: #283D6B;
    border-color: #fff;
}
.hw-exchk--hero .hw-exchk--step.is-done {
    color: #fff;
}
.hw-exchk--hero .hw-exchk--step.is-done .hw-exchk--stepNum {
    background: #4ade80;
    color: #0f3d22;
    border-color: #4ade80;
}

/* Overlap booking content onto hero banner — exact match with hw-hotel--hotelDetails */
/* Overlap booking content onto hero banner — exact match with hw-hotel--hotelDetails */
.hw-flight--flightDetails {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: clip !important;
    overflow-y: visible !important;
    box-sizing: border-box !important;
}

.hw-flight--flightDetails .hw-page--width {
    max-width: 144rem !important;
    width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding: 0 1.5rem !important;
    box-sizing: border-box !important;
}

@media (min-width: 600px) {
    .hw-flight--flightDetails .hw-page--width {
        padding-left: 3rem !important;
        padding-right: 3rem !important;
    }
}
@media (min-width: 1200px) {
    .hw-flight--flightDetails .hw-page--width {
        padding-left: 5rem !important;
        padding-right: 5rem !important;
    }
}
@media (min-width: 1300px) {
    .hw-flight--flightDetails .hw-page--width {
        padding-left: 6rem !important;
        padding-right: 6rem !important;
    }
}
@media (min-width: 1400px) {
    .hw-flight--flightDetails .hw-page--width {
        padding-left: 10rem !important;
        padding-right: 10rem !important;
    }
}

.hw-flight--flightDetails .hw-page--width > .hw-passenger--wrapper,
.hw-page--width > .hw-passenger--wrapper.fbd-overlap-wrap,
.hw-passenger--wrapper.fbd-overlap-wrap,
.fbd-overlap-wrap {
    padding-top: 0 !important;
    margin-top: -34px !important;
    position: relative !important;
    z-index: 20 !important;
    overflow: visible !important;
}

.hw-flight--flightDetails .hw-passenger--list,
.fbd-overlap-wrap .hw-passenger--list {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
    row-gap: 0;
}

.hw-flight--flightDetails .hw-passenger--wrapper,
.hw-flight--flightDetails .hw-passenger--listShow,
.fbd-overlap-wrap,
.fbd-overlap-wrap .hw-passenger--listShow {
    overflow: visible !important;
}

@media (min-width: 1025px) {
    .hw-flight--flightDetails .hw-passenger--list,
    .fbd-overlap-wrap .hw-passenger--list {
        display: block !important;
        height: auto !important;
        overflow: visible !important;
    }

    .hw-flight--flightDetails .hw-passenger--wrapper,
    .fbd-overlap-wrap.hw-passenger--wrapper {
        align-items: start !important;
    }

    .hw-flight--flightDetails .hw-passenger--fareSummary,
    .hw-flight--flightDetails .fbd-sidebar,
    .fbd-overlap-wrap .hw-passenger--fareSummary,
    .fbd-overlap-wrap .fbd-sidebar,
    aside.hw-passenger--fareSummary.fbd-sidebar {
        position: -webkit-sticky !important;
        position: sticky !important;
        top: 24px !important;
        align-self: start !important;
        z-index: 10;
    }
}

/* Confirmation Hero (hw-cfhero) */
.hw-flight--flightDetails .hw-cfhero,
.hw-flight--stepsWrapper .hw-cfhero,
.hw-flight--hero.hw-cfhero,
.hw-cfhero {
    width: 100%;
    color: #fff;
    padding: 16px 0 60px !important;
    min-height: 147px !important;
    box-shadow: 0 10px 26px -18px rgba(40, 61, 107, 0.5);
    background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);
}
.hw-cfhero.is-confirm,
.hw-cfhero.is-cancel-hotel,
.hw-cfhero.is-confirm-hotel,
.hw-cfhero.is-pending {
    padding: 16px 0 60px !important;
    min-height: 147px !important;
    background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);
}

.hw-cfhero .hw-exchk--back,
.hw-cfhero--back {
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 1.5;
}
.hw-cfhero .hw-exchk--back:hover,
.hw-cfhero--back:hover {
    color: #fff;
}

.hw-cfhero--bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 4px;
}
.hw-cfhero--left {
    display: flex;
    align-items: center;
    gap: 16px;
}
.hw-cfhero--badge {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.16);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: none;
    color: #fff;
}
.hw-cfhero--badge svg {
    width: 24px;
    height: 24px;
}
.hw-cfhero--title {
    margin: 0;
    color: #fff;
    font-weight: 700;
    font-size: clamp(20px, 2.4vw, 27px);
}
.hw-cfhero--sub {
    margin: 3px 0 0;
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    max-width: 640px;
    line-height: 1.45;
}
.hw-cfhero--id {
    text-align: right;
}
.hw-cfhero--idLabel {
    display: flex;
    color: rgba(255, 255, 255, 0.7);
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: .05em;
}
.hw-cfhero--idVal {
    display: block;
    color: #fff;
    font-weight: 800;
    font-size: 16px;
    margin-top: 2px;
}

.hw-cfhero--id .fbd-hold-expiry {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #fee2e2;
    color: #b42318 !important;
    padding: 4px 12px;
    border-radius: 999px;
    font-weight: 600;
}

@media (max-width: 767px) {
    .hw-exchk--heroBar {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        margin-top: 10px;
    }
    .hw-exchk--steps {
        gap: 4px;
        flex-wrap: nowrap;
    }
    .hw-exchk--step {
        font-size: 13px;
    }
    .hw-exchk--step:not(:last-child)::after {
        width: 20px;
        margin: 0 4px;
    }
    .hw-exchk--stepNum {
        width: 24px;
        height: 24px;
        font-size: 12px;
        flex: none;
    }
    .hw-cfhero--bar {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        margin-top: 10px;
    }
}

@media (max-width: 600px) {
    .hw-cfhero--id {
        text-align: left;
    }
}

/* Responsive adjustments for flight cards & widgets on mobile (matching hotel checkout) */
@media (max-width: 1024px) {
    .hw-passenger--pageList {
        display: block !important;
    }

    .hw-flight--flightDetails .hw-passenger--wrapper,
    .hw-flight--flightDetails .hw-page--width > .hw-passenger--wrapper,
    .hw-passenger--wrapper.fbd-overlap-wrap {
        display: flex !important;
        flex-direction: column !important;
        grid-template-columns: 100% !important;
        gap: 16px !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
    }

    .hw-flight--flightDetails .hw-passenger--list,
    .hw-flight--flightDetails .hw-passenger--list.hw-3rd-active-booking-details,
    .hw-flight--flightDetails .hw-passenger--listShow,
    .hw-flight--flightDetails .hw-passenger--listShow.fbd-page,
    .hw-flight--flightDetails .hw-passenger--fareSummary.fbd-sidebar,
    .hw-flight--flightDetails .fbd-sidebar {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
    }
}

@media (max-width: 767px) {
    .hw-flight--flightDetails .fbd-card,
    .hw-flight--flightDetails .fbd-guestCard,
    .hw-flight--flightDetails .fbd-flightGroup,
    .hw-flight--flightDetails .hw-passenger--listShow__widget,
    .hw-flight--flightDetails .hw-passenger--fareShow__widget,
    .hw-flight--flightDetails .hw-after--bookingWidget,
    .hw-flight--flightDetails .hw-passenger--fareSummary.fbd-sidebar {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
    }

    .fbd-guestCard {
        padding: 16px 14px !important;
        border-radius: 8px !important;
    }

    .hw-passenger--listShow__widget.fbd-card,
    .hw-passenger--fareShow__widget.fbd-card,
    .fbd-card {
        padding: 16px 14px !important;
        /* border-radius: 8px !important; */
    }

    .fbd-section__header {
        margin-bottom: 14px;
        padding-bottom: 12px;
        gap: 10px;
    }

    .fbd-section__icon {
        width: 32px;
        height: 32px;
    }

    .fbd-section__icon svg {
        width: 16px;
        height: 16px;
    }

    .fbd-section__title {
        font-size: var(--fbd-title-size);
    }

    .fbd-info-list {
        padding-left: 18px;
        margin-bottom: 0;
    }

    .fbd-info-list li {
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 8px;
    }

    .hw-after--bookingWidget {
        padding: 16px 14px !important;
        border-radius: 8px !important;
    }

    .hw-after--bookingWidget .h4,
    .fbd-sidebar .hw-after--bookingWidget.tickets .h4 {
        font-size: 16px;
    }

    .fbd-pax-table-wrap .fbd-pax-table {
        min-width: 480px !important;
    }

    .fbd-pax-table-wrap .fbd-pax-table thead th,
    .fbd-pax-table-wrap .fbd-pax-table tbody td {
        padding: 8px 10px !important;
        font-size: 12.5px !important;
        white-space: nowrap !important;
    }

    .fbd-flightGroup__head {
        padding: 12px 14px !important;
        gap: 10px !important;
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 100% !important;
    }

    .fbd-flightGroup__rows {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }

    .fbd-flightSummaryRow {
        flex-wrap: wrap !important;
        gap: 8px 12px !important;
        width: 100% !important;
        max-width: 100% !important;
    }

    .fbd-flightSummary__airline {
        flex: 0 0 auto !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }

    .fbd-flightSummary__route {
        flex: 0 0 auto !important;
        font-size: 1.4rem !important;
    }

    .fbd-flightSummary__meta {
        flex-basis: 100% !important;
        width: 100% !important;
        font-size: 1.2rem !important;
        color: var(--fbd-text-muted) !important;
        flex-wrap: wrap !important;
        gap: 4px 6px !important;
    }

    .fbd-flightSummary__chev {
        flex: 0 0 auto !important;
        margin-left: auto !important;
    }

    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead,
    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbodyTR,
    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead > span,
    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbodyTR > span {
        font-size: 13.5px !important;
    }

    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead,
    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbodyTR {
        gap: 8px !important;
    }

    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tfoot {
        padding-top: 10px !important;
        margin-top: 0 !important;
    }

    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tfoot span {
        font-size: 16px !important;
    }
}

@media (max-width: 600px) {
    .hw-flight--flightDetails .hw-page--width > .hw-passenger--wrapper,
    .hw-page--width > .hw-passenger--wrapper.fbd-overlap-wrap,
    .hw-passenger--wrapper.fbd-overlap-wrap,
    .fbd-overlap-wrap {
        margin-top: -24px !important;
    }
}

@media (max-width: 575px) {
    .fbd-ticket-row {
        flex-direction: column !important;
        gap: 8px !important;
        width: 100% !important;
    }

    .fbd-ticket-row > .hw-btn {
        width: 100% !important;
        flex: 1 1 auto !important;
    }

    .fbd-markup-row {
        flex-direction: column !important;
        gap: 8px !important;
        width: 100% !important;
    }

    .fbd-markup-row > .hw-form--input,
    .fbd-markup-row > .hw-btn {
        width: 100% !important;
        flex: 1 1 auto !important;
    }

    .hw-after--bookingWidget.tickets {
        padding: 14px 12px !important;
    }
}

@media (max-width: 480px) {
    .hw-flight--flightDetails .hw-page--width {
        padding-left: 12px !important;
        padding-right: 12px !important;
    }

    .hw-passenger--fareSummary__box {
        padding: 14px 12px !important;
    }

    .fbd-pax-table-wrap .fbd-pax-table {
        min-width: 420px !important;
    }

    .fbd-pax-table-wrap .fbd-pax-table thead th,
    .fbd-pax-table-wrap .fbd-pax-table tbody td {
        padding: 8px 8px !important;
        font-size: 12px !important;
    }

    .fbd-fb-body {
        padding: 14px 12px 10px !important;
    }

    .fbd-fb-iata__code {
        font-size: 19px !important;
    }

    .fbd-fb-connector {
        padding: 0 6px !important;
    }

    .fbd-fb-connector__plane svg {
        width: 18px !important;
        height: 18px !important;
    }

    .fbd-fb-connector__airline {
        flex-wrap: wrap !important;
        gap: 8px !important;
        margin-bottom: 12px !important;
    }

    .fbd-fb-connector__flight-no {
        text-align: left !important;
        font-size: 12px !important;
    }
}

/* left column just holds the payment card; align it to the top of the row */
.hw-passenger--list.fbd-payment-left {
    align-self: start;
}

.fbd-sidebar.fbd-pay-panel {
    position: static;
    top: auto;
    width: 100%;
    align-self: start;
    background: #ffffff;
    border: 1px solid var(--fbd-border, #e2e8f0);
    border-radius: var(--fbd-radius-lg, 6px);
    box-shadow: var(--fbd-shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
    overflow: hidden;
}

.fbd-sidebar.fbd-pay-panel .fbd-pay-panel__box {
    padding: 24px;
}

/* Payment Methods Selector & Cards (matches hotel / excursion .hw-exchk--pay-wrap) */
.hw-exchk--pay-wrap,
.fbd-pay-methods {
    margin-bottom: 12px;
}

.hw-exchk--panelTitle,
.fbd-select-pay-methods__title,
.fbd-pay-methods__title {
    color: #1b2439;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.fbd-section__optional {
    font-size: 13px;
    font-weight: 400;
    color: #98a2b6;
}

.hw-exchk--payGrid,
.fbd-pay-methods__grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.hw-exchk--method,
.fbd-pay-card {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1 1 240px;
    min-width: 0;
    text-align: left;
    background: #fff;
    border: 1.5px solid #e2e6ee;
    border-radius: 12px;
    padding: 16px;
    cursor: pointer;
    transition: border-color .15s, box-shadow .15s, background .15s;
    user-select: none;
    box-sizing: border-box;
}

.hw-exchk--method:hover,
.fbd-pay-card:hover {
    border-color: #c3ccdb;
}

.hw-exchk--method.is-selected,
.fbd-pay-card.fbd-pay-card--active,
.fbd-pay-card--active {
    border-color: #3264FF;
    background: #f5f8ff;
}

.hw-exchk--methodRadio,
.fbd-pay-card__radio {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #c3ccdb;
    flex: none;
    position: relative;
    background: transparent;
    transition: border-color .15s;
}

.hw-exchk--method.is-selected .hw-exchk--methodRadio,
.fbd-pay-card--active .fbd-pay-card__radio {
    border-color: #3264FF;
}

.hw-exchk--method.is-selected .hw-exchk--methodRadio::after,
.fbd-pay-card--active .fbd-pay-card__radio::after {
    content: "";
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: #3264FF;
}

.hw-exchk--methodIco,
.fbd-pay-card__icon {
    color: #283D6B;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.hw-exchk--methodIco svg,
.fbd-pay-card__icon svg {
    width: 22px;
    height: 22px;
}

.hw-exchk--methodBody,
.fbd-pay-card__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.hw-exchk--methodName,
.fbd-pay-card__title {
    color: #1b2439;
    line-height: 1.3;
}

.hw-exchk--methodDesc,
.fbd-pay-card__sub {
    color: #6b7280;
    font-size: 12.5px;
    margin-top: 2px;
    line-height: 1.3;
}

.fbd-divider {
    height: 1px;
    background: var(--fbd-border, #e2e8f0);
    margin: 20px 0;
}

.fbd-booking-ref {
    /* spacing to the next block is owned by the sibling rule below, so the gap
       matches the hotel's 16px exactly instead of collapsing against it */
    margin-bottom: 0;
}

/* gap between Booking Reference and the Terms & Conditions block — mirrors the
   hotel's \`.hw-hotel--guestCard .hw-term--condition { margin-top: 16px }\` */
.fbd-booking-ref + .hw-term--condition {
    margin-top: 16px;
}

.fbd-booking-ref .hw-form--input {
    width: 100%;
    /* gap comes from the label's 6px margin-bottom, as in the hotel/excursion field */
    margin-top: 0;
}

/* more breathing room between the Terms & Conditions checkbox and its text
   (shared .hw-term--conditionInput only has .4rem) */
.fbd-pay-panel .hw-term--conditionInput {
    column-gap: 10px;
    align-items: flex-start;
}

/* keep the checkbox a fixed square — when the label wraps to 2 lines on small
   screens the flex row stretched it into a tall rounded rectangle. */
.fbd-pay-panel .hw-term--conditionInput input[type="checkbox"] {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    align-self: flex-start;
    margin-top: 0.2rem;
}

.fbd-pay-panel .fbd-pay-panel__box>.hw-select--payment {
    margin-top: 0;
    padding-top: 0;
    border-top: 0;
}

.fbd-pay-actions {
    display: flex;
    gap: 12px;
    margin-top: 16px;
}

/* booking error sits under the Pay Now button, left aligned */
.fbd-pay-error {
    margin-top: 10px;
    text-align: left;
}

/* the hold block's wrapper is a shared .hw-term--condition flex column with
   row-gap: 2rem, which would stack on top of the error's own margin — drop the
   gap there so the error sits 10px below the buttons, as on the payment panel */
.hw-term--condition.fbd-hold-actions {
    row-gap: 0;
}

/* tighter space above the hold buttons than the default 16px */
.fbd-hold-actions .fbd-pay-actions {
    margin-top: 10px;
}

.fbd-pay-error .hw-input--error-search {
    position: static;
    display: inline-block;
    max-width: 100%;
}

.fbd-pay-actions>.hw-btn {
    flex: 1 1 0;
    width: auto;
    margin: 0;
}

@media (max-width: 520px) {
    .fbd-pay-actions {
        flex-direction: column;
    }
}

.hw-after--bookingWidget .fbd-pay-methods__grid {
    grid-template-columns: 1fr;
}

.hw-after--bookingWidget .fbd-pay-actions {
    flex-direction: column;
}

/* Download Tickets section: "with Fare | without Fare" share one row, and the
   markup input + "with Markup" button share one row. */
.fbd-ticket-row {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    align-items: center;
}

.fbd-ticket-row > .hw-btn {
    flex: 1 1 0;
    min-width: 0;
    width: auto;
    margin: 0;
    white-space: nowrap;
}

.fbd-markup-row {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    align-items: center;
}

.fbd-markup-row > .hw-form--input {
    flex: 1 1 auto;
    min-width: 0;
    margin-top: 0;
}

.fbd-markup-row > .hw-btn {
    flex: 0 0 auto;
    width: auto;
    white-space: nowrap;
}

@media (max-width: 575px) {
    .fbd-ticket-row {
        flex-direction: column !important;
        gap: 8px !important;
        width: 100% !important;
    }
    .fbd-ticket-row > .hw-btn {
        width: 100% !important;
        flex: 1 1 auto !important;
    }
    .fbd-markup-row {
        flex-direction: column !important;
        gap: 8px !important;
        width: 100% !important;
    }
    .fbd-markup-row > .hw-form--input,
    .fbd-markup-row > .hw-btn {
        width: 100% !important;
        flex: 1 1 auto !important;
    }
}

.fbd-confirm-banner .hw-bookId .fbd-hold-expiry {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #fee2e2;
    color: #b42318 !important;
    padding: 4px 12px;
    border-radius: 999px;
    font-weight: 600;
    margin-top: 6px !important;
}

.fbd-stripe-dialog {
    max-width: 460px;
    width: 100%;
}

.fbd-stripe.hw-modal-content {
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-lg);
    overflow: hidden;
    box-shadow: var(--fbd-shadow-lg, 0 20px 48px rgba(16, 24, 40, 0.18));
}

.fbd-stripe .hw-modal-header {
    background: var(--fbd-surface-alt);
    border-bottom: 1px solid var(--fbd-border);
    padding: 18px 22px;
}

.fbd-stripe .hw-modal-headerTitle {
    color: var(--fbd-text-strong);
}

.fbd-stripe .hw-modal-body {
    padding: 22px;
}

.fbd-stripe .hw-label {
    font-size: 13px;
    color: var(--fbd-text-muted);
    margin-bottom: 6px;
}

/* card fields */
.fbd-stripe .hw-stripe-input {
    border: 1.5px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    padding: 13px 14px;
    background: var(--fbd-surface);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.fbd-stripe .hw-stripe-input:focus-within {
    border-color: var(--fbd-primary);
    box-shadow: 0 0 0 3px var(--fbd-primary-light);
}

.fbd-stripe .hw-stripe-input.is-error {
    border-color: #d92d20;
}

/* total summary box */
.fbd-stripe .hw-payment--summary {
    background: var(--fbd-surface-alt);
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    padding: 14px 16px;
}

/* actions stacked with a small gap */
.fbd-stripe .hw-payment--actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 2px;
}


/* ─────────────────────────────────────────────────────────────────────────────
   Selected-flights summary bar (ListFlightPage sticky bottom footer).
   Scoped under .hw-search--flightListBottomFooter — that wrapper is used ONLY by
   the flight list page (grep-verified), so nothing else on the site is affected.
   UI only: no markup or logic change. flight.css is imported by ListFlightPage
   for these rules to apply.
   ───────────────────────────────────────────────────────────────────────────── */
.hw-search--flightListBottomFooter {
    box-shadow: 0 -0.4rem 1.8rem rgba(15, 41, 77, 0.10);
}

.hw-search--flightListBottomFooter .hw-search--destinationRowMain {
    align-items: center;
    column-gap: 1.6rem;
}

/* flights strip fills the bar so a single (one-way) leg doesn't leave a
   detached center gap; the total + Book block stays pinned right */
.hw-search--flightListBottomFooter .col-scroll {
    flex: 1 1 auto;
    min-width: 0;
}

/* horizontal scroller that holds the per-leg chips */
.hw-search--flightListBottomFooter .row.hw-search--destinationRow {
    margin: 0;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 1rem;
    padding-block: 0.4rem;
}

/* ── each selected leg = a clean white chip on the light-blue bar ── */
.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col {
    flex: 0 0;
    align-items: center !important;
    gap: 1.2rem !important;
    padding: 0.7rem 1.3rem;
    background: var(--hw-white, #fff);
    border: 0.1rem solid rgba(15, 41, 77, 0.10);
    border-radius: 6px;
    box-shadow: 0 0.1rem 0.3rem rgba(15, 41, 77, 0.06);
}

/* airline logo tile */
.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col img {
    width: 3rem;
    height: 3rem;
    border-radius: 6px;
    object-fit: contain;
    background: var(--hw-brand-blue-light, #EBEFFF);
    padding: 0.3rem;
}

/* airline name */
.hw-search--flightListBottomFooter .hw-dtr--mtext {
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.2;
    max-width: 12rem;
}

/* flight code-number line (sits directly after the airline name) */
.hw-search--flightListBottomFooter .hw-dtr--mtext+.hw-dtr--dtext {
    font-size: 1.2rem;
    font-weight: 400;
    color: var(--hw-gray-650, #626262);
}

/* time / route group (dep -> arr) */
.hw-search--flightListBottomFooter .col-auto.d-flex {
    gap: 0.8rem !important;
    padding-inline: 0.4rem;
}

.hw-search--flightListBottomFooter .col-auto.d-flex>div {
    text-align: center;
    line-height: 1.35;
}

.hw-search--flightListBottomFooter .col-auto.d-flex svg {
    width: 1.6rem;
    height: 1.6rem;
    color: var(--hw-brand-orange, #3264FF);
    flex-shrink: 0;
}

.hw-search--flightListBottomFooter .col-auto.d-flex .hw-text12 {
    font-size: 1.1rem;
    font-weight: 400;
    color: var(--hw-gray-650, #626262);
}

/* leg price (last cell inside a chip) — separated by a soft dashed rule */
.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col>.d-flex.align-items-center:last-child {
    align-self: stretch;
    padding-left: 1.2rem;
    margin-left: 0.2rem;
    border-left: 0.1rem dashed rgba(15, 41, 77, 0.15);
}

.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col>.d-flex.align-items-center:last-child span {
    font-size: 1.5rem;
    font-weight: 700;
}

/* ── right block: grand total + Book / Select-another button ── */
.hw-search--flightListBottomFooter .col-fix-right {
    gap: 1.6rem !important;
    padding-left: 1.8rem;
    border-left: 0.1rem solid rgba(15, 41, 77, 0.12);
}

.hw-search--flightListBottomFooter .col-fix-right .hw-text18 {
    font-size: 2rem;
    font-weight: 800;
    line-height: 1.1;
}

.hw-search--flightListBottomFooter .col-fix-right .hw-btn {
    border-radius: 6px;
    font-weight: 700;
    box-shadow: 0 0.4rem 1rem rgba(50, 100, 255, 0.22);
}

/* ── responsive (phones): the whole bar no longer fits on one row, so the
   flights strip takes the top (still scrolls horizontally) and the grand total
   + Book drop to their own full-width row below. Scoped to this footer only. ── */
@media (max-width: 600px) {
    .hw-search--flightListBottomFooter .hw-search--destinationRowMain {
        flex-wrap: wrap;
        column-gap: 1rem;
        row-gap: 0.8rem;
    }

    .hw-search--flightListBottomFooter .col-scroll {
        flex: 1 1 100%;
        order: 1;
    }

    /* don't clip the chip — let its content show instead of being cut off */
    .hw-search--flightListBottomFooter .hw-search--destinationRowMain .col-scroll {
        overflow: visible;
    }

    /* chips stack full-width (no horizontal scroll) and wrap their own content,
       so the leg price is never clipped off the right edge */
    .hw-search--flightListBottomFooter .row.hw-search--destinationRow {
        flex-wrap: wrap;
        overflow-x: visible;
        gap: 0.8rem;
    }

    .hw-search--flightListBottomFooter .row.hw-search--destinationRow > .col {
        flex: 1 1 100%;
        flex-wrap: wrap;
        row-gap: 0.4rem;
    }

    /* leg price sits at the end of the chip line (wraps below if needed) */
    .hw-search--flightListBottomFooter .row.hw-search--destinationRow > .col > .d-flex.align-items-center:last-child {
        margin-left: auto;
    }

    .hw-search--flightListBottomFooter .col-fix-right {
        order: 2;
        flex: 1 1 100%;
        width: 100%;
        padding-left: 0;
        border-left: 0;
        justify-content: space-between;
        gap: 1rem !important;
    }

    .hw-search--flightListBottomFooter .col-fix-right .hw-text18 {
        font-size: 1.6rem;
    }

    .hw-search--flightListBottomFooter .col-fix-right .hw-btn {
        min-width: 11rem;
        padding: 0.9rem 1.4rem;
    }
}

/* ─────────────────────────────────────────────────────────────────────────────
   Flight listing top row: "View As" (left) + Cheapest/Fastest filter (right)
   on one row. Scoped to the fbd- hook so shared hw- classes aren't touched
   globally. Two-class selectors win over the global base rules on specificity.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-filterTopRow.hw-search--flightFilterResult__top {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

/* The global .hw-twoLine--iconFilter has width:100% which forced it onto its own
   row; override it so it shrinks and sits on the right. */
.fbd-filterTopRow .hw-twoLine--iconFilter {
    width: auto;
    flex: 0 0 auto;
    margin-left: auto;
}

/* Even out the tab padding (base is 0.1rem 1rem 0.6rem — almost no top). */
.fbd-filterTopRow .hw-twoLine--iconFilter .hw-flight--cTab {
    padding: 0.6rem 1.4rem;
}

/* Match the Cheapest/Fastest text style to .hw-btn.hw-btn--tabLink
   (font-size 1.4rem, weight 500 — overriding .hw-fontBold's bold !important).
   NOTE: do NOT set color here — the active/inactive color is handled by the
   base .hw-flight--cTab.active rules (white on the blue active tab). */
.fbd-filterTopRow .hw-twoLine--iconFilter .hw-flight--cTab span {
    font-size: 1.4rem;
    font-weight: 500 !important;
    line-height: 1.5;
}

@media (max-width: 640px) {
    .fbd-filterTopRow.hw-search--flightFilterResult__top {
        flex-wrap: wrap;
    }

    .fbd-filterTopRow .hw-twoLine--iconFilter {
        width: 100%;
        margin-left: 0;
    }
}

/* ─────────────────────────────────────────────────────────────────────────────
   Stepper bar (Trip.com style): one dark container. The selected onward shows
   as a light inset card; the current leg shows as white text on the dark bar.
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-stepBar {
    background: #0f1b33;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 10px;
}

.fbd-stepBar__onward {
    background: #ffffff;
    border-radius: 6px;
    padding: 10px 14px;
    margin-bottom: 10px;
}

.fbd-stepBar__current {
    color: #ffffff;
    padding: 2px 4px;
}

.fbd-stepBar__current .fbd-stepBar__date {
    opacity: 0.85;
}

.fbd-stepBar__change {
    background: none;
    border: none;
    cursor: pointer;
    font-weight: 600;
    color: #2f6fed;
}

/* ------------------------------------------------------------------ */
/* Sidebar filter sections moved from the top row: Flight Selection    */
/* (Single/Combo) and Sort By (Cheapest/Fastest), shown above Price.   */
/* Scoped to fbd- hooks so shared hw- classes are untouched.           */
/* ------------------------------------------------------------------ */
.fbd-sideFilter .hw-search--flightFilter__title {
    margin-bottom: 8px;
}

/* Single / Combo tabs sit side by side and share the row evenly */
/* Flight Selection (Single/Combo) and Sort By (Cheapest/Fastest) reuse the
   Stops pill look: hw-btn hw-btn--smallSize + hw-btn--secondaryOutline /
   hw-btn--primaryOutlineActive. Both pills share the row evenly. */
.fbd-sideFilter__tabs,
.fbd-sideFilter__sort {
    display: flex;
    gap: 8px;
    width: 100%;
}
.fbd-sideFilter__tabs .hw-btn,
.fbd-sideFilter__sort .hw-btn {
    flex: 1 1 0;
    text-align: center;
}

/* Sort By pills carry two lines (label + price | duration), so let the button
   grow vertically and stack its spans instead of the default single centered line. */
.fbd-sortBtn {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    gap: 2px;
    line-height: 1.3;
    white-space: normal;
}
.fbd-sortBtn .hw-no-price {
      color: var(--Blue, #3264FF);
  text-align: center;
  font-family: "DM Sans";
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
}

/* ------------------------------------------------------------------ */
/* Scroll-to-top button: a footer pinned to the bottom of the filter     */
/* card. No wrapper — the sidebar keeps its original sticky behaviour, so */
/* there is no extra sticky unit to mis-offset and cause a top gap.       */
/* ------------------------------------------------------------------ */
.fbd-scrollTopBtn {
    position: sticky;
    bottom: 0;
    display: block;
    width: 100%;
    margin-top: 1.2rem;
    padding: 1rem 1.4rem;
    border: 1px solid var(--hw-brand-orange);
    background-color: var(--hw-white);
    color: var(--hw-brand-orange);
    border-radius: 6px;
    font-size: 1.4rem;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
}
.fbd-scrollTopBtn:hover {
    background-color: var(--hw-brand-orange-light);
}
/* Hide it when the filter rail is collapsed (narrow) so it doesn't widen the rail. */
.filter-collapsed .fbd-scrollTopBtn {
    display: none;
}

/* Per-flight header inside Meals/Baggage & Seat sections (mixed booking) */
/* so the user knows which leg a selection applies to.                   */
/* ------------------------------------------------------------------ */
.fbd-legHeading {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin: 6px 0 14px;
    font-size: 1.3rem;
    font-weight: 600;
    color: var(--hw-black-900);
}
.fbd-legHeading__dir {
    background-color: var(--hw-brand-orange-light);
    color: var(--hw-brand-orange);
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 1.2rem;
    font-weight: 600;
}
.fbd-legHeading__route {
    color: var(--hw-black-900);
}
.fbd-legHeading__airline {
    color: var(--hw-gray-600);
    font-weight: 500;
}

/* ------------------------------------------------------------------ */
/* Collapsible flights: ONE box listing each leg's compact summary row,   */
/* with a single chevron that toggles the full details of all legs.       */
/* ------------------------------------------------------------------ */
.fbd-flightGroup__head {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding: 12px 16px;
    background: var(--hw-white);
    border: none;
    cursor: pointer;
    text-align: left;
    font: inherit;
}
.fbd-flightGroup__rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1 1 auto;
    min-width: 0;
}
.fbd-flightSummaryRow {
    display: flex;
    align-items: center;
    gap: 16px;
}
.fbd-flightGroup__body {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.3s ease;
}
.fbd-flightGroup__body.is-open {
    grid-template-rows: 1fr;
    border-top: 1px solid var(--hw-gray-400);
}
.fbd-flightGroup__bodyInner {
    overflow: hidden;
    min-height: 0;
}
.fbd-flightSummary__airline {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}
.fbd-flightSummary__airline img {
    border-radius: 6px;
    flex: 0 0 auto;
}
.fbd-flightSummary__airlineName {
    font-weight: 600;
    color: var(--hw-black-900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.fbd-flightSummary__route {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--hw-black-900);
    font-size: 1.5rem;
}
.fbd-flightSummary__route b { font-weight: 700; }
.fbd-flightSummary__arrow { color: var(--hw-brand-orange); display: inline-flex; }
.fbd-flightSummary__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--hw-black-900);
    font-size: 1.3rem;
    font-weight: 500;
}
.fbd-flightSummary__chev,
.hw-exchk--sectionChevron {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    color: #000000;
}
.fbd-flightSummary__chev.is-open,
.hw-exchk--sectionHead__toggle.is-open .hw-exchk--sectionChevron,
.hw-exchk--sectionHead.is-open .hw-exchk--sectionChevron {
    transform: rotate(180deg);
}



/* ------------------------------------------------------------------ */
/* Split (multi-vendor round trip) per-leg status strip. Shown only for  */
/* a mixed booking; makes a PARTLY_BOOKED trip read at a glance (which    */
/* leg confirmed, which failed). All fbd- classes; no hw- class touched. */
/* ------------------------------------------------------------------ */
.fbd-splitStatus {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px 16px;
    border-left: 4px solid var(--fbd-primary);
}
.fbd-splitStatus.is-ok { border-left-color: #16a34a; }
.fbd-splitStatus.is-partial { border-left-color: #dc2626; }
.fbd-splitStatus__head {
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--fbd-text-strong);
}
.fbd-splitStatus.is-partial .fbd-splitStatus__head { color: #b91c1c; }
.fbd-splitStatus__legs {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
.fbd-splitStatus__leg {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    flex: 1 1 260px;
    padding: 8px 12px;
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-sm);
    background: var(--fbd-surface-alt);
}
.fbd-splitStatus__leg.is-ok { background: #f0fdf4; border-color: #bbf7d0; }
.fbd-splitStatus__leg.is-failed { background: #fef2f2; border-color: #fecaca; }
.fbd-splitStatus__dir {
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--fbd-text-strong);
}
.fbd-splitStatus__badge {
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 1.1rem;
    font-weight: 600;
    text-transform: capitalize;
}
.fbd-splitStatus__badge.is-ok { background: #dcfce7; color: #15803d; }
.fbd-splitStatus__badge.is-failed { background: #fee2e2; color: #b91c1c; }
.fbd-splitStatus__pnr {
    font-size: 1.2rem;
    color: var(--fbd-text-body);
    font-weight: 500;
}
.fbd-splitStatus__reason {
    flex-basis: 100%;
    font-size: 1.15rem;
    color: #b91c1c;
}
.fbd-splitStatus__note {
    font-size: 1.2rem;
    color: var(--fbd-text-muted);
}
@media (max-width: 575px) {
    .fbd-splitStatus__leg { flex-basis: 100%; }
}

/* ─────────────────────────────────────────────────────────────────────────────
   Ticket download cards (2 cards in a single row + markup dropdown)
   ───────────────────────────────────────────────────────────────────────────── */
.fbd-ticket-widget {
    margin-bottom: 16px;
}

.fbd-ticket-options__grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px;
    width: 100%;
}

.fbd-ticket-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border: 1.5px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    background: var(--fbd-surface);
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    min-width: 0;
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    outline: none;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.fbd-ticket-btn:hover:not(:disabled) {
    border-color: var(--fbd-primary);
    background: var(--fbd-primary-light);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.10);
}

.fbd-ticket-btn:active:not(:disabled) {
    transform: translateY(0);
    background: #dbeafe;
}

.fbd-ticket-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.fbd-ticket-btn--loading {
    border-color: var(--fbd-primary-mid) !important;
    background: var(--fbd-primary-light) !important;
    cursor: wait !important;
    justify-content: center !important;
}

/* Icon badge */
.fbd-ticket-btn__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    border-radius: 6px;
    background: var(--fbd-primary-light);
    color: var(--fbd-primary);
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
}

.fbd-ticket-btn__icon svg {
    width: 18px;
    height: 18px;
}

.fbd-ticket-btn__icon .hw-main--loaderCommon,
.fbd-ticket-btn__spinner {
    width: 18px !important;
    height: 18px !important;
    min-width: 18px !important;
    min-height: 18px !important;
    max-width: 18px !important;
    max-height: 18px !important;
    border-width: 2.5px !important;
    border-style: solid !important;
    border-color: #dbeafe !important;
    border-top-color: var(--fbd-primary) !important;
    display: inline-block !important;
    position: static !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
    box-sizing: border-box !important;
}

/* Text */
.fbd-ticket-btn__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
    line-height: 1.25;
    overflow: hidden;
}

.fbd-ticket-btn__title {
    font-size: 13.5px;
    font-weight: 700;
    color: var(--fbd-text-strong);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fbd-ticket-btn:hover:not(:disabled) .fbd-ticket-btn__title {
    color: var(--fbd-primary);
}

.fbd-ticket-btn__sub {
    font-size: 11.5px;
    color: var(--fbd-text-muted);
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Add Markup toggle & panel */
.fbd-ticket-markup-dropdown {
    margin-top: 14px;
    padding-top: 10px;
    border-top: 1px dashed var(--fbd-border);
}

.fbd-ticket-markup-toggle {
    padding: 4px 0;
    font-size: 13.5px;
    color: var(--fbd-text-strong);
    user-select: none;
    transition: color 0.15s ease;
}

.fbd-ticket-markup-toggle:hover {
    color: var(--fbd-primary);
}

.fbd-ticket-markup-panel {
    background: var(--fbd-surface-alt);
    border: 1px solid var(--fbd-border);
    border-radius: var(--fbd-radius-md);
    padding: 14px;
    animation: fbdTicketFadeIn 0.2s ease-out;
}

.fbd-ticket-markup-panel .markup-price {
    height: 42px !important;
    font-size: 14px !important;
    border: 1.5px solid var(--fbd-border) !important;
    border-radius: var(--fbd-radius-sm) !important;
    background: #fff !important;
}

.fbd-ticket-markup-panel .markup-price:focus {
    border-color: var(--fbd-primary) !important;
    box-shadow: 0 0 0 2px var(--fbd-primary-light) !important;
}

@keyframes fbdTicketFadeIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 540px) {
    .fbd-ticket-options__grid {
        grid-template-columns: 1fr !important;
    }
}

/* ============================================================
   Booking Processing Overlay (.hw-bkovl)
   ============================================================ */
.hw-bkovl { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(20,28,48,.55); -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px); }
.hw-bkovl--card { width: 100%; max-width: 380px; background: #fff; border-radius: 18px; padding: 30px 26px 22px; box-shadow: 0 26px 64px -22px rgba(16,24,40,.45); text-align: center; animation: hwBkPop .28s ease; }
@keyframes hwBkPop { from { opacity: 0; transform: translateY(10px) scale(.97); } to { opacity: 1; transform: none; } }
.hw-bkovl--ring { position: relative; width: 74px; height: 74px; margin: 0 auto 16px; }
.hw-bkovl--spinner { width: 74px; height: 74px; animation: hwBkRotate 1.3s linear infinite; }
.hw-bkovl--track { fill: none; stroke: #eaf0ff; stroke-width: 4; }
.hw-bkovl--path { fill: none; stroke: #3264FF; stroke-width: 4; stroke-linecap: round; stroke-dasharray: 85 160; }
.hw-bkovl--lock { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #283D6B; }
@keyframes hwBkRotate { to { transform: rotate(360deg); } }
.hw-bkovl--title { color: #1b2439; }
.hw-bkovl--sub { margin-top: 4px; color: #6b7280; font-size: 13px; }
.hw-bkovl--steps { list-style: none; margin: 18px 0 0; padding: 0; display: grid; gap: 11px; text-align: left; }
.hw-bkovl--step { display: flex; align-items: center; gap: 11px; color: #98a2b6; font-size: 14px; font-weight: 600; transition: color .3s; }
.hw-bkovl--step.is-active { color: #1b2439; }
.hw-bkovl--step.is-done { color: #137333; }
.hw-bkovl--dot { width: 21px; height: 21px; border-radius: 50%; border: 2px solid #dfe4ee; display: inline-flex; align-items: center; justify-content: center; flex: none; color: #fff; transition: all .3s; }
.hw-bkovl--dot svg { opacity: 0; transition: opacity .2s; }
.hw-bkovl--step.is-active .hw-bkovl--dot { border-color: #3264FF; box-shadow: 0 0 0 4px rgba(50,100,255,.12); animation: hwBkPulse 1.2s ease-in-out infinite; }
.hw-bkovl--step.is-done .hw-bkovl--dot { background: #137333; border-color: #137333; }
.hw-bkovl--step.is-done .hw-bkovl--dot svg { opacity: 1; }
@keyframes hwBkPulse { 0%,100% { box-shadow: 0 0 0 4px rgba(50,100,255,.12); } 50% { box-shadow: 0 0 0 7px rgba(50,100,255,.05); } }
.hw-bkovl--note { margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef1f7; color: #6b7280; font-size: 12.5px; }

`, "",{"version":3,"sources":["webpack://./src/pages/flights/BookingDetailsComponent/flight.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;;kFAEkF;AAClF;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,iDAAiD;IACjD,kDAAkD;IAClD,kDAAkD;IAClD,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,qEAAqE;IACrE,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,iEAAiE;AACjE;;;;;;;;;;;;;;;;;;IAkBI,4BAA4B;IAC5B,gCAAgC;IAChC,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA,qDAAqD;AACrD;;;;;;;;;;IAUI,4BAA4B;IAC5B,+BAA+B;IAC/B,mCAAmC;AACvC;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;kFAEkF;AAClF;IACI,aAAa;IACb,sBAAsB;IACtB;+EAC2E;IAC3E,MAAM;AACV;;AAEA,sFAAsF;AACtF;IACI,UAAU;AACd;;AAEA,0DAA0D;AAC1D;IACI,mBAAmB;AACvB;;AAEA;;sDAEsD;AACtD;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;;;;kFAIkF;AAClF;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,mCAAmC;IACnC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,wDAAwD;IACxD,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;iFAEiF;AACjF;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;kFAEkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;kFAGkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,6CAA6C;AAC7C;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,qFAAqF;AACrF;IACI,cAAc;AAClB;;AAEA,mFAAmF;AACnF;IACI,aAAa;AACjB;;AAEA;8EAC8E;AAC9E;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;;kFAGkF;AAClF;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,2EAA2E;IAC3E,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,0DAA0D;AAC9D;;AAEA;8EAC8E;AAC9E;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;;;;kFAKkF;AAClF,YAAY,eAAe,EAAE,QAAQ,EAAE,aAAa,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,8BAA8B,EAAE,kCAAkC,EAAE,0BAA0B,EAAE;AAClO,kBAAkB,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gDAAgD,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACrN,qBAAqB,OAAO,UAAU,EAAE,sCAAsC,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AACtH,kBAAkB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtF,qBAAqB,WAAW,EAAE,YAAY,EAAE,0CAA0C,EAAE;AAC5F,mBAAmB,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE;AACjE,kBAAkB,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE,qBAAqB,EAAE,wBAAwB,EAAE;AACjH,kBAAkB,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAC7H,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;AAC1D,mBAAmB,cAAc,EAAE;AACnC,iBAAiB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACnE,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC/G,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC3I,4BAA4B,cAAc,EAAE;AAC5C,0BAA0B,cAAc,EAAE;AAC1C,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC7M,qBAAqB,UAAU,EAAE,uBAAuB,EAAE;AAC1D,2CAA2C,qBAAqB,EAAE,0CAA0C,EAAE,8CAA8C,EAAE;AAC9J,yCAAyC,mBAAmB,EAAE,qBAAqB,EAAE;AACrF,6CAA6C,UAAU,EAAE;AACzD,uBAAuB,UAAU,0CAA0C,EAAE,EAAE,MAAM,0CAA0C,EAAE,EAAE;AACnI,kBAAkB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEzH;;;kFAGkF;AAClF;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,mCAAmC;IACnC,wCAAwC;IACxC,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;;kFAEkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;;;kFAKkF;AAClF;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,UAAU;IACV,uEAAuE;IACvE,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;;kFAGkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;IAClC,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;kFAGkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,kCAAkC;IAClC,4BAA4B;IAC5B,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;;;;;kFAKkF;AAClF;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;gFACgF;AAChF;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA,yCAAyC;AACzC;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;;;kFAGkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;;;;kFAIkF;AAClF;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,mCAAmC;IACnC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX,wDAAwD;AAC5D;;AAEA;IACI,gCAAgC;IAChC,6CAA6C;AACjD;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;;;kFAGkF;AAClF;;;iFAGiF;AACjF;IACI,aAAa;IACb,+BAA+B;IAC/B,oBAAoB;IACpB,oCAAoC;IACpC,kBAAkB;IAClB;yEACqE;IACrE,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qEAAqE;AACrE;IACI,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA,wDAAwD;AACxD;IACI,qDAAqD;AACzD;;AAEA;IACI,6BAA6B;AACjC;;AAEA,+EAA+E;AAC/E;IACI,oBAAoB;AACxB;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,mBAAmB;IACnB,UAAU;AACd;;AAEA;;4CAE4C;AAC5C;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;;;gDAIgD;AAChD;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;8EAC8E;AAC9E;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,mCAAmC;IACnC,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;kFAEkF;AAClF;IACI,8EAA8E;IAC9E,gBAAgB;AACpB;;AAEA;;kFAEkF;AAClF;IACI,UAAU;AACd;;AAEA;yEACyE;AACzE;IACI,WAAW;IACX,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;;kEAEkE;AAClE;IACI,cAAc;IACd,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;AACtB;;AAEA,kFAAkF;AAClF;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;;;;kFAIkF;AAClF;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA;IACI,uDAAuD;IACvD,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;kFAGkF;AAClF;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;;AAEA;;;kFAGkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;;kFAEkF;AAClF;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;kFAEkF;AAClF;;IAEI;;QAEI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;8DAC0D;IAC1D;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA,6EAA6E;IAC7E;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;IACA,2BAA2B;AAC/B;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,gCAAgC;IACpC;AACJ;;AAEA;;kFAEkF;AAClF;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,6CAA6C;IAC7C,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA,sDAAsD;AACtD;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kDAAkD;AAClD;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,WAAW;IACX;;;;6BAIyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,WAAW;IACX;;;;6BAIyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA,uCAAuC;AACvC;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA,sCAAsC;AACtC;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,QAAQ;IACR,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;;AAGA;;;;kFAIkF;AAClF;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,wCAAwC;IACxC,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,mCAAmC;IACnC,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;4EAE4E;AAC5E;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA,gEAAgE;IAChE;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;;;;kFAIkF;AAClF;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;wEAEwE;AACxE;;sEAEsE;AACtE;IACI,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;;4CAE4C;AAC5C;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;sEACsE;AACtE;;IAEI,iCAAiC;AACrC;;AAEA;2CAC2C;AAC3C;IACI,uCAAuC;IACvC,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;4BAC4B;AAC5B;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;GAEG;;AAEH,iDAAiD;AACjD;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA,+BAA+B;AAC/B;IACI,mCAAmC;IACnC,0DAA0D;AAC9D;;;AAGA;;;;kFAIkF;AAClF,4CAA4C;AAC5C;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qGAAqG;AACzG;;AAEA,oCAAoC;AACpC;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;IACI,oCAAoC;IACpC,gCAAgC;IAChC,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;4FAC4F;AAC5F;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,mCAAmC;IACnC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;;;;;;kFAMkF;AAClF;IACI,oCAAoC;IACpC,gBAAgB;IAChB,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;;mFAEmF;AACnF;IACI,iBAAiB;AACrB;;;AAGA;;kFAEkF;AAClF;qFACqF;AACrF;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;;;;kFAIkF;AAClF;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,4CAA4C;IAC5C,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mCAAmC;IACnC,yBAAyB;IACzB,iBAAiB;IACjB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;;;;;kFAKkF;AAClF;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA,4BAA4B,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,EAAE;AAC9F,6BAA6B,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,EAAE;AAC/F,6BAA6B,uBAAuB,kBAAkB,EAAE,mBAAmB,EAAE,EAAE;AAC/F,6BAA6B,uBAAuB,mBAAmB,EAAE,oBAAoB,EAAE,EAAE;;AAEjG;IACI,0EAA0E;IAC1E,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,gDAAgD;IAChD,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,eAAe;AACnB;AACA;;IAEI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;IACrC,WAAW;IACX,4CAA4C;AAChD;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,uFAAuF;AACvF,uFAAuF;AACvF;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ;AACA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ;AACA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ;AACA;IACI;QACI,8BAA8B;QAC9B,+BAA+B;IACnC;AACJ;;AAEA;;;;IAII,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;IACzB,uBAAuB;IACvB,4BAA4B;IAC5B,UAAU;AACd;;AAEA;;;;IAII,4BAA4B;AAChC;;AAEA;IACI;;QAEI,yBAAyB;QACzB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;;;;QAKI,mCAAmC;QACnC,2BAA2B;QAC3B,oBAAoB;QACpB,4BAA4B;QAC5B,WAAW;IACf;AACJ;;AAEA,kCAAkC;AAClC;;;;IAII,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,4BAA4B;IAC5B,oDAAoD;IACpD,0EAA0E;AAC9E;AACA;;;;IAII,+BAA+B;IAC/B,4BAA4B;IAC5B,0EAA0E;AAC9E;;AAEA;;IAEI,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mCAAmC;AACvC;AACA;IACI,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,QAAQ;QACR,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,0FAA0F;AAC1F;IACI;QACI,yBAAyB;IAC7B;;IAEA;;;QAGI,wBAAwB;QACxB,iCAAiC;QACjC,sCAAsC;QACtC,oBAAoB;QACpB,sBAAsB;QACtB,0BAA0B;QAC1B,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;;;;;;QAMI,sBAAsB;QACtB,0BAA0B;QAC1B,uBAAuB;QACvB,iCAAiC;IACrC;AACJ;;AAEA;IACI;;;;;;;QAOI,sBAAsB;QACtB,0BAA0B;QAC1B,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;;IAEA;;;QAGI,6BAA6B;QAC7B,mCAAmC;IACvC;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;QAC5B,4BAA4B;QAC5B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,iCAAiC;QACjC,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;QACxB,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;QAC3B,sBAAsB;QACtB,4BAA4B;QAC5B,uCAAuC;QACvC,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;;;;QAII,4BAA4B;IAChC;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;QAC5B,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;;;;QAII,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,iCAAiC;QACjC,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;AACJ;;AAEA,4EAA4E;AAC5E;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,wCAAwC;IACxC,kEAAkE;IAClE,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,qFAAqF;AACrF;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,+DAA+D;IAC/D,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI;0EACsE;IACtE,gBAAgB;AACpB;;AAEA;4EAC4E;AAC5E;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kFAAkF;IAClF,aAAa;AACjB;;AAEA;qDACqD;AACrD;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;qEACqE;AACrE;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA,8DAA8D;AAC9D;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;gFAEgF;AAChF;IACI,UAAU;AACd;;AAEA,+DAA+D;AAC/D;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;uDACuD;AACvD;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,iCAAiC;QACjC,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,yBAAyB;IAC7B;IACA;QACI,iCAAiC;QACjC,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;;QAEI,sBAAsB;QACtB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,gBAAgB;IAChB,oEAAoE;AACxE;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,qCAAqC;IACrC,mCAAmC;IACnC,kBAAkB;IAClB,8BAA8B;IAC9B,0DAA0D;AAC9D;;AAEA;IACI,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;;AAGA;;;;;;kFAMkF;AAClF;IACI,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;mEACmE;AACnE;IACI,cAAc;IACd,YAAY;AAChB;;AAEA,qDAAqD;AACrD;IACI,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;IACT,qBAAqB;AACzB;;AAEA,uEAAuE;AACvE;IACI,SAAS;IACT,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,iCAAiC;IACjC,2CAA2C;IAC3C,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,oCAAoC;AACpC;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,0EAA0E;AAC1E;IACI,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,kEAAkE;AAClE;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;;kFAEkF;AAClF;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,QAAQ;IACZ;;IAEA,wEAAwE;IACxE;QACI,iBAAiB;IACrB;;IAEA;6DACyD;IACzD;QACI,eAAe;QACf,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;IACnB;;IAEA,uEAAuE;IACvE;QACI,iBAAiB;IACrB;;IAEA;QACI,QAAQ;QACR,cAAc;QACd,WAAW;QACX,eAAe;QACf,cAAc;QACd,8BAA8B;QAC9B,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;AACJ;;AAEA;;;;kFAIkF;AAClF;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;0DAC0D;AAC1D;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA,2EAA2E;AAC3E;IACI,sBAAsB;AAC1B;;AAEA;;;uEAGuE;AACvE;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;;;kFAGkF;AAClF;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,wEAAwE;AACxE,wEAAwE;AACxE,uEAAuE;AACvE;IACI,kBAAkB;AACtB;;AAEA,kEAAkE;AAClE;;mEAEmE;AACnE;;IAEI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;AACA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;qFACqF;AACrF;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;AACvB;AACA;MACM,2BAA2B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE,0EAA0E;AAC1E,2EAA2E;AAC3E,2EAA2E;AAC3E,uEAAuE;AACvE;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,wCAAwC;IACxC,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,8CAA8C;AAClD;AACA,qFAAqF;AACrF;IACI,aAAa;AACjB;;AAEA,2EAA2E;AAC3E,0EAA0E;AAC1E,uEAAuE;AACvE;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE,2EAA2E;AAC3E,2EAA2E;AAC3E,uEAAuE;AACvE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,wCAAwC;AAC5C;AACA;IACI,uBAAuB;IACvB,wCAAwC;AAC5C;AACA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,iBAAiB;AACrB;AACA,8BAA8B,gBAAgB,EAAE;AAChD,4BAA4B,6BAA6B,EAAE,oBAAoB,EAAE;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;AACA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;AAClB;AACA;;;IAGI,yBAAyB;AAC7B;;;;AAIA,uEAAuE;AACvE,0EAA0E;AAC1E,2EAA2E;AAC3E,0EAA0E;AAC1E,uEAAuE;AACvE;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,yCAAyC;AAC7C;AACA,yBAAyB,0BAA0B,EAAE;AACrD,8BAA8B,0BAA0B,EAAE;AAC1D;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA,qDAAqD,cAAc,EAAE;AACrE;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,mCAAmC;IACnC,mCAAmC;IACnC,kCAAkC;AACtC;AACA,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE;AAC1E,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE;AAC9E;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;AACA;IACI,wBAAwB,gBAAgB,EAAE;AAC9C;;AAEA;;kFAEkF;AAClF;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,2DAA2D;IAC3D,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,mCAAmC;IACnC,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,+CAA+C;IAC/C,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,gCAAgC;IAChC,+CAA+C;IAC/C,gCAAgC;IAChC,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA,SAAS;AACT;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;IACnC,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,gDAAgD;IAChD,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,yDAAyD;AAC7D;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;;iEAEiE;AACjE,YAAY,eAAe,EAAE,QAAQ,EAAE,aAAa,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,8BAA8B,EAAE,kCAAkC,EAAE,0BAA0B,EAAE;AAClO,kBAAkB,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,gDAAgD,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;AACrN,qBAAqB,OAAO,UAAU,EAAE,sCAAsC,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AACtH,kBAAkB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACtF,qBAAqB,WAAW,EAAE,YAAY,EAAE,0CAA0C,EAAE;AAC5F,mBAAmB,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE;AACjE,kBAAkB,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE,qBAAqB,EAAE,wBAAwB,EAAE;AACjH,kBAAkB,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AAC7H,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;AAC1D,mBAAmB,cAAc,EAAE;AACnC,iBAAiB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACnE,mBAAmB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC/G,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC3I,4BAA4B,cAAc,EAAE;AAC5C,0BAA0B,cAAc,EAAE;AAC1C,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC7M,qBAAqB,UAAU,EAAE,uBAAuB,EAAE;AAC1D,2CAA2C,qBAAqB,EAAE,0CAA0C,EAAE,8CAA8C,EAAE;AAC9J,yCAAyC,mBAAmB,EAAE,qBAAqB,EAAE;AACrF,6CAA6C,UAAU,EAAE;AACzD,uBAAuB,UAAU,0CAA0C,EAAE,EAAE,MAAM,0CAA0C,EAAE,EAAE;AACnI,kBAAkB,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE,cAAc,EAAE,iBAAiB,EAAE","sourcesContent":["/**\n * flight.css\n *\n * Scoped styles for FlightBookingDetailsComponent.\n * All selectors use the \"fbd-\" prefix to avoid collisions with\n * shared classes used by hotels, excursions, and other pages.\n *\n * DO NOT rename or override any class that does not use \"fbd-\".\n * Shared classes (hw-table--default, hw-form--input, hw-modal*, etc.)\n * are intentionally left untouched.\n */\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   CSS Custom Properties (design tokens)\n   ───────────────────────────────────────────────────────────────────────────── */\n:root {\n    --fbd-primary: #2563eb;\n    --fbd-primary-light: #eff6ff;\n    --fbd-primary-mid: #93c5fd;\n    --fbd-blue-dark: #1e40af;\n    --fbd-surface: #ffffff;\n    --fbd-surface-alt: #f8fafc;\n    --fbd-surface-hover: #f1f5f9;\n    --fbd-border: #e2e8f0;\n    --fbd-border-focus: #93c5fd;\n    --fbd-text-strong: #1e293b;\n    --fbd-text-body: #334155;\n    --fbd-text-muted: #64748b;\n    --fbd-text-subtle: #94a3b8;\n    --fbd-radius-sm: 6px;\n    --fbd-radius-md: 6px;\n    --fbd-radius-lg: 6px;\n    --fbd-shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.08);\n    --fbd-shadow-md: 0 4px 12px rgba(15, 23, 42, 0.10);\n    --fbd-shadow-lg: 0 8px 24px rgba(15, 23, 42, 0.12);\n    --fbd-gap-xs: 4px;\n    --fbd-gap-sm: 8px;\n    --fbd-gap-md: 12px;\n    --fbd-gap-lg: 16px;\n    --fbd-gap-xl: 20px;\n    --fbd-gap-2xl: 24px;\n    /* Match Hotels module typography (titles vs details stay separate) */\n    --fbd-font: \"DM Sans\", sans-serif;\n    --fbd-title-size: 18px;\n    --fbd-title-weight: 700;\n    --fbd-title-tracking: -0.01em;\n    --fbd-text-size: 14.5px;\n    --fbd-text-weight: 600;\n}\n\n/* Titles — section / card headings. Do not mix with .fbd-text. */\n.fbd-title,\n.fbd-card__title,\n.fbd-section__title,\n.fbd-route-city,\n.fbd-tl-place__city,\n.fbd-contact-badge__head,\n.fbd-services-toggle__label,\n.fbd-seat-segment-route,\n.fbd-fb-connector__airline-name,\n.fbd-select-pay-methods__title,\n.fbd-pay-methods__title,\n.fbd-pay-card__title,\n.hw-exchk--methodName,\n.fbd-baggage-modal .hw-modal-headerTitle,\n.fbd-sidebar .hw-passenger--head h2,\n.fbd-stripe .hw-modal-headerTitle,\n.hw-exchk--panelTitle,\n.hw-bkovl--title {\n    font-family: var(--fbd-font);\n    font-size: var(--fbd-title-size);\n    font-weight: var(--fbd-title-weight);\n    letter-spacing: var(--fbd-title-tracking);\n}\n\n/* Details / body copy. Do not mix with .fbd-title. */\n.fbd-text,\n.fbd-contact-row__val,\n.fbd-contact-badge__field,\n.fbd-airline-name,\n.fbd-tl-time,\n.fbd-info-list__item,\n.fbd-hold-confirm,\n.fbd-sidebar .hw-passenger--fareSummary__thead,\n.fbd-sidebar .hw-passenger--fareSummary__tbodyTR,\n.fbd-pax-table-wrap .fbd-pax-table tbody td {\n    font-family: var(--fbd-font);\n    font-size: var(--fbd-text-size);\n    font-weight: var(--fbd-text-weight);\n}\n\n.fbd-page,\n.fbd-sidebar,\n.fbd-guestCard {\n    font-family: var(--fbd-font);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Page wrapper\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-page {\n    display: flex;\n    flex-direction: column;\n    /* no gap between the booking sections — they join into one continuous card\n       (like the hotel's single guest card); only the flight box keeps a gap. */\n    gap: 0;\n}\n\n/* beat the shared .hw-passenger--listShow { row-gap: 2rem } on the flight page only */\n.hw-passenger--listShow.fbd-page {\n    row-gap: 0;\n}\n\n/* the flight box (fbd-flightGroup) keeps a gap below it */\n.fbd-page > .fbd-flightGroup {\n    margin-bottom: 10px;\n}\n\n/* Booking sections live inside ONE card (like the hotel's .hw-hotel--guestCard):\n   the wrapper is the card, the inner .fbd-section widgets are flattened, and a\n   single divider sits between consecutive sections. */\n.fbd-guestCard {\n    background: var(--fbd-surface);\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-lg);\n    box-shadow: var(--fbd-shadow-sm);\n    padding: 20px;\n}\n\n.fbd-guestCard > .fbd-section {\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n    background: transparent;\n    overflow: visible;\n}\n\n.fbd-guestCard > .fbd-section + .fbd-section {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--fbd-border);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Section widget card\n   Replaces: hw-passenger--listShow__widget / hw-nav--tabContentRound /\n             hw-nav--tabContentRoundWidget\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-card {\n    background: var(--fbd-surface);\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-lg);\n    box-shadow: var(--fbd-shadow-sm);\n    overflow: hidden;\n}\n\n.fbd-card--flight {\n    /* wrapper only — visual card is fbd-flight-box inside */\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    border-radius: 0;\n    overflow: visible;\n}\n\n/* Compound selector (0,2,0) beats the shared single-class\n   .hw-passenger--listShow__widget { border-radius: 0.5rem } (0,1,0),\n   regardless of CSS load order, so section cards match .fbd-flight-box (16px). */\n.hw-passenger--listShow__widget.fbd-card {\n    /* border-radius: var(--fbd-radius-lg); */\n}\n\n.hw-passenger--fareShow__widget.fbd-card {\n    /* border-radius: var(--fbd-radius-lg); */\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Section header inside a card\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-card__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px 14px;\n    border-bottom: 1px solid var(--fbd-border);\n    background: var(--fbd-surface-alt);\n}\n\n.fbd-card__title {\n    color: var(--fbd-text-strong);\n}\n\n.fbd-card__body {\n    padding: 20px;\n}\n\n.fbd-card__body--tight {\n    padding: 14px 20px;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Section header inside a padded widget (Traveller Details, etc.)\n   Sits INSIDE .hw-passenger--listShow__widget's own padding — no full-bleed bar.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-section__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-bottom: 14px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-section__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n    border-radius: 6px;\n    background: var(--fbd-primary-light);\n    color: var(--fbd-primary);\n}\n\n.fbd-section__icon svg {\n    width: 18px;\n    height: 18px;\n}\n\n.fbd-section__title {\n    color: var(--fbd-text-strong);\n}\n\n/* \"(optional)\" tag next to a section title */\n.fbd-section__optional {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--fbd-text-muted);\n    margin-left: 4px;\n}\n\n/* content directly under a section header (spacing comes from the header's margin) */\n.fbd-section__body {\n    padding-top: 0;\n}\n\n/* padding for section cards whose widget has no built-in padding (e.g. fareShow) */\n.fbd-section--pad {\n    padding: 24px;\n}\n\n/* Contact Information review rows (step 2) — stacked label/value rows that\n   mirror the hotel's contact details (.hw-hotel--reviewRow), flight-scoped. */\n.fbd-contact-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.fbd-contact-row {\n    display: flex;\n    align-items: baseline;\n    gap: 12px;\n}\n\n.fbd-contact-row__lbl {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--fbd-text-muted);\n    min-width: 62px;\n    flex: none;\n}\n\n.fbd-contact-row__val {\n    color: var(--fbd-text-strong);\n    word-break: break-word;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Gender/title custom dropdown (Traveller Details) — styled box + options panel.\n   Control matches .hw-form--input dimensions; panel is a styled menu.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-gender {\n    position: relative;\n    width: 100%;\n}\n\n.fbd-gender__control {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    min-height: 4.4rem;\n    padding: 1rem 1.2rem;\n    background: #fff;\n    border: 1px solid var(--hw-gray-600);\n    border-radius: 6px;\n    /* match .hw-form--input typography so the height matches First/Last Name */\n    font-size: 1.4rem;\n    line-height: 1.5;\n    color: var(--fbd-text-strong);\n    text-align: left;\n    cursor: pointer;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n/* .hw-form--input bumps to 1.6rem/1.75 at >=992px, which makes the inputs taller;\n   mirror it so the Gender control keeps the same height as the name fields. */\n@media (min-width: 992px) {\n    .fbd-gender__control {\n        font-size: 1.6rem;\n        line-height: 1.75;\n    }\n}\n\n.fbd-gender.is-open .fbd-gender__control,\n.fbd-gender__control:hover {\n    border-color: var(--fbd-primary);\n}\n\n.fbd-gender.is-open .fbd-gender__control {\n    box-shadow: 0 0 0 3px var(--fbd-primary-light);\n}\n\n.fbd-gender__control.is-error {\n    border-color: red;\n}\n\n.fbd-gender__placeholder {\n    color: var(--fbd-text-muted);\n}\n\n.fbd-gender__value {\n    color: var(--fbd-text-strong);\n}\n\n.fbd-gender__chev {\n    display: inline-flex;\n    flex: 0 0 auto;\n    color: var(--fbd-text-muted);\n}\n\n.fbd-gender__chev svg {\n    width: 18px;\n    height: 18px;\n}\n\n.fbd-gender__menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    z-index: 20;\n    margin: 0;\n    padding: 6px;\n    list-style: none;\n    background: #fff;\n    border: 1px solid var(--fbd-border);\n    border-radius: 8px;\n    box-shadow: var(--fbd-shadow-md);\n}\n\n.fbd-gender__option {\n    padding: 10px 12px;\n    font-size: 14px;\n    color: var(--fbd-text-strong);\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.12s ease;\n}\n\n.fbd-gender__option:hover {\n    background: var(--fbd-surface-alt);\n}\n\n.fbd-gender__option.is-selected {\n    background: var(--fbd-primary-light);\n    color: var(--fbd-primary);\n    font-weight: 600;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Booking processing overlay — styles for the shared BookingProcessingOverlay\n   component (used by hotel/excursion checkouts). Copied here so the flight page\n   renders it styled without depending on Excursion.css being loaded. These\n   .hw-bkovl* classes are used only by that overlay, so no other page is affected.\n   ───────────────────────────────────────────────────────────────────────────── */\n.hw-bkovl { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(20,28,48,.55); -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px); }\n.hw-bkovl--card { width: 100%; max-width: 380px; background: #fff; border-radius: 18px; padding: 30px 26px 22px; box-shadow: 0 26px 64px -22px rgba(16,24,40,.45); text-align: center; animation: hwBkPop .28s ease; }\n@keyframes hwBkPop { from { opacity: 0; transform: translateY(10px) scale(.97); } to { opacity: 1; transform: none; } }\n.hw-bkovl--ring { position: relative; width: 74px; height: 74px; margin: 0 auto 16px; }\n.hw-bkovl--spinner { width: 74px; height: 74px; animation: hwBkRotate 1.3s linear infinite; }\n.hw-bkovl--track { fill: none; stroke: #eaf0ff; stroke-width: 4; }\n.hw-bkovl--path { fill: none; stroke: #3264FF; stroke-width: 4; stroke-linecap: round; stroke-dasharray: 85 160; }\n.hw-bkovl--lock { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #283D6B; }\n@keyframes hwBkRotate { to { transform: rotate(360deg); } }\n.hw-bkovl--title { color: #1b2439; }\n.hw-bkovl--sub { margin-top: 4px; color: #6b7280; font-size: 13px; }\n.hw-bkovl--steps { list-style: none; margin: 18px 0 0; padding: 0; display: grid; gap: 11px; text-align: left; }\n.hw-bkovl--step { display: flex; align-items: center; gap: 11px; color: #98a2b6; font-size: 14px; font-weight: 600; transition: color .3s; }\n.hw-bkovl--step.is-active { color: #1b2439; }\n.hw-bkovl--step.is-done { color: #137333; }\n.hw-bkovl--dot { width: 21px; height: 21px; border-radius: 50%; border: 2px solid #dfe4ee; display: inline-flex; align-items: center; justify-content: center; flex: none; color: #fff; transition: all .3s; }\n.hw-bkovl--dot svg { opacity: 0; transition: opacity .2s; }\n.hw-bkovl--step.is-active .hw-bkovl--dot { border-color: #3264FF; box-shadow: 0 0 0 4px rgba(50,100,255,.12); animation: hwBkPulse 1.2s ease-in-out infinite; }\n.hw-bkovl--step.is-done .hw-bkovl--dot { background: #137333; border-color: #137333; }\n.hw-bkovl--step.is-done .hw-bkovl--dot svg { opacity: 1; }\n@keyframes hwBkPulse { 0%,100% { box-shadow: 0 0 0 4px rgba(50,100,255,.12); } 50% { box-shadow: 0 0 0 7px rgba(50,100,255,.05); } }\n.hw-bkovl--note { margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef1f7; color: #6b7280; font-size: 12.5px; }\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Flight route header (City → City + meta line)\n   Replaces: hw-inner--flightBookingBox header area\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-route-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: var(--fbd-gap-sm);\n    padding: 16px 20px 0;\n}\n\n.fbd-route-cities {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-sm);\n}\n\n.fbd-route-city {\n    color: var(--fbd-text-strong);\n}\n\n.fbd-route-arrow {\n    color: var(--fbd-text-muted);\n    display: inline-flex;\n}\n\n.fbd-route-meta {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n    flex-wrap: wrap;\n    margin-top: 4px;\n    font-size: 13px;\n    color: var(--fbd-text-muted);\n}\n\n.fbd-route-meta__dot {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: var(--fbd-text-subtle);\n    display: inline-block;\n}\n\n.fbd-fare-rules-link {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--fbd-primary);\n    cursor: pointer;\n    text-decoration: none;\n    white-space: nowrap;\n    padding: 6px 12px;\n    border-radius: var(--fbd-radius-sm);\n    border: 1px solid var(--fbd-primary-mid);\n    background: var(--fbd-primary-light);\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.fbd-fare-rules-link:hover {\n    background: var(--fbd-primary);\n    color: #fff;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Airline info bar (logo + name + code + fare identifier)\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-airline-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: var(--fbd-gap-sm);\n    padding: 12px 20px;\n    background: var(--fbd-surface-alt);\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-airline-info {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-lg);\n}\n\n.fbd-airline-logo {\n    display: flex;\n    align-items: center;\n    border-radius: var(--fbd-radius-sm);\n    overflow: hidden;\n    background: #fff;\n    border: 1px solid var(--fbd-border);\n    padding: 2px;\n}\n\n.fbd-airline-logo img {\n    display: block;\n    object-fit: contain;\n}\n\n.fbd-airline-name {\n    color: var(--fbd-primary);\n}\n\n.fbd-airline-code {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--fbd-text-muted);\n    margin-top: 2px;\n}\n\n.fbd-fare-identifier {\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--fbd-text-strong);\n    background: #dbeafe;\n    border: 1px solid #bfdbfe;\n    border-radius: 6px;\n    padding: 4px 10px;\n    white-space: nowrap;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Flight timeline\n   Replaces: hw-flight--timeline, hw-flight--listOut, hw-flight--segment,\n             hw-flight--marker, hw-flight--timelineDetails,\n             f-timeDate, f-timeDate--inline, f-place, f-dot, dot, line\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-timeline {\n    display: flex;\n    flex-direction: column;\n    padding: 16px 20px 0;\n    gap: 0;\n}\n\n.fbd-timeline__row {\n    display: flex;\n    gap: var(--fbd-gap-md);\n    position: relative;\n}\n\n.fbd-timeline__marker {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-shrink: 0;\n    width: 18px;\n    padding-top: 5px;\n}\n\n.fbd-timeline__dot {\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    border: 2px solid var(--fbd-primary);\n    background: var(--fbd-surface);\n    flex-shrink: 0;\n}\n\n.fbd-timeline__line {\n    flex: 1;\n    width: 2px;\n    background: linear-gradient(to bottom, var(--fbd-primary-mid), #e0e7ff);\n    margin: 2px 0;\n    min-height: 40px;\n}\n\n.fbd-timeline__details {\n    flex: 1;\n    padding-bottom: 20px;\n}\n\n.fbd-tl-time {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n    color: var(--fbd-primary);\n    margin-bottom: 4px;\n}\n\n.fbd-tl-time__sep {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: var(--fbd-primary-mid);\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.fbd-tl-place {\n    color: var(--fbd-primary);\n}\n\n.fbd-tl-place__city {\n    display: inline;\n}\n\n.fbd-tl-place__sub {\n    font-size: 12px;\n    color: var(--fbd-text-muted);\n    margin-top: 2px;\n}\n\n.fbd-tl-duration {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--fbd-primary);\n    background: var(--fbd-primary-light);\n    border-radius: 6px;\n    padding: 3px 8px;\n    display: inline-flex;\n    margin: 6px 0 4px;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Baggage line\n   Replaces: hw-baggage--line\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-baggage-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: var(--fbd-gap-sm);\n    padding: 10px 20px 14px;\n    background: var(--fbd-surface-alt);\n    border-top: 1px solid var(--fbd-border);\n    margin-top: 4px;\n}\n\n.fbd-baggage-bar__items {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: var(--fbd-gap-lg);\n    font-size: 13px;\n}\n\n.fbd-baggage-bar__item {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n    flex-wrap: wrap;\n}\n\n.fbd-baggage-bar__icon {\n    color: var(--fbd-primary);\n    display: inline-flex;\n}\n\n.fbd-baggage-bar__label {\n    font-weight: 600;\n    color: var(--fbd-text-strong);\n}\n\n.fbd-baggage-bar__value {\n    color: var(--fbd-text-body);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Layover / connection badge\n   Replaces: hw-search--innerflight__divider, divider-badge\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-layover {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-sm);\n    padding: 8px 20px;\n    background: #fef9ec;\n    border-top: 1px dashed #fbbf24;\n    border-bottom: 1px dashed #fbbf24;\n}\n\n.fbd-layover__badge {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-sm);\n    font-size: 12px;\n    color: #92400e;\n    font-weight: 600;\n    flex-wrap: wrap;\n}\n\n.fbd-layover__line {\n    flex: 1;\n    height: 1px;\n    background: #fde68a;\n}\n\n/* Show more/less button for multi-segment */\n.fbd-segment-toggle {\n    display: flex;\n    justify-content: center;\n    padding: 8px 20px 12px;\n}\n\n.fbd-segment-toggle__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: 1px solid var(--fbd-border);\n    background: var(--fbd-surface-alt);\n    color: var(--fbd-text-muted);\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.fbd-segment-toggle__btn:hover {\n    background: var(--fbd-primary-light);\n    color: var(--fbd-primary);\n    border-color: var(--fbd-primary-mid);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Passenger accordion card\n   Replaces: hw-passenger--detailsGroupItem, fare-toggle-parent,\n             hw-passenger--fareShowToggle, hw-passenger--fareShowToggleContent,\n             hw-passenger--detailsGroup\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-pax-group {\n    display: flex;\n    flex-direction: column;\n    gap: var(--fbd-gap-md);\n    margin-top: var(--fbd-gap-lg);\n}\n\n.fbd-pax-card {\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    overflow: hidden;\n    transition: box-shadow 0.15s ease;\n}\n\n.fbd-pax-card.active {\n    box-shadow: none;\n}\n\n.fbd-pax-card__toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 18px;\n    cursor: pointer;\n    /* background: var(--fbd-surface-alt); */\n    user-select: none;\n    transition: background 0.15s ease;\n}\n\n.fbd-pax-card__toggle:hover {\n    background: var(--fbd-surface-hover);\n}\n\n.fbd-pax-card.active .fbd-pax-card__toggle {\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-pax-card__name {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-sm);\n    font-weight: 700;\n    color: var(--fbd-primary);\n}\n\n/* beat the shared `.hw-passenger--listShow__widget .hw-text18` (0,2,0) that\n   otherwise forces this to 1.8rem; !important keeps it 1.4rem at every width. */\n.fbd-pax-card__name {\n    font-size: 1.4rem !important;\n}\n\n.fbd-pax-card__chevron {\n    color: var(--fbd-text-muted);\n    display: inline-flex;\n    transition: transform 0.2s ease;\n}\n\n.fbd-pax-card.active .fbd-pax-card__chevron {\n    transform: rotate(180deg);\n}\n\n.fbd-pax-card__body {\n    padding: 18px;\n    background: var(--fbd-surface);\n}\n\n/* Sub-section label (Passport Details) */\n.fbd-subsection-label {\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--fbd-text-strong);\n    letter-spacing: 0.04em;\n    margin: 14px 0 10px;\n    padding-bottom: 6px;\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Meals & Baggage section\n   Replaces: hw-passenger-meal-baggage and surrounding structure\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-services-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 20px;\n    cursor: pointer;\n    background: var(--fbd-surface-alt);\n    border-bottom: 1px solid var(--fbd-border);\n    transition: background 0.15s ease;\n}\n\n.fbd-services-toggle:hover {\n    background: var(--fbd-surface-hover);\n}\n\n.fbd-services-toggle__label {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-sm);\n    color: var(--fbd-text-strong);\n}\n\n.fbd-services-toggle__icon {\n    color: var(--fbd-primary);\n    display: inline-flex;\n}\n\n.fbd-services-toggle__chevron {\n    color: var(--fbd-text-muted);\n    display: inline-flex;\n    transition: transform 0.2s ease;\n}\n\n.fbd-services-toggle.open .fbd-services-toggle__chevron {\n    transform: rotate(180deg);\n}\n\n.fbd-services-body {\n    padding: 18px 20px;\n}\n\n.fbd-services-segment {\n    margin-bottom: 20px;\n}\n\n.fbd-services-segment:last-child {\n    margin-bottom: 0;\n}\n\n.fbd-services-segment__title {\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--fbd-text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    margin-bottom: 10px;\n}\n\n.fbd-services-pax-row {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--fbd-gap-md);\n    flex-wrap: wrap;\n    padding: 10px 0;\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-services-pax-row:last-child {\n    border-bottom: none;\n}\n\n.fbd-services-pax-row__label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--fbd-text-body);\n    min-width: 100px;\n    padding-top: 8px;\n}\n\n.fbd-services-select-group {\n    display: flex;\n    gap: var(--fbd-gap-md);\n    flex: 1;\n    flex-wrap: wrap;\n}\n\n.fbd-services-select-wrap {\n    flex: 1;\n    min-width: 160px;\n}\n\n.fbd-services-select-label {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--fbd-text-muted);\n    margin-bottom: 4px;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Seat selection section\n   Replaces: hw-segment--data, hw-segment-text,\n             hw-btn hw-btn--primary hw-btn--mn140 (only for seat btn)\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-seat-segment-list {\n    display: flex;\n    flex-direction: column;\n    gap: var(--fbd-gap-sm);\n}\n\n.fbd-seat-segment-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--fbd-gap-md);\n    flex-wrap: wrap;\n    padding: 14px 16px;\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    background: var(--fbd-surface-alt);\n    transition: box-shadow 0.15s ease;\n}\n\n.fbd-seat-segment-row:hover {\n    box-shadow: var(--fbd-shadow-sm);\n}\n\n.fbd-seat-segment-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.fbd-seat-segment-route {\n    color: var(--fbd-text-strong);\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n}\n\n.fbd-seat-segment-meta {\n    font-size: 12px;\n    color: var(--fbd-text-muted);\n}\n\n.fbd-seat-selected-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n    font-size: 12px;\n    font-weight: 600;\n    color: #16a34a;\n    background: #dcfce7;\n    border: 1px solid #86efac;\n    border-radius: 6px;\n    padding: 4px 10px;\n}\n\n.fbd-btn-seat {\n    display: inline-flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n    padding: 8px 20px;\n    min-width: 130px;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    border-radius: var(--fbd-radius-sm);\n    cursor: pointer;\n    border: none;\n    background: var(--fbd-primary);\n    color: #fff;\n    transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.fbd-btn-seat:hover {\n    background: var(--fbd-blue-dark);\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.30);\n}\n\n.fbd-btn-seat--edit {\n    background: var(--fbd-surface);\n    color: var(--fbd-primary);\n    border: 1.5px solid var(--fbd-primary-mid);\n}\n\n.fbd-btn-seat--edit:hover {\n    background: var(--fbd-primary-light);\n    box-shadow: none;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Contact Information section\n   Replaces: hw-contact--inputSingleField, hw-inner--fullWidth, input-m--field\n   ───────────────────────────────────────────────────────────────────────────── */\n/* Phone code + mobile number as ONE joined field (same as the hotel's\n   .hw-contact--inputSingleField): one outer border, a grid of\n   [phone-code auto | number 1fr], and borderless inner inputs. The\n   HwPhoneCodeSelect control supplies the \"|\" divider via its own right border. */\n.fbd-contact-phone-row {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: stretch;\n    border: 1px solid var(--hw-gray-600);\n    border-radius: 6px;\n    /* reserve room for the absolutely-positioned phone-code / number errors so the\n       card (overflow:hidden) doesn't clip them when the email is valid */\n    margin-bottom: 2.4rem;\n}\n\n.fbd-contact-phone-row > div {\n    position: relative;\n}\n\n/* inner inputs have no border — the row provides the single border */\n.fbd-contact-phone-row .hw-form--input {\n    border: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n}\n\n/* separator line between phone code and mobile number */\n.fbd-contact-phone-row .fbd-contact-phone-code {\n    border-right: 1px solid var(--hw-gray-600) !important;\n}\n\n.fbd-contact-phone-row .fbd-contact-phone-code .hw-pcsel--control {\n    border-right: none !important;\n}\n\n/* keep the number input snug to the divider, like the hotel's input-m--field */\n.fbd-contact-phone-row .input-m--field .hw-form--input {\n    padding-left: 1.2rem;\n}\n\n/* inline errors float below the field */\n.fbd-contact-phone-row .hw-p-error-cls {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 4px;\n    white-space: nowrap;\n    z-index: 5;\n}\n\n/* fixed phone-code width like the hotel (.hw--hotel-phonecode: 18rem / 14rem) so\n   it doesn't grow to its content and squeeze the mobile number. display:flex lets\n   the HwPhoneCodeSelect (flex:1) fill it. */\n.fbd-contact-phone-code {\n    display: flex;\n    width: 18rem;\n    min-width: 14rem;\n}\n\n.fbd-contact-phone-code p.hw-p-error-cls {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 4px !important;\n    white-space: nowrap;\n}\n\n.fbd-contact-phone-number {\n    min-width: 0;\n}\n\n.fbd-contact-phone-number p.hw-p-error-cls {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 4px !important;\n    white-space: nowrap;\n}\n\n/* At desktop the shared .hw-passenger--list gets `height:100%; overflow-y:auto`,\n   turning the flight's left column into a scroll container that CLIPS absolutely\n   positioned dropdown menus (the phone-code list gets cut off and scrolls).\n   Flight-scoped (under .fbd-overlap-wrap): let the column grow naturally so menus\n   overflow freely — the page scrolls instead. */\n.fbd-overlap-wrap .hw-passenger--list {\n    height: auto;\n    overflow: visible;\n}\n\n/* Contact Info badge (Tab 2 read-only view)\n   Replaces: hw-contact--badge, hw-contact--badgeHead, hw-contact--badgeBody */\n.fbd-contact-badge {\n    background: var(--fbd-surface);\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    overflow: hidden;\n    box-shadow: var(--fbd-shadow-sm);\n}\n\n.fbd-contact-badge__head {\n    padding: 12px 18px;\n    color: var(--fbd-text-strong);\n    background: var(--fbd-surface-alt);\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-contact-badge__body {\n    padding: 16px 18px;\n}\n\n.fbd-contact-badge__field {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-sm);\n}\n\n.fbd-contact-badge__key {\n    font-weight: 700;\n    color: var(--fbd-text-strong);\n}\n\n.fbd-contact-badge__val {\n    color: var(--fbd-primary);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Address Details section\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-address-section {\n    /* container for the address fields — uses standard .row/.col Bootstrap grid */\n    margin-top: 14px;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Booking Reference widget\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-booking-ref {\n    padding: 0;\n}\n\n/* thin divider between payment methods and Booking Reference — mirrors the\n   hotel's .hw-hotel--guestDivider (kept flight-scoped, in flight.css). */\n.fbd-divider {\n    height: 1px;\n    background: var(--fbd-border);\n    margin: 16px 0;\n}\n\n/* Booking Reference label — mirrors the hotel/excursion .hw-exchk--label\n   (.hw-exchk--field.hw-exchk--bookingRef) so both modules read identically.\n   Kept flight-scoped here rather than reusing the shared class. */\n.fbd-booking-ref__label {\n    display: block;\n    font-family: var(--fbd-font);\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: normal;\n    color: #1b2439;\n    margin-bottom: 6px;\n}\n\n/* \"(optional)\" tag — matches .hw-exchk--optional (inherits the 14px label size) */\n.fbd-booking-ref__label .fbd-section__optional {\n    font-size: inherit;\n    font-weight: 500;\n    color: #98a2b6;\n    margin-left: 0;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Traveller summary table wrapper\n   The inner table keeps hw-table--default (shared); only the outer wrapper\n   and the section heading get new classes.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-summary-wrap {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    border-radius: var(--fbd-radius-md);\n    border: 1px solid var(--fbd-border);\n}\n\n.fbd-summary-wrap .hw-table--default {\n    /* ensure table sits flush inside the rounded wrapper */\n    border-radius: 0;\n    border: none;\n    margin-bottom: 0;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Important Information list\n   Replaces: hw-list--circleSmall (flight-specific usage only)\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-info-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: var(--fbd-gap-sm);\n}\n\n.fbd-info-list__item {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--fbd-gap-sm);\n    color: var(--fbd-text-body);\n    line-height: 1.5;\n}\n\n.fbd-info-list__item::before {\n    content: \"\";\n    display: block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--fbd-primary);\n    flex-shrink: 0;\n    margin-top: 6px;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Seat map legend (inside CommonPopup)\n   Replaces: hw-seatmap-legend, hw-seat-selected, hw-seat-not-selected\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-seat-legend {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: var(--fbd-gap-lg);\n    padding: 10px 0;\n}\n\n.fbd-seat-legend__item {\n    display: flex;\n    align-items: center;\n    gap: var(--fbd-gap-xs);\n    font-size: 12px;\n    color: var(--fbd-text-body);\n    font-weight: 500;\n}\n\n.fbd-seat-legend__swatch {\n    width: 16px;\n    height: 16px;\n    border-radius: 6px;\n    border: 1px solid var(--fbd-border);\n}\n\n.fbd-seat-legend__swatch--unavailable {\n    background: #e2e8f0;\n}\n\n.fbd-seat-legend__swatch--premium {\n    background: #fde68a;\n    border-color: #fbbf24;\n}\n\n.fbd-seat-legend__swatch--selected {\n    background: var(--fbd-primary);\n    border-color: var(--fbd-blue-dark);\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Section spacing helper\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-pt16 {\n    padding-top: 16px;\n}\n\n.fbd-pt20 {\n    padding-top: 20px;\n}\n\n.fbd-mt10 {\n    margin-top: 10px;\n}\n\n.fbd-mt16 {\n    margin-top: 16px;\n}\n\n.fbd-mt20 {\n    margin-top: 20px;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Responsive overrides\n   ───────────────────────────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n\n    .fbd-card__body,\n    .fbd-card__body--tight {\n        padding: 14px;\n    }\n\n    .fbd-route-header {\n        padding: 12px 14px 0;\n    }\n\n    .fbd-airline-bar {\n        padding: 10px 14px;\n    }\n\n    .fbd-timeline {\n        padding: 12px 14px 0;\n    }\n\n    .fbd-baggage-bar {\n        padding: 10px 14px 12px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n\n    .fbd-seat-segment-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .fbd-btn-seat {\n        width: 100%;\n    }\n\n    /* Seat Selection: stack the flight info + Select Seats button so the info\n       doesn't squish into a narrow column on small screens. */\n    .fbd-seatsel-row {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n    }\n\n    .fbd-seatsel-row .hw-segment--data {\n        flex-wrap: wrap;\n    }\n\n    .fbd-seatsel-row .hw-btn {\n        width: 100%;\n    }\n\n    /* keep the phone code + number joined on mobile too, just a touch narrower */\n    .fbd-contact-phone-code {\n        width: 13rem;\n        min-width: 11rem;\n    }\n\n    .fbd-contact-phone-code p{\n    margin-top: 48px !important;\n}\n\n    .fbd-pax-card__body {\n        padding: 14px;\n    }\n\n    .fbd-services-body {\n        padding: 14px;\n    }\n\n    .fbd-services-pax-row {\n        flex-direction: column;\n    }\n\n    .fbd-services-pax-row__label {\n        padding-top: 0;\n    }\n\n    .fbd-route-city,\n    .fbd-card__title {\n        font-size: var(--fbd-title-size);\n    }\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   fbd-flight-box  — ticket-style flight card (reference UI redesign)\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-flight-box {\n    background: #fff;\n    border: 1px solid #dbeafe;\n    border-radius: 0;\n    box-shadow: 0 2px 12px rgba(15, 23, 42, 0.07);\n    overflow: hidden;\n    /* margin-bottom: 12px; */\n}\n\n/* ── top meta row: date + stops/duration on left, fare rules link on right ── */\n.fbd-fb-meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 12px 20px;\n    border-bottom: 1px dashed #bfdbfe;\n    background: #f0f7ff;\n}\n\n.fbd-fb-meta__left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #475569;\n    font-weight: 500;\n    flex-wrap: wrap;\n}\n\n.fbd-fb-meta__sep {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: #94a3b8;\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.fbd-fb-meta__pipe {\n    color: #cbd5e1;\n    font-weight: 300;\n}\n\n.fbd-fb-meta__fare-link {\n    font-size: 13px;\n    font-weight: 600;\n    color: #2563eb;\n    cursor: pointer;\n    text-decoration: none;\n    white-space: nowrap;\n    transition: opacity 0.15s;\n}\n\n.fbd-fb-meta__fare-link:hover {\n    opacity: 0.75;\n}\n\n/* ── main body: IATA codes + dotted line + plane ── */\n.fbd-fb-body {\n    padding: 20px 24px 16px;\n}\n\n.fbd-fb-route {\n    display: flex;\n    align-items: center;\n    gap: 0;\n    width: 100%;\n}\n\n.fbd-fb-iata {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    min-width: 70px;\n    flex-shrink: 0;\n}\n\n.fbd-fb-iata--right {\n    align-items: flex-end;\n}\n\n.fbd-fb-iata__code {\n    font-size: 27px;\n    font-weight: 800;\n    color: #1e293b;\n    letter-spacing: -1px;\n    line-height: 1;\n}\n\n.fbd-fb-iata__time {\n    font-size: 12px;\n    color: #64748b;\n    font-weight: 500;\n    margin-top: 4px;\n}\n\n/* center: dotted connector line with plane icon */\n.fbd-fb-connector {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    padding: 0 12px;\n}\n\n.fbd-fb-connector__line-wrap {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 0;\n}\n\n.fbd-fb-connector__dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #2563eb;\n    flex-shrink: 0;\n}\n\n.fbd-fb-connector__dashed {\n    flex: 1;\n    height: 2px;\n    background: repeating-linear-gradient(to right,\n            #93c5fd 0px,\n            #93c5fd 6px,\n            transparent 6px,\n            transparent 12px);\n}\n\n.fbd-fb-connector__plane {\n    flex-shrink: 0;\n    color: #2563eb;\n    display: inline-flex;\n    align-items: center;\n    margin: 0 4px;\n    rotate: 45deg;\n}\n\n.fbd-fb-connector__plane svg {\n    width: 22px;\n    height: 22px;\n}\n\n.fbd-fb-connector__arrow {\n    flex: 1;\n    height: 2px;\n    background: repeating-linear-gradient(to right,\n            #93c5fd 0px,\n            #93c5fd 6px,\n            transparent 6px,\n            transparent 12px);\n}\n\n.fbd-fb-connector__info {\n    font-size: 12px;\n    color: #64748b;\n    font-weight: 500;\n    text-align: center;\n    margin-top: 2px;\n}\n\n/* airline row: flight-no on the LEFT, logo + name on the RIGHT */\n.fbd-fb-connector__airline {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    text-align: left;\n    margin-bottom: 16px;\n}\n\n/* right group: logo + airline name */\n.fbd-fb-connector__airline-brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n}\n\n.fbd-fb-connector__logo {\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    object-fit: contain;\n    border-radius: 6px;\n    border: 1px solid #e2e8f0;\n    background: #fff;\n    padding: 2px;\n}\n\n.fbd-fb-connector__airline-name {\n    color: #1e293b;\n}\n\n/* right: flight number + fare */\n.fbd-fb-connector__flight-no {\n    font-size: 13px;\n    font-weight: 500;\n    color: #64748b;\n    text-align: right;\n}\n\n/* ── duration labels on each side ── */\n.fbd-fb-iata__duration {\n    font-size: 11px;\n    color: #94a3b8;\n    margin-top: 2px;\n}\n\n/* ── city names below IATA codes ── */\n.fbd-fb-iata__city {\n    font-size: 13px;\n    color: #64748b;\n    font-weight: 600;\n    margin-top: 6px;\n}\n\n/* ── baggage strip ── */\n.fbd-fb-baggage {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 10px 20px 14px;\n    border-top: 1px solid #f1f5f9;\n}\n\n.fbd-fb-baggage__pills {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.fbd-fb-baggage__pill {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #334155;\n    font-weight: 500;\n}\n\n.fbd-fb-baggage__pill-icon {\n    color: #2563eb;\n    display: inline-flex;\n    align-items: center;\n}\n\n.fbd-fb-baggage__pill-label {\n    font-weight: 600;\n    color: #475569;\n}\n\n.fbd-fb-baggage__pill-value {\n    color: #1e293b;\n}\n\n.fbd-fb-baggage__link {\n    font-size: 13px;\n    font-weight: 600;\n    color: #2563eb;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    white-space: nowrap;\n    background: none;\n    border: none;\n    padding: 0;\n    transition: opacity 0.15s;\n}\n\n.fbd-fb-baggage__link:hover {\n    opacity: 0.75;\n}\n\n/* ── responsive ── */\n@media (max-width: 600px) {\n    .fbd-fb-iata__code {\n        font-size: 23px;\n    }\n\n    .fbd-fb-meta {\n        padding: 10px 14px;\n    }\n\n    .fbd-fb-body {\n        padding: 16px 14px 12px;\n    }\n\n    .fbd-fb-baggage {\n        padding: 10px 14px 12px;\n    }\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Baggage Details modal (BaggageDetailsPopup)\n   Scoped under .fbd-baggage-modal so the shared .hw-modal* / .hw-table* classes\n   used by other popups are NOT affected.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-baggage-modal {\n    --bs-modal-width: 52rem;\n}\n\n.fbd-baggage-modal .hw-modal-dialog {\n    max-width: 520px !important;\n    width: 92% !important;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.fbd-baggage-modal .hw-modal-content {\n    border-radius: var(--fbd-radius-lg);\n    border: 1px solid var(--fbd-border);\n    box-shadow: var(--fbd-shadow-lg);\n    overflow: hidden;\n}\n\n.fbd-baggage-modal .hw-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 20px;\n    background: var(--fbd-surface-alt);\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-baggage-modal .hw-modal-headerTitle {\n    color: var(--fbd-text-strong);\n}\n\n.fbd-baggage-modal .hw-modal-body {\n    padding: 18px 20px 22px !important;\n}\n\n.fbd-baggage-modal .hw-modal--close {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: var(--fbd-text-muted);\n    transition: color 0.15s ease;\n}\n\n.fbd-baggage-modal .hw-modal--close:hover {\n    color: var(--fbd-text-strong);\n}\n\n/* airline logo + route summary band */\n.fbd-baggage-modal .fbd-bag-summary {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    background: var(--fbd-primary-light);\n    border: 1px solid var(--fbd-primary-mid);\n    border-radius: var(--fbd-radius-md);\n    margin-bottom: 16px;\n}\n\n.fbd-baggage-modal .fbd-bag-summary img {\n    border-radius: 6px;\n    border: 1px solid var(--fbd-border);\n    background: #fff;\n    padding: 2px;\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n\n.fbd-baggage-modal .fbd-bag-summary .h4 {\n    font-size: 15px;\n    font-weight: 700;\n}\n\n/* baggage table */\n.fbd-baggage-modal .hw-table--baggage {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    overflow: hidden;\n}\n\n.fbd-baggage-modal .hw-table--baggage thead th {\n    background: var(--fbd-surface-alt);\n    color: var(--fbd-text-strong);\n    font-size: 13px;\n    font-weight: 700;\n    padding: 10px 14px;\n    text-align: left;\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-baggage-modal .hw-table--baggage tbody td {\n    padding: 10px 14px;\n    font-size: 13.5px;\n    color: var(--fbd-text-body);\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-baggage-modal .hw-table--baggage tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.fbd-baggage-modal .hw-table--baggage tbody tr:nth-child(even) td {\n    background: var(--fbd-surface-alt);\n}\n\n/* ── responsive (phones): the 3-column baggage table + header icons overflow a\n   ~334px popup and the last column gets clipped. Tighten padding/font, drop the\n   header icons, and let the table scroll horizontally as a safety net. ── */\n@media (max-width: 600px) {\n    .fbd-baggage-modal .hw-modal-body {\n        padding: 14px 14px 18px !important;\n    }\n\n    .fbd-baggage-modal .hw-table--responsive {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .fbd-baggage-modal .hw-table--baggage thead th,\n    .fbd-baggage-modal .hw-table--baggage tbody td {\n        padding: 8px 9px;\n        font-size: 12px;\n        white-space: nowrap;\n    }\n\n    /* the Check-In / Cabin header icons eat width on tiny screens */\n    .fbd-baggage-modal .hw-table--baggage thead th svg {\n        display: none;\n    }\n\n    .fbd-baggage-modal .fbd-bag-summary .h4 {\n        font-size: 14px;\n    }\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Fare Summary sidebar (BookingDetailsSideBarComponent — flight only)\n   Scoped under .fbd-sidebar so shared .hw-passenger--fareSummary* used elsewhere\n   is NOT affected. Amount colors (.hw-blue etc.) are left as-is on purpose.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-sidebar {\n    background: var(--fbd-surface);\n    border: 1px solid var(--fbd-border);\n    box-shadow: var(--fbd-shadow-sm);\n    overflow: hidden;\n}\n\n.hw-passenger--fareSummary.fbd-sidebar {\n    border-radius: 6px !important;\n}\n\n/* Tab 3: shared rule zeroes the fare-summary radius with !important\n   (.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary).\n   Restore 16px for the flight sidebar only (it carries .fbd-sidebar). */\n/* On the confirmation page the children are already self-contained\n   .hw-after--bookingWidget cards, so the outer frame only shows as a faint\n   hairline around them — drop the border/shadow there (tab 3 only). */\n.hw-passenger--pageList.hw-passenger--pageListEnd .hw-passenger--fareSummary.fbd-sidebar {\n    border-radius: 6px !important;\n    border: 0;\n    box-shadow: none;\n}\n\n/* header band */\n.fbd-sidebar .hw-passenger--head {\n    padding: 16px 20px;\n    background: var(--fbd-surface-alt);\n    border-bottom: 1px solid var(--fbd-border);\n}\n\n.fbd-sidebar .hw-passenger--head h2 {\n    color: var(--fbd-text-strong);\n}\n\n.fbd-sidebar .hw-passenger--fareSummary__box {\n    padding: 20px;\n}\n\n/* fare rows: match the hotel's .hw-passenger--fareSummary body rows, which are\n   marked up as `hw-text14 hw-fontBold` (14px / bold / 1.71429) rather than the\n   flight module's 14.5px / 600 body text. */\n.fbd-sidebar .hw-passenger--fareSummary__thead,\n.fbd-sidebar .hw-passenger--fareSummary__tbodyTR {\n    align-items: center;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.71429;\n}\n\n.fbd-sidebar .hw-passenger--fareSummary__thead > span,\n.fbd-sidebar .hw-passenger--fareSummary__tbodyTR > span {\n    font-size: 14px;\n    font-weight: 700;\n}\n\n/* amounts: the hotel renders these in --hw-black (hw-black), not the brand blue.\n   .hw-blue sets color with !important, so match that weight to win. */\n.fbd-sidebar .hw-passenger--fareSummary__thead > span.hw-blue,\n.fbd-sidebar .hw-passenger--fareSummary__tbodyTR > span.hw-blue {\n    color: var(--hw-black) !important;\n}\n\n/* total footer emphasis — separation comes from the border + padding alone,\n   so no extra margin above the Total row */\n.fbd-sidebar .hw-passenger--fareSummary__tfoot {\n    border-top: 1px solid var(--fbd-border);\n    padding: 10px 0 0;\n    /* margin-top: 0 !important; */\n    align-items: center;\n}\n\n/* \"Price Breakup\" panel heading only — the Download Tickets title is left on\n   the shared .h4 styling. */\n.fbd-sidebar .hw-after--bookingWidget.price-backup .h4 {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.fbd-sidebar .hw-after--bookingWidget.tickets .h4 {\n    font-size: 18px;\n}\n\n/* .fbd-sidebar .hw-passenger--fareSummary__tfoot span {\n    font-size: 18px;\n} */\n\n/* section dividers for coupon / payment blocks */\n.fbd-sidebar .hw-apply--coupen,\n.fbd-sidebar .hw-select--payment {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px dashed var(--fbd-border);\n}\n\n/* payment method radio cards */\n.fbd-sidebar .hw-radio--btnIcon {\n    border-radius: var(--fbd-radius-md);\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Booking step progress (BookingStepProgress — flight only)\n   Scoped under .fbd-steps. Highlights the current step, shows completed steps\n   with a filled connector, and dims upcoming steps.\n   ───────────────────────────────────────────────────────────────────────────── */\n/* step number bubble — default (upcoming) */\n.fbd-steps .lm-i {\n    background-color: var(--fbd-surface);\n    color: var(--fbd-text-subtle);\n    border: 2px solid var(--fbd-border);\n    width: 34px;\n    height: 34px;\n    font-size: 15px;\n    font-weight: 700;\n    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n/* step label — default (upcoming) */\n.fbd-steps .hw-step .lm-icon--grid .hw-text14 {\n    color: var(--fbd-text-subtle);\n    font-weight: 600;\n    transition: color 0.2s ease;\n}\n\n/* ACTIVE step */\n.fbd-steps .hw-step.active .lm-i {\n    background-color: var(--fbd-primary);\n    border-color: var(--fbd-primary);\n    color: #fff;\n    box-shadow: 0 0 0 4px var(--fbd-primary-light);\n}\n\n.fbd-steps .hw-step.active .lm-icon--grid .hw-text14 {\n    color: var(--fbd-text-strong);\n    font-weight: 700;\n}\n\n/* COMPLETE step — shared rule paints the white check via background-image;\n   we only recolor the bubble (never use the background shorthand or the check disappears) */\n.fbd-steps .hw-step.complete .lm-i {\n    background-color: var(--fbd-primary);\n    border-color: var(--fbd-primary);\n}\n\n.fbd-steps .hw-step.complete .lm-icon--grid .hw-text14 {\n    color: var(--fbd-text-body);\n    font-weight: 600;\n}\n\n/* connector line between steps */\n.fbd-steps .row>.hw-step:not(:last-child)::after {\n    background-color: var(--fbd-border);\n    height: 2px;\n    border-radius: 6px;\n}\n\n.fbd-steps .row>.hw-step.complete:not(:last-child)::after {\n    background-color: var(--fbd-primary);\n}\n\n/* session-expiry timer pill */\n.fbd-steps__timer {\n    display: flex;\n    justify-content: center;\n    margin-top: 12px;\n}\n\n.fbd-steps__timer>div {\n    background: var(--fbd-primary-light);\n    border: 1px solid var(--fbd-primary-mid);\n    color: var(--fbd-blue-dark);\n    padding: 6px 14px;\n    border-radius: 999px;\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Flight modal body (Fare Rules raw modals + Seat Selection CommonPopups)\n   Renamed off the shared .hw-modal-body so the shared\n   \".hw-modal-dialog-scrollable .hw-modal-body { overflow-y:auto }\" no longer\n   stacks with the seat map's own scroll (was causing two scrollbars).\n   Here the modal body is the SINGLE scroll container.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-modal-body {\n    padding: 1.2rem 1.6rem 1.6rem 1.6rem;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: var(--fbd-text-subtle) transparent;\n}\n\n/* Seat Selection: keep the seat map's own framed internal scroll (the good\n   design) and stop the modal body from scrolling too — so only ONE scrollbar\n   (the seat map) shows instead of two. Fare Rules keep .fbd-modal-body's scroll. */\n.fbd-modal-body.fbd-modal-body--seat {\n    overflow: visible;\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Confirm Hold Booking modal (BookingDetailsSideBarComponent, via CommonPopup)\n   ───────────────────────────────────────────────────────────────────────────── */\n/* Confirm Hold Booking popup — compact width (overrides shared 90% dialog width).\n   Compound selector beats \".hw-modal-dialog { max-width: var(--bs-modal-width) }\". */\n.hw-modal-dialog.fbd-hold-dialog {\n    max-width: 680px;\n}\n\n.fbd-hold-modal {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n/* non-refundable fee warning callout */\n.fbd-hold-note {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 14px 16px;\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: var(--fbd-radius-md);\n}\n\n.fbd-hold-note__icon {\n    color: #dc2626;\n    flex-shrink: 0;\n    display: inline-flex;\n    margin-top: 1px;\n}\n\n.fbd-hold-note__text {\n    font-size: 14px;\n    line-height: 1.6;\n    color: #7f1d1d;\n}\n\n.fbd-hold-note__text strong {\n    color: #b91c1c;\n    font-weight: 700;\n}\n\n.fbd-hold-confirm {\n    margin: 0;\n    color: var(--fbd-text-strong);\n}\n\n.fbd-hold-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 16px;\n    border-top: 1px solid var(--fbd-border);\n}\n\n.fbd-hold-actions .hw-btn {\n    min-width: 120px;\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Traveller Details summary table (Tab 2 / Tab 3, read-only)\n   Scoped under .fbd-pax-table-wrap so the shared .hw-table--default used on\n   other pages is untouched. Selectors are prefixed to beat the shared rules.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-pax-table-wrap {\n    margin-top: 0;\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    display: block !important;\n    box-sizing: border-box !important;\n}\n\n.fbd-pax-table-wrap .fbd-pax-table {\n    width: 100%;\n    min-width: 540px;\n    border: 1px solid var(--fbd-border);\n    border-collapse: separate;\n    border-spacing: 0;\n    border-radius: var(--fbd-radius-md);\n    overflow: hidden;\n}\n\n.fbd-pax-table-wrap .fbd-pax-table thead th {\n    background: var(--fbd-surface-alt);\n    color: var(--fbd-text-strong);\n    font-size: 14.5px;\n    font-weight: 700;\n    text-align: left;\n    padding: 12px 16px;\n    border-bottom: 1px solid var(--fbd-border);\n    white-space: nowrap;\n}\n\n.fbd-pax-table-wrap .fbd-pax-table tbody td {\n    padding: 12px 16px;\n    color: var(--fbd-text-body);\n    border-bottom: 1px solid var(--fbd-border);\n    vertical-align: top;\n}\n\n.fbd-pax-table-wrap .fbd-pax-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.fbd-pax-table-wrap .fbd-pax-table tbody tr:nth-child(even) td {\n    background: var(--fbd-surface-alt);\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Review Booking blue banner (flight booking page, tabs 1-2)\n/* ─────────────────────────────────────────────────────────────────────────────\n   Hero Banner & Stepper (hw-exchk--hero, hw-hotel--hero, hw-flight--hero, hw-cfhero)\n   Exact match with Excursion and Hotel checkout hero components.\n   ───────────────────────────────────────────────────────────────────────────── */\n.hw-exchk--heroInner {\n    max-width: 144rem;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0 1.5rem;\n}\n@media (min-width: 600px) { .hw-exchk--heroInner { padding-left: 3rem; padding-right: 3rem; } }\n@media (min-width: 1200px) { .hw-exchk--heroInner { padding-left: 5rem; padding-right: 5rem; } }\n@media (min-width: 1300px) { .hw-exchk--heroInner { padding-left: 6rem; padding-right: 6rem; } }\n@media (min-width: 1400px) { .hw-exchk--heroInner { padding-left: 10rem; padding-right: 10rem; } }\n\n.hw-exchk--hero {\n    background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);\n    border-radius: 0;\n    padding: 18px 0 60px;\n    margin: 0;\n    color: #fff;\n    box-shadow: 0 10px 26px -18px rgba(40,61,107,.5);\n    min-height: 147px;\n}\n\n.hw-hotel--hero,\n.hw-flight--hero {\n    padding: 16px 0 60px;\n}\n\n.hw-exchk--hero .hw-exchk--back {\n    color: rgba(255, 255, 255, 0.85);\n}\n.hw-exchk--hero .hw-exchk--back:hover {\n    color: #fff;\n}\n\n.hw-exchk--back {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: none;\n    border: none;\n    color: #556;\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 6px 8px 6px 0;\n    transition: color 0.15s ease;\n}\n.hw-exchk--back:hover {\n    color: #3264FF;\n}\n\n.hw-exchk--heroBar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    flex-wrap: wrap;\n    margin-top: 4px;\n}\n.hw-hotel--hero .hw-exchk--heroBar,\n.hw-flight--hero .hw-exchk--heroBar {\n    gap: 16px 24px;\n}\n\n.hw-exchk--heroTitle {\n    margin: 0;\n    color: #fff;\n    font-weight: 700;\n    font-size: clamp(20px, 2.4vw, 27px);\n}\n\n.hw-hotel--heroTimer {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 13px;\n    font-weight: 500;\n    white-space: nowrap;\n    min-width: 250px;\n}\n.hw-hotel--heroTimer svg {\n    color: #fff;\n    width: 18px;\n    height: 18px;\n    flex: 0 0 auto;\n}\n\n/* Stepper styles */\n.hw-exchk--steps {\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: 0;\n    padding: 0;\n}\n.hw-exchk--step {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #98a2b6;\n    font-weight: 600;\n    font-size: 14px;\n}\n.hw-exchk--step:not(:last-child)::after {\n    content: \"\";\n    width: 30px;\n    height: 2px;\n    background: #e2e6ee;\n    margin: 0 6px;\n    border-radius: 2px;\n}\n.hw-exchk--step.is-done:not(:last-child)::after {\n    background: #b8d8c3;\n}\n.hw-exchk--stepNum {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #eef1f7;\n    color: #98a2b6;\n    font-size: 13px;\n    font-weight: 700;\n}\n.hw-exchk--step.is-active {\n    color: #1b2439;\n}\n.hw-exchk--step.is-active .hw-exchk--stepNum {\n    background: #3264FF;\n    color: #fff;\n}\n.hw-exchk--step.is-done {\n    color: #283D6B;\n    cursor: pointer;\n}\n.hw-exchk--step.is-done .hw-exchk--stepNum {\n    background: #137333;\n    color: #fff;\n}\n\n.hw-exchk--hero .hw-exchk--step {\n    color: rgba(255, 255, 255, 0.6);\n}\n.hw-exchk--hero .hw-exchk--step:not(:last-child)::after {\n    background: rgba(255, 255, 255, 0.28);\n}\n.hw-exchk--hero .hw-exchk--step.is-done:not(:last-child)::after {\n    background: rgba(255, 255, 255, 0.55);\n}\n.hw-exchk--hero .hw-exchk--stepNum {\n    background: rgba(255, 255, 255, 0.18);\n    color: #fff;\n    border: 1.5px solid rgba(255, 255, 255, 0.5);\n}\n.hw-exchk--hero .hw-exchk--step.is-active {\n    color: #fff;\n}\n.hw-exchk--hero .hw-exchk--step.is-active .hw-exchk--stepNum {\n    background: #fff;\n    color: #283D6B;\n    border-color: #fff;\n}\n.hw-exchk--hero .hw-exchk--step.is-done {\n    color: #fff;\n}\n.hw-exchk--hero .hw-exchk--step.is-done .hw-exchk--stepNum {\n    background: #4ade80;\n    color: #0f3d22;\n    border-color: #4ade80;\n}\n\n/* Overlap booking content onto hero banner — exact match with hw-hotel--hotelDetails */\n/* Overlap booking content onto hero banner — exact match with hw-hotel--hotelDetails */\n.hw-flight--flightDetails {\n    width: 100% !important;\n    max-width: 100% !important;\n    overflow-x: clip !important;\n    overflow-y: visible !important;\n    box-sizing: border-box !important;\n}\n\n.hw-flight--flightDetails .hw-page--width {\n    max-width: 144rem !important;\n    width: 100% !important;\n    margin-left: auto !important;\n    margin-right: auto !important;\n    padding: 0 1.5rem !important;\n    box-sizing: border-box !important;\n}\n\n@media (min-width: 600px) {\n    .hw-flight--flightDetails .hw-page--width {\n        padding-left: 3rem !important;\n        padding-right: 3rem !important;\n    }\n}\n@media (min-width: 1200px) {\n    .hw-flight--flightDetails .hw-page--width {\n        padding-left: 5rem !important;\n        padding-right: 5rem !important;\n    }\n}\n@media (min-width: 1300px) {\n    .hw-flight--flightDetails .hw-page--width {\n        padding-left: 6rem !important;\n        padding-right: 6rem !important;\n    }\n}\n@media (min-width: 1400px) {\n    .hw-flight--flightDetails .hw-page--width {\n        padding-left: 10rem !important;\n        padding-right: 10rem !important;\n    }\n}\n\n.hw-flight--flightDetails .hw-page--width > .hw-passenger--wrapper,\n.hw-page--width > .hw-passenger--wrapper.fbd-overlap-wrap,\n.hw-passenger--wrapper.fbd-overlap-wrap,\n.fbd-overlap-wrap {\n    padding-top: 0 !important;\n    margin-top: -34px !important;\n    position: relative !important;\n    z-index: 20 !important;\n    overflow: visible !important;\n}\n\n.hw-flight--flightDetails .hw-passenger--list,\n.fbd-overlap-wrap .hw-passenger--list {\n    display: block !important;\n    height: auto !important;\n    overflow: visible !important;\n    row-gap: 0;\n}\n\n.hw-flight--flightDetails .hw-passenger--wrapper,\n.hw-flight--flightDetails .hw-passenger--listShow,\n.fbd-overlap-wrap,\n.fbd-overlap-wrap .hw-passenger--listShow {\n    overflow: visible !important;\n}\n\n@media (min-width: 1025px) {\n    .hw-flight--flightDetails .hw-passenger--list,\n    .fbd-overlap-wrap .hw-passenger--list {\n        display: block !important;\n        height: auto !important;\n        overflow: visible !important;\n    }\n\n    .hw-flight--flightDetails .hw-passenger--wrapper,\n    .fbd-overlap-wrap.hw-passenger--wrapper {\n        align-items: start !important;\n    }\n\n    .hw-flight--flightDetails .hw-passenger--fareSummary,\n    .hw-flight--flightDetails .fbd-sidebar,\n    .fbd-overlap-wrap .hw-passenger--fareSummary,\n    .fbd-overlap-wrap .fbd-sidebar,\n    aside.hw-passenger--fareSummary.fbd-sidebar {\n        position: -webkit-sticky !important;\n        position: sticky !important;\n        top: 24px !important;\n        align-self: start !important;\n        z-index: 10;\n    }\n}\n\n/* Confirmation Hero (hw-cfhero) */\n.hw-flight--flightDetails .hw-cfhero,\n.hw-flight--stepsWrapper .hw-cfhero,\n.hw-flight--hero.hw-cfhero,\n.hw-cfhero {\n    width: 100%;\n    color: #fff;\n    padding: 16px 0 60px !important;\n    min-height: 147px !important;\n    box-shadow: 0 10px 26px -18px rgba(40, 61, 107, 0.5);\n    background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);\n}\n.hw-cfhero.is-confirm,\n.hw-cfhero.is-cancel-hotel,\n.hw-cfhero.is-confirm-hotel,\n.hw-cfhero.is-pending {\n    padding: 16px 0 60px !important;\n    min-height: 147px !important;\n    background: linear-gradient(120deg, #283D6B 0%, #22335e 52%, #3264FF 165%);\n}\n\n.hw-cfhero .hw-exchk--back,\n.hw-cfhero--back {\n    color: rgba(255, 255, 255, 0.85);\n    margin-bottom: 6px;\n    font-size: 14px;\n    line-height: 1.5;\n}\n.hw-cfhero .hw-exchk--back:hover,\n.hw-cfhero--back:hover {\n    color: #fff;\n}\n\n.hw-cfhero--bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    flex-wrap: wrap;\n    margin-top: 4px;\n}\n.hw-cfhero--left {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n.hw-cfhero--badge {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.16);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: none;\n    color: #fff;\n}\n.hw-cfhero--badge svg {\n    width: 24px;\n    height: 24px;\n}\n.hw-cfhero--title {\n    margin: 0;\n    color: #fff;\n    font-weight: 700;\n    font-size: clamp(20px, 2.4vw, 27px);\n}\n.hw-cfhero--sub {\n    margin: 3px 0 0;\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 14px;\n    max-width: 640px;\n    line-height: 1.45;\n}\n.hw-cfhero--id {\n    text-align: right;\n}\n.hw-cfhero--idLabel {\n    display: flex;\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 11.5px;\n    text-transform: uppercase;\n    letter-spacing: .05em;\n}\n.hw-cfhero--idVal {\n    display: block;\n    color: #fff;\n    font-weight: 800;\n    font-size: 16px;\n    margin-top: 2px;\n}\n\n.hw-cfhero--id .fbd-hold-expiry {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: #fee2e2;\n    color: #b42318 !important;\n    padding: 4px 12px;\n    border-radius: 999px;\n    font-weight: 600;\n}\n\n@media (max-width: 767px) {\n    .hw-exchk--heroBar {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n        margin-top: 10px;\n    }\n    .hw-exchk--steps {\n        gap: 4px;\n        flex-wrap: nowrap;\n    }\n    .hw-exchk--step {\n        font-size: 13px;\n    }\n    .hw-exchk--step:not(:last-child)::after {\n        width: 20px;\n        margin: 0 4px;\n    }\n    .hw-exchk--stepNum {\n        width: 24px;\n        height: 24px;\n        font-size: 12px;\n        flex: none;\n    }\n    .hw-cfhero--bar {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n        margin-top: 10px;\n    }\n}\n\n@media (max-width: 600px) {\n    .hw-cfhero--id {\n        text-align: left;\n    }\n}\n\n/* Responsive adjustments for flight cards & widgets on mobile (matching hotel checkout) */\n@media (max-width: 1024px) {\n    .hw-passenger--pageList {\n        display: block !important;\n    }\n\n    .hw-flight--flightDetails .hw-passenger--wrapper,\n    .hw-flight--flightDetails .hw-page--width > .hw-passenger--wrapper,\n    .hw-passenger--wrapper.fbd-overlap-wrap {\n        display: flex !important;\n        flex-direction: column !important;\n        grid-template-columns: 100% !important;\n        gap: 16px !important;\n        width: 100% !important;\n        max-width: 100% !important;\n        min-width: 0 !important;\n        box-sizing: border-box !important;\n    }\n\n    .hw-flight--flightDetails .hw-passenger--list,\n    .hw-flight--flightDetails .hw-passenger--list.hw-3rd-active-booking-details,\n    .hw-flight--flightDetails .hw-passenger--listShow,\n    .hw-flight--flightDetails .hw-passenger--listShow.fbd-page,\n    .hw-flight--flightDetails .hw-passenger--fareSummary.fbd-sidebar,\n    .hw-flight--flightDetails .fbd-sidebar {\n        width: 100% !important;\n        max-width: 100% !important;\n        min-width: 0 !important;\n        box-sizing: border-box !important;\n    }\n}\n\n@media (max-width: 767px) {\n    .hw-flight--flightDetails .fbd-card,\n    .hw-flight--flightDetails .fbd-guestCard,\n    .hw-flight--flightDetails .fbd-flightGroup,\n    .hw-flight--flightDetails .hw-passenger--listShow__widget,\n    .hw-flight--flightDetails .hw-passenger--fareShow__widget,\n    .hw-flight--flightDetails .hw-after--bookingWidget,\n    .hw-flight--flightDetails .hw-passenger--fareSummary.fbd-sidebar {\n        width: 100% !important;\n        max-width: 100% !important;\n        min-width: 0 !important;\n        box-sizing: border-box !important;\n    }\n\n    .fbd-guestCard {\n        padding: 16px 14px !important;\n        border-radius: 8px !important;\n    }\n\n    .hw-passenger--listShow__widget.fbd-card,\n    .hw-passenger--fareShow__widget.fbd-card,\n    .fbd-card {\n        padding: 16px 14px !important;\n        /* border-radius: 8px !important; */\n    }\n\n    .fbd-section__header {\n        margin-bottom: 14px;\n        padding-bottom: 12px;\n        gap: 10px;\n    }\n\n    .fbd-section__icon {\n        width: 32px;\n        height: 32px;\n    }\n\n    .fbd-section__icon svg {\n        width: 16px;\n        height: 16px;\n    }\n\n    .fbd-section__title {\n        font-size: var(--fbd-title-size);\n    }\n\n    .fbd-info-list {\n        padding-left: 18px;\n        margin-bottom: 0;\n    }\n\n    .fbd-info-list li {\n        font-size: 13px;\n        line-height: 1.5;\n        margin-bottom: 8px;\n    }\n\n    .hw-after--bookingWidget {\n        padding: 16px 14px !important;\n        border-radius: 8px !important;\n    }\n\n    .hw-after--bookingWidget .h4,\n    .fbd-sidebar .hw-after--bookingWidget.tickets .h4 {\n        font-size: 16px;\n    }\n\n    .fbd-pax-table-wrap .fbd-pax-table {\n        min-width: 480px !important;\n    }\n\n    .fbd-pax-table-wrap .fbd-pax-table thead th,\n    .fbd-pax-table-wrap .fbd-pax-table tbody td {\n        padding: 8px 10px !important;\n        font-size: 12.5px !important;\n        white-space: nowrap !important;\n    }\n\n    .fbd-flightGroup__head {\n        padding: 12px 14px !important;\n        gap: 10px !important;\n        box-sizing: border-box !important;\n        width: 100% !important;\n        max-width: 100% !important;\n    }\n\n    .fbd-flightGroup__rows {\n        width: 100% !important;\n        max-width: 100% !important;\n        min-width: 0 !important;\n    }\n\n    .fbd-flightSummaryRow {\n        flex-wrap: wrap !important;\n        gap: 8px 12px !important;\n        width: 100% !important;\n        max-width: 100% !important;\n    }\n\n    .fbd-flightSummary__airline {\n        flex: 0 0 auto !important;\n        max-width: 100% !important;\n        min-width: 0 !important;\n    }\n\n    .fbd-flightSummary__route {\n        flex: 0 0 auto !important;\n        font-size: 1.4rem !important;\n    }\n\n    .fbd-flightSummary__meta {\n        flex-basis: 100% !important;\n        width: 100% !important;\n        font-size: 1.2rem !important;\n        color: var(--fbd-text-muted) !important;\n        flex-wrap: wrap !important;\n        gap: 4px 6px !important;\n    }\n\n    .fbd-flightSummary__chev {\n        flex: 0 0 auto !important;\n        margin-left: auto !important;\n    }\n\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead,\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbodyTR,\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead > span,\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbodyTR > span {\n        font-size: 13.5px !important;\n    }\n\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__thead,\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tbodyTR {\n        gap: 8px !important;\n    }\n\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tfoot {\n        padding-top: 10px !important;\n        margin-top: 0 !important;\n    }\n\n    .hw-after--bookingWidget.price-backup .hw-passenger--fareSummary__tfoot span {\n        font-size: 16px !important;\n    }\n}\n\n@media (max-width: 600px) {\n    .hw-flight--flightDetails .hw-page--width > .hw-passenger--wrapper,\n    .hw-page--width > .hw-passenger--wrapper.fbd-overlap-wrap,\n    .hw-passenger--wrapper.fbd-overlap-wrap,\n    .fbd-overlap-wrap {\n        margin-top: -24px !important;\n    }\n}\n\n@media (max-width: 575px) {\n    .fbd-ticket-row {\n        flex-direction: column !important;\n        gap: 8px !important;\n        width: 100% !important;\n    }\n\n    .fbd-ticket-row > .hw-btn {\n        width: 100% !important;\n        flex: 1 1 auto !important;\n    }\n\n    .fbd-markup-row {\n        flex-direction: column !important;\n        gap: 8px !important;\n        width: 100% !important;\n    }\n\n    .fbd-markup-row > .hw-form--input,\n    .fbd-markup-row > .hw-btn {\n        width: 100% !important;\n        flex: 1 1 auto !important;\n    }\n\n    .hw-after--bookingWidget.tickets {\n        padding: 14px 12px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .hw-flight--flightDetails .hw-page--width {\n        padding-left: 12px !important;\n        padding-right: 12px !important;\n    }\n\n    .hw-passenger--fareSummary__box {\n        padding: 14px 12px !important;\n    }\n\n    .fbd-pax-table-wrap .fbd-pax-table {\n        min-width: 420px !important;\n    }\n\n    .fbd-pax-table-wrap .fbd-pax-table thead th,\n    .fbd-pax-table-wrap .fbd-pax-table tbody td {\n        padding: 8px 8px !important;\n        font-size: 12px !important;\n    }\n\n    .fbd-fb-body {\n        padding: 14px 12px 10px !important;\n    }\n\n    .fbd-fb-iata__code {\n        font-size: 19px !important;\n    }\n\n    .fbd-fb-connector {\n        padding: 0 6px !important;\n    }\n\n    .fbd-fb-connector__plane svg {\n        width: 18px !important;\n        height: 18px !important;\n    }\n\n    .fbd-fb-connector__airline {\n        flex-wrap: wrap !important;\n        gap: 8px !important;\n        margin-bottom: 12px !important;\n    }\n\n    .fbd-fb-connector__flight-no {\n        text-align: left !important;\n        font-size: 12px !important;\n    }\n}\n\n/* left column just holds the payment card; align it to the top of the row */\n.hw-passenger--list.fbd-payment-left {\n    align-self: start;\n}\n\n.fbd-sidebar.fbd-pay-panel {\n    position: static;\n    top: auto;\n    width: 100%;\n    align-self: start;\n    background: #ffffff;\n    border: 1px solid var(--fbd-border, #e2e8f0);\n    border-radius: var(--fbd-radius-lg, 6px);\n    box-shadow: var(--fbd-shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n    overflow: hidden;\n}\n\n.fbd-sidebar.fbd-pay-panel .fbd-pay-panel__box {\n    padding: 24px;\n}\n\n/* Payment Methods Selector & Cards (matches hotel / excursion .hw-exchk--pay-wrap) */\n.hw-exchk--pay-wrap,\n.fbd-pay-methods {\n    margin-bottom: 12px;\n}\n\n.hw-exchk--panelTitle,\n.fbd-select-pay-methods__title,\n.fbd-pay-methods__title {\n    color: #1b2439;\n    margin-bottom: 14px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.fbd-section__optional {\n    font-size: 13px;\n    font-weight: 400;\n    color: #98a2b6;\n}\n\n.hw-exchk--payGrid,\n.fbd-pay-methods__grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.hw-exchk--method,\n.fbd-pay-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    flex: 1 1 240px;\n    min-width: 0;\n    text-align: left;\n    background: #fff;\n    border: 1.5px solid #e2e6ee;\n    border-radius: 12px;\n    padding: 16px;\n    cursor: pointer;\n    transition: border-color .15s, box-shadow .15s, background .15s;\n    user-select: none;\n    box-sizing: border-box;\n}\n\n.hw-exchk--method:hover,\n.fbd-pay-card:hover {\n    border-color: #c3ccdb;\n}\n\n.hw-exchk--method.is-selected,\n.fbd-pay-card.fbd-pay-card--active,\n.fbd-pay-card--active {\n    border-color: #3264FF;\n    background: #f5f8ff;\n}\n\n.hw-exchk--methodRadio,\n.fbd-pay-card__radio {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 2px solid #c3ccdb;\n    flex: none;\n    position: relative;\n    background: transparent;\n    transition: border-color .15s;\n}\n\n.hw-exchk--method.is-selected .hw-exchk--methodRadio,\n.fbd-pay-card--active .fbd-pay-card__radio {\n    border-color: #3264FF;\n}\n\n.hw-exchk--method.is-selected .hw-exchk--methodRadio::after,\n.fbd-pay-card--active .fbd-pay-card__radio::after {\n    content: \"\";\n    position: absolute;\n    inset: 3px;\n    border-radius: 50%;\n    background: #3264FF;\n}\n\n.hw-exchk--methodIco,\n.fbd-pay-card__icon {\n    color: #283D6B;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.hw-exchk--methodIco svg,\n.fbd-pay-card__icon svg {\n    width: 22px;\n    height: 22px;\n}\n\n.hw-exchk--methodBody,\n.fbd-pay-card__text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.hw-exchk--methodName,\n.fbd-pay-card__title {\n    color: #1b2439;\n    line-height: 1.3;\n}\n\n.hw-exchk--methodDesc,\n.fbd-pay-card__sub {\n    color: #6b7280;\n    font-size: 12.5px;\n    margin-top: 2px;\n    line-height: 1.3;\n}\n\n.fbd-divider {\n    height: 1px;\n    background: var(--fbd-border, #e2e8f0);\n    margin: 20px 0;\n}\n\n.fbd-booking-ref {\n    /* spacing to the next block is owned by the sibling rule below, so the gap\n       matches the hotel's 16px exactly instead of collapsing against it */\n    margin-bottom: 0;\n}\n\n/* gap between Booking Reference and the Terms & Conditions block — mirrors the\n   hotel's `.hw-hotel--guestCard .hw-term--condition { margin-top: 16px }` */\n.fbd-booking-ref + .hw-term--condition {\n    margin-top: 16px;\n}\n\n.fbd-booking-ref .hw-form--input {\n    width: 100%;\n    /* gap comes from the label's 6px margin-bottom, as in the hotel/excursion field */\n    margin-top: 0;\n}\n\n/* more breathing room between the Terms & Conditions checkbox and its text\n   (shared .hw-term--conditionInput only has .4rem) */\n.fbd-pay-panel .hw-term--conditionInput {\n    column-gap: 10px;\n    align-items: flex-start;\n}\n\n/* keep the checkbox a fixed square — when the label wraps to 2 lines on small\n   screens the flex row stretched it into a tall rounded rectangle. */\n.fbd-pay-panel .hw-term--conditionInput input[type=\"checkbox\"] {\n    flex: 0 0 auto;\n    width: 2rem;\n    height: 2rem;\n    align-self: flex-start;\n    margin-top: 0.2rem;\n}\n\n.fbd-pay-panel .fbd-pay-panel__box>.hw-select--payment {\n    margin-top: 0;\n    padding-top: 0;\n    border-top: 0;\n}\n\n.fbd-pay-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 16px;\n}\n\n/* booking error sits under the Pay Now button, left aligned */\n.fbd-pay-error {\n    margin-top: 10px;\n    text-align: left;\n}\n\n/* the hold block's wrapper is a shared .hw-term--condition flex column with\n   row-gap: 2rem, which would stack on top of the error's own margin — drop the\n   gap there so the error sits 10px below the buttons, as on the payment panel */\n.hw-term--condition.fbd-hold-actions {\n    row-gap: 0;\n}\n\n/* tighter space above the hold buttons than the default 16px */\n.fbd-hold-actions .fbd-pay-actions {\n    margin-top: 10px;\n}\n\n.fbd-pay-error .hw-input--error-search {\n    position: static;\n    display: inline-block;\n    max-width: 100%;\n}\n\n.fbd-pay-actions>.hw-btn {\n    flex: 1 1 0;\n    width: auto;\n    margin: 0;\n}\n\n@media (max-width: 520px) {\n    .fbd-pay-actions {\n        flex-direction: column;\n    }\n}\n\n.hw-after--bookingWidget .fbd-pay-methods__grid {\n    grid-template-columns: 1fr;\n}\n\n.hw-after--bookingWidget .fbd-pay-actions {\n    flex-direction: column;\n}\n\n/* Download Tickets section: \"with Fare | without Fare\" share one row, and the\n   markup input + \"with Markup\" button share one row. */\n.fbd-ticket-row {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n    align-items: center;\n}\n\n.fbd-ticket-row > .hw-btn {\n    flex: 1 1 0;\n    min-width: 0;\n    width: auto;\n    margin: 0;\n    white-space: nowrap;\n}\n\n.fbd-markup-row {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n    align-items: center;\n}\n\n.fbd-markup-row > .hw-form--input {\n    flex: 1 1 auto;\n    min-width: 0;\n    margin-top: 0;\n}\n\n.fbd-markup-row > .hw-btn {\n    flex: 0 0 auto;\n    width: auto;\n    white-space: nowrap;\n}\n\n@media (max-width: 575px) {\n    .fbd-ticket-row {\n        flex-direction: column !important;\n        gap: 8px !important;\n        width: 100% !important;\n    }\n    .fbd-ticket-row > .hw-btn {\n        width: 100% !important;\n        flex: 1 1 auto !important;\n    }\n    .fbd-markup-row {\n        flex-direction: column !important;\n        gap: 8px !important;\n        width: 100% !important;\n    }\n    .fbd-markup-row > .hw-form--input,\n    .fbd-markup-row > .hw-btn {\n        width: 100% !important;\n        flex: 1 1 auto !important;\n    }\n}\n\n.fbd-confirm-banner .hw-bookId .fbd-hold-expiry {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: #fee2e2;\n    color: #b42318 !important;\n    padding: 4px 12px;\n    border-radius: 999px;\n    font-weight: 600;\n    margin-top: 6px !important;\n}\n\n.fbd-stripe-dialog {\n    max-width: 460px;\n    width: 100%;\n}\n\n.fbd-stripe.hw-modal-content {\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-lg);\n    overflow: hidden;\n    box-shadow: var(--fbd-shadow-lg, 0 20px 48px rgba(16, 24, 40, 0.18));\n}\n\n.fbd-stripe .hw-modal-header {\n    background: var(--fbd-surface-alt);\n    border-bottom: 1px solid var(--fbd-border);\n    padding: 18px 22px;\n}\n\n.fbd-stripe .hw-modal-headerTitle {\n    color: var(--fbd-text-strong);\n}\n\n.fbd-stripe .hw-modal-body {\n    padding: 22px;\n}\n\n.fbd-stripe .hw-label {\n    font-size: 13px;\n    color: var(--fbd-text-muted);\n    margin-bottom: 6px;\n}\n\n/* card fields */\n.fbd-stripe .hw-stripe-input {\n    border: 1.5px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    padding: 13px 14px;\n    background: var(--fbd-surface);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.fbd-stripe .hw-stripe-input:focus-within {\n    border-color: var(--fbd-primary);\n    box-shadow: 0 0 0 3px var(--fbd-primary-light);\n}\n\n.fbd-stripe .hw-stripe-input.is-error {\n    border-color: #d92d20;\n}\n\n/* total summary box */\n.fbd-stripe .hw-payment--summary {\n    background: var(--fbd-surface-alt);\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    padding: 14px 16px;\n}\n\n/* actions stacked with a small gap */\n.fbd-stripe .hw-payment--actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 2px;\n}\n\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Selected-flights summary bar (ListFlightPage sticky bottom footer).\n   Scoped under .hw-search--flightListBottomFooter — that wrapper is used ONLY by\n   the flight list page (grep-verified), so nothing else on the site is affected.\n   UI only: no markup or logic change. flight.css is imported by ListFlightPage\n   for these rules to apply.\n   ───────────────────────────────────────────────────────────────────────────── */\n.hw-search--flightListBottomFooter {\n    box-shadow: 0 -0.4rem 1.8rem rgba(15, 41, 77, 0.10);\n}\n\n.hw-search--flightListBottomFooter .hw-search--destinationRowMain {\n    align-items: center;\n    column-gap: 1.6rem;\n}\n\n/* flights strip fills the bar so a single (one-way) leg doesn't leave a\n   detached center gap; the total + Book block stays pinned right */\n.hw-search--flightListBottomFooter .col-scroll {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n/* horizontal scroller that holds the per-leg chips */\n.hw-search--flightListBottomFooter .row.hw-search--destinationRow {\n    margin: 0;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    gap: 1rem;\n    padding-block: 0.4rem;\n}\n\n/* ── each selected leg = a clean white chip on the light-blue bar ── */\n.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col {\n    flex: 0 0;\n    align-items: center !important;\n    gap: 1.2rem !important;\n    padding: 0.7rem 1.3rem;\n    background: var(--hw-white, #fff);\n    border: 0.1rem solid rgba(15, 41, 77, 0.10);\n    border-radius: 6px;\n    box-shadow: 0 0.1rem 0.3rem rgba(15, 41, 77, 0.06);\n}\n\n/* airline logo tile */\n.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col img {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 6px;\n    object-fit: contain;\n    background: var(--hw-brand-blue-light, #EBEFFF);\n    padding: 0.3rem;\n}\n\n/* airline name */\n.hw-search--flightListBottomFooter .hw-dtr--mtext {\n    font-size: 1.4rem;\n    font-weight: 700;\n    line-height: 1.2;\n    max-width: 12rem;\n}\n\n/* flight code-number line (sits directly after the airline name) */\n.hw-search--flightListBottomFooter .hw-dtr--mtext+.hw-dtr--dtext {\n    font-size: 1.2rem;\n    font-weight: 400;\n    color: var(--hw-gray-650, #626262);\n}\n\n/* time / route group (dep -> arr) */\n.hw-search--flightListBottomFooter .col-auto.d-flex {\n    gap: 0.8rem !important;\n    padding-inline: 0.4rem;\n}\n\n.hw-search--flightListBottomFooter .col-auto.d-flex>div {\n    text-align: center;\n    line-height: 1.35;\n}\n\n.hw-search--flightListBottomFooter .col-auto.d-flex svg {\n    width: 1.6rem;\n    height: 1.6rem;\n    color: var(--hw-brand-orange, #3264FF);\n    flex-shrink: 0;\n}\n\n.hw-search--flightListBottomFooter .col-auto.d-flex .hw-text12 {\n    font-size: 1.1rem;\n    font-weight: 400;\n    color: var(--hw-gray-650, #626262);\n}\n\n/* leg price (last cell inside a chip) — separated by a soft dashed rule */\n.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col>.d-flex.align-items-center:last-child {\n    align-self: stretch;\n    padding-left: 1.2rem;\n    margin-left: 0.2rem;\n    border-left: 0.1rem dashed rgba(15, 41, 77, 0.15);\n}\n\n.hw-search--flightListBottomFooter .row.hw-search--destinationRow>.col>.d-flex.align-items-center:last-child span {\n    font-size: 1.5rem;\n    font-weight: 700;\n}\n\n/* ── right block: grand total + Book / Select-another button ── */\n.hw-search--flightListBottomFooter .col-fix-right {\n    gap: 1.6rem !important;\n    padding-left: 1.8rem;\n    border-left: 0.1rem solid rgba(15, 41, 77, 0.12);\n}\n\n.hw-search--flightListBottomFooter .col-fix-right .hw-text18 {\n    font-size: 2rem;\n    font-weight: 800;\n    line-height: 1.1;\n}\n\n.hw-search--flightListBottomFooter .col-fix-right .hw-btn {\n    border-radius: 6px;\n    font-weight: 700;\n    box-shadow: 0 0.4rem 1rem rgba(50, 100, 255, 0.22);\n}\n\n/* ── responsive (phones): the whole bar no longer fits on one row, so the\n   flights strip takes the top (still scrolls horizontally) and the grand total\n   + Book drop to their own full-width row below. Scoped to this footer only. ── */\n@media (max-width: 600px) {\n    .hw-search--flightListBottomFooter .hw-search--destinationRowMain {\n        flex-wrap: wrap;\n        column-gap: 1rem;\n        row-gap: 0.8rem;\n    }\n\n    .hw-search--flightListBottomFooter .col-scroll {\n        flex: 1 1 100%;\n        order: 1;\n    }\n\n    /* don't clip the chip — let its content show instead of being cut off */\n    .hw-search--flightListBottomFooter .hw-search--destinationRowMain .col-scroll {\n        overflow: visible;\n    }\n\n    /* chips stack full-width (no horizontal scroll) and wrap their own content,\n       so the leg price is never clipped off the right edge */\n    .hw-search--flightListBottomFooter .row.hw-search--destinationRow {\n        flex-wrap: wrap;\n        overflow-x: visible;\n        gap: 0.8rem;\n    }\n\n    .hw-search--flightListBottomFooter .row.hw-search--destinationRow > .col {\n        flex: 1 1 100%;\n        flex-wrap: wrap;\n        row-gap: 0.4rem;\n    }\n\n    /* leg price sits at the end of the chip line (wraps below if needed) */\n    .hw-search--flightListBottomFooter .row.hw-search--destinationRow > .col > .d-flex.align-items-center:last-child {\n        margin-left: auto;\n    }\n\n    .hw-search--flightListBottomFooter .col-fix-right {\n        order: 2;\n        flex: 1 1 100%;\n        width: 100%;\n        padding-left: 0;\n        border-left: 0;\n        justify-content: space-between;\n        gap: 1rem !important;\n    }\n\n    .hw-search--flightListBottomFooter .col-fix-right .hw-text18 {\n        font-size: 1.6rem;\n    }\n\n    .hw-search--flightListBottomFooter .col-fix-right .hw-btn {\n        min-width: 11rem;\n        padding: 0.9rem 1.4rem;\n    }\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Flight listing top row: \"View As\" (left) + Cheapest/Fastest filter (right)\n   on one row. Scoped to the fbd- hook so shared hw- classes aren't touched\n   globally. Two-class selectors win over the global base rules on specificity.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-filterTopRow.hw-search--flightFilterResult__top {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n/* The global .hw-twoLine--iconFilter has width:100% which forced it onto its own\n   row; override it so it shrinks and sits on the right. */\n.fbd-filterTopRow .hw-twoLine--iconFilter {\n    width: auto;\n    flex: 0 0 auto;\n    margin-left: auto;\n}\n\n/* Even out the tab padding (base is 0.1rem 1rem 0.6rem — almost no top). */\n.fbd-filterTopRow .hw-twoLine--iconFilter .hw-flight--cTab {\n    padding: 0.6rem 1.4rem;\n}\n\n/* Match the Cheapest/Fastest text style to .hw-btn.hw-btn--tabLink\n   (font-size 1.4rem, weight 500 — overriding .hw-fontBold's bold !important).\n   NOTE: do NOT set color here — the active/inactive color is handled by the\n   base .hw-flight--cTab.active rules (white on the blue active tab). */\n.fbd-filterTopRow .hw-twoLine--iconFilter .hw-flight--cTab span {\n    font-size: 1.4rem;\n    font-weight: 500 !important;\n    line-height: 1.5;\n}\n\n@media (max-width: 640px) {\n    .fbd-filterTopRow.hw-search--flightFilterResult__top {\n        flex-wrap: wrap;\n    }\n\n    .fbd-filterTopRow .hw-twoLine--iconFilter {\n        width: 100%;\n        margin-left: 0;\n    }\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Stepper bar (Trip.com style): one dark container. The selected onward shows\n   as a light inset card; the current leg shows as white text on the dark bar.\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-stepBar {\n    background: #0f1b33;\n    border-radius: 6px;\n    padding: 12px;\n    margin-bottom: 10px;\n}\n\n.fbd-stepBar__onward {\n    background: #ffffff;\n    border-radius: 6px;\n    padding: 10px 14px;\n    margin-bottom: 10px;\n}\n\n.fbd-stepBar__current {\n    color: #ffffff;\n    padding: 2px 4px;\n}\n\n.fbd-stepBar__current .fbd-stepBar__date {\n    opacity: 0.85;\n}\n\n.fbd-stepBar__change {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-weight: 600;\n    color: #2f6fed;\n}\n\n/* ------------------------------------------------------------------ */\n/* Sidebar filter sections moved from the top row: Flight Selection    */\n/* (Single/Combo) and Sort By (Cheapest/Fastest), shown above Price.   */\n/* Scoped to fbd- hooks so shared hw- classes are untouched.           */\n/* ------------------------------------------------------------------ */\n.fbd-sideFilter .hw-search--flightFilter__title {\n    margin-bottom: 8px;\n}\n\n/* Single / Combo tabs sit side by side and share the row evenly */\n/* Flight Selection (Single/Combo) and Sort By (Cheapest/Fastest) reuse the\n   Stops pill look: hw-btn hw-btn--smallSize + hw-btn--secondaryOutline /\n   hw-btn--primaryOutlineActive. Both pills share the row evenly. */\n.fbd-sideFilter__tabs,\n.fbd-sideFilter__sort {\n    display: flex;\n    gap: 8px;\n    width: 100%;\n}\n.fbd-sideFilter__tabs .hw-btn,\n.fbd-sideFilter__sort .hw-btn {\n    flex: 1 1 0;\n    text-align: center;\n}\n\n/* Sort By pills carry two lines (label + price | duration), so let the button\n   grow vertically and stack its spans instead of the default single centered line. */\n.fbd-sortBtn {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: auto;\n    gap: 2px;\n    line-height: 1.3;\n    white-space: normal;\n}\n.fbd-sortBtn .hw-no-price {\n      color: var(--Blue, #3264FF);\n  text-align: center;\n  font-family: \"DM Sans\";\n  font-size: 1.4rem;\n  font-style: normal;\n  font-weight: 500;\n}\n\n/* ------------------------------------------------------------------ */\n/* Scroll-to-top button: a footer pinned to the bottom of the filter     */\n/* card. No wrapper — the sidebar keeps its original sticky behaviour, so */\n/* there is no extra sticky unit to mis-offset and cause a top gap.       */\n/* ------------------------------------------------------------------ */\n.fbd-scrollTopBtn {\n    position: sticky;\n    bottom: 0;\n    display: block;\n    width: 100%;\n    margin-top: 1.2rem;\n    padding: 1rem 1.4rem;\n    border: 1px solid var(--hw-brand-orange);\n    background-color: var(--hw-white);\n    color: var(--hw-brand-orange);\n    border-radius: 6px;\n    font-size: 1.4rem;\n    font-weight: 600;\n    cursor: pointer;\n    text-align: center;\n}\n.fbd-scrollTopBtn:hover {\n    background-color: var(--hw-brand-orange-light);\n}\n/* Hide it when the filter rail is collapsed (narrow) so it doesn't widen the rail. */\n.filter-collapsed .fbd-scrollTopBtn {\n    display: none;\n}\n\n/* Per-flight header inside Meals/Baggage & Seat sections (mixed booking) */\n/* so the user knows which leg a selection applies to.                   */\n/* ------------------------------------------------------------------ */\n.fbd-legHeading {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin: 6px 0 14px;\n    font-size: 1.3rem;\n    font-weight: 600;\n    color: var(--hw-black-900);\n}\n.fbd-legHeading__dir {\n    background-color: var(--hw-brand-orange-light);\n    color: var(--hw-brand-orange);\n    padding: 2px 10px;\n    border-radius: 999px;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n.fbd-legHeading__route {\n    color: var(--hw-black-900);\n}\n.fbd-legHeading__airline {\n    color: var(--hw-gray-600);\n    font-weight: 500;\n}\n\n/* ------------------------------------------------------------------ */\n/* Collapsible flights: ONE box listing each leg's compact summary row,   */\n/* with a single chevron that toggles the full details of all legs.       */\n/* ------------------------------------------------------------------ */\n.fbd-flightGroup__head {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    width: 100%;\n    padding: 12px 16px;\n    background: var(--hw-white);\n    border: none;\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n}\n.fbd-flightGroup__rows {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    flex: 1 1 auto;\n    min-width: 0;\n}\n.fbd-flightSummaryRow {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n.fbd-flightGroup__body {\n    display: grid;\n    grid-template-rows: 0fr;\n    transition: grid-template-rows 0.3s ease;\n}\n.fbd-flightGroup__body.is-open {\n    grid-template-rows: 1fr;\n    border-top: 1px solid var(--hw-gray-400);\n}\n.fbd-flightGroup__bodyInner {\n    overflow: hidden;\n    min-height: 0;\n}\n.fbd-flightSummary__airline {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n}\n.fbd-flightSummary__airline img {\n    border-radius: 6px;\n    flex: 0 0 auto;\n}\n.fbd-flightSummary__airlineName {\n    font-weight: 600;\n    color: var(--hw-black-900);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.fbd-flightSummary__route {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--hw-black-900);\n    font-size: 1.5rem;\n}\n.fbd-flightSummary__route b { font-weight: 700; }\n.fbd-flightSummary__arrow { color: var(--hw-brand-orange); display: inline-flex; }\n.fbd-flightSummary__meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--hw-black-900);\n    font-size: 1.3rem;\n    font-weight: 500;\n}\n.fbd-flightSummary__chev,\n.hw-exchk--sectionChevron {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.2s ease;\n    color: #000000;\n}\n.fbd-flightSummary__chev.is-open,\n.hw-exchk--sectionHead__toggle.is-open .hw-exchk--sectionChevron,\n.hw-exchk--sectionHead.is-open .hw-exchk--sectionChevron {\n    transform: rotate(180deg);\n}\n\n\n\n/* ------------------------------------------------------------------ */\n/* Split (multi-vendor round trip) per-leg status strip. Shown only for  */\n/* a mixed booking; makes a PARTLY_BOOKED trip read at a glance (which    */\n/* leg confirmed, which failed). All fbd- classes; no hw- class touched. */\n/* ------------------------------------------------------------------ */\n.fbd-splitStatus {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 14px 16px;\n    border-left: 4px solid var(--fbd-primary);\n}\n.fbd-splitStatus.is-ok { border-left-color: #16a34a; }\n.fbd-splitStatus.is-partial { border-left-color: #dc2626; }\n.fbd-splitStatus__head {\n    font-size: 1.4rem;\n    font-weight: 600;\n    color: var(--fbd-text-strong);\n}\n.fbd-splitStatus.is-partial .fbd-splitStatus__head { color: #b91c1c; }\n.fbd-splitStatus__legs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n.fbd-splitStatus__leg {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    flex: 1 1 260px;\n    padding: 8px 12px;\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-sm);\n    background: var(--fbd-surface-alt);\n}\n.fbd-splitStatus__leg.is-ok { background: #f0fdf4; border-color: #bbf7d0; }\n.fbd-splitStatus__leg.is-failed { background: #fef2f2; border-color: #fecaca; }\n.fbd-splitStatus__dir {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: var(--fbd-text-strong);\n}\n.fbd-splitStatus__badge {\n    padding: 2px 10px;\n    border-radius: 999px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n.fbd-splitStatus__badge.is-ok { background: #dcfce7; color: #15803d; }\n.fbd-splitStatus__badge.is-failed { background: #fee2e2; color: #b91c1c; }\n.fbd-splitStatus__pnr {\n    font-size: 1.2rem;\n    color: var(--fbd-text-body);\n    font-weight: 500;\n}\n.fbd-splitStatus__reason {\n    flex-basis: 100%;\n    font-size: 1.15rem;\n    color: #b91c1c;\n}\n.fbd-splitStatus__note {\n    font-size: 1.2rem;\n    color: var(--fbd-text-muted);\n}\n@media (max-width: 575px) {\n    .fbd-splitStatus__leg { flex-basis: 100%; }\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Ticket download cards (2 cards in a single row + markup dropdown)\n   ───────────────────────────────────────────────────────────────────────────── */\n.fbd-ticket-widget {\n    margin-bottom: 16px;\n}\n\n.fbd-ticket-options__grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 12px;\n    width: 100%;\n}\n\n.fbd-ticket-btn {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 14px;\n    border: 1.5px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    background: var(--fbd-surface);\n    cursor: pointer;\n    transition: all 0.2s ease;\n    user-select: none;\n    min-width: 0;\n    box-sizing: border-box;\n    text-align: left;\n    width: 100%;\n    outline: none;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.fbd-ticket-btn:hover:not(:disabled) {\n    border-color: var(--fbd-primary);\n    background: var(--fbd-primary-light);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.10);\n}\n\n.fbd-ticket-btn:active:not(:disabled) {\n    transform: translateY(0);\n    background: #dbeafe;\n}\n\n.fbd-ticket-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.fbd-ticket-btn--loading {\n    border-color: var(--fbd-primary-mid) !important;\n    background: var(--fbd-primary-light) !important;\n    cursor: wait !important;\n    justify-content: center !important;\n}\n\n/* Icon badge */\n.fbd-ticket-btn__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    min-height: 36px;\n    border-radius: 6px;\n    background: var(--fbd-primary-light);\n    color: var(--fbd-primary);\n    flex-shrink: 0;\n    position: relative;\n    box-sizing: border-box;\n}\n\n.fbd-ticket-btn__icon svg {\n    width: 18px;\n    height: 18px;\n}\n\n.fbd-ticket-btn__icon .hw-main--loaderCommon,\n.fbd-ticket-btn__spinner {\n    width: 18px !important;\n    height: 18px !important;\n    min-width: 18px !important;\n    min-height: 18px !important;\n    max-width: 18px !important;\n    max-height: 18px !important;\n    border-width: 2.5px !important;\n    border-style: solid !important;\n    border-color: #dbeafe !important;\n    border-top-color: var(--fbd-primary) !important;\n    display: inline-block !important;\n    position: static !important;\n    margin: 0 !important;\n    flex-shrink: 0 !important;\n    box-sizing: border-box !important;\n}\n\n/* Text */\n.fbd-ticket-btn__text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    line-height: 1.25;\n    overflow: hidden;\n}\n\n.fbd-ticket-btn__title {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: var(--fbd-text-strong);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fbd-ticket-btn:hover:not(:disabled) .fbd-ticket-btn__title {\n    color: var(--fbd-primary);\n}\n\n.fbd-ticket-btn__sub {\n    font-size: 11.5px;\n    color: var(--fbd-text-muted);\n    margin-top: 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Add Markup toggle & panel */\n.fbd-ticket-markup-dropdown {\n    margin-top: 14px;\n    padding-top: 10px;\n    border-top: 1px dashed var(--fbd-border);\n}\n\n.fbd-ticket-markup-toggle {\n    padding: 4px 0;\n    font-size: 13.5px;\n    color: var(--fbd-text-strong);\n    user-select: none;\n    transition: color 0.15s ease;\n}\n\n.fbd-ticket-markup-toggle:hover {\n    color: var(--fbd-primary);\n}\n\n.fbd-ticket-markup-panel {\n    background: var(--fbd-surface-alt);\n    border: 1px solid var(--fbd-border);\n    border-radius: var(--fbd-radius-md);\n    padding: 14px;\n    animation: fbdTicketFadeIn 0.2s ease-out;\n}\n\n.fbd-ticket-markup-panel .markup-price {\n    height: 42px !important;\n    font-size: 14px !important;\n    border: 1.5px solid var(--fbd-border) !important;\n    border-radius: var(--fbd-radius-sm) !important;\n    background: #fff !important;\n}\n\n.fbd-ticket-markup-panel .markup-price:focus {\n    border-color: var(--fbd-primary) !important;\n    box-shadow: 0 0 0 2px var(--fbd-primary-light) !important;\n}\n\n@keyframes fbdTicketFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (max-width: 540px) {\n    .fbd-ticket-options__grid {\n        grid-template-columns: 1fr !important;\n    }\n}\n\n/* ============================================================\n   Booking Processing Overlay (.hw-bkovl)\n   ============================================================ */\n.hw-bkovl { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(20,28,48,.55); -webkit-backdrop-filter: blur(3px); backdrop-filter: blur(3px); }\n.hw-bkovl--card { width: 100%; max-width: 380px; background: #fff; border-radius: 18px; padding: 30px 26px 22px; box-shadow: 0 26px 64px -22px rgba(16,24,40,.45); text-align: center; animation: hwBkPop .28s ease; }\n@keyframes hwBkPop { from { opacity: 0; transform: translateY(10px) scale(.97); } to { opacity: 1; transform: none; } }\n.hw-bkovl--ring { position: relative; width: 74px; height: 74px; margin: 0 auto 16px; }\n.hw-bkovl--spinner { width: 74px; height: 74px; animation: hwBkRotate 1.3s linear infinite; }\n.hw-bkovl--track { fill: none; stroke: #eaf0ff; stroke-width: 4; }\n.hw-bkovl--path { fill: none; stroke: #3264FF; stroke-width: 4; stroke-linecap: round; stroke-dasharray: 85 160; }\n.hw-bkovl--lock { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; color: #283D6B; }\n@keyframes hwBkRotate { to { transform: rotate(360deg); } }\n.hw-bkovl--title { color: #1b2439; }\n.hw-bkovl--sub { margin-top: 4px; color: #6b7280; font-size: 13px; }\n.hw-bkovl--steps { list-style: none; margin: 18px 0 0; padding: 0; display: grid; gap: 11px; text-align: left; }\n.hw-bkovl--step { display: flex; align-items: center; gap: 11px; color: #98a2b6; font-size: 14px; font-weight: 600; transition: color .3s; }\n.hw-bkovl--step.is-active { color: #1b2439; }\n.hw-bkovl--step.is-done { color: #137333; }\n.hw-bkovl--dot { width: 21px; height: 21px; border-radius: 50%; border: 2px solid #dfe4ee; display: inline-flex; align-items: center; justify-content: center; flex: none; color: #fff; transition: all .3s; }\n.hw-bkovl--dot svg { opacity: 0; transition: opacity .2s; }\n.hw-bkovl--step.is-active .hw-bkovl--dot { border-color: #3264FF; box-shadow: 0 0 0 4px rgba(50,100,255,.12); animation: hwBkPulse 1.2s ease-in-out infinite; }\n.hw-bkovl--step.is-done .hw-bkovl--dot { background: #137333; border-color: #137333; }\n.hw-bkovl--step.is-done .hw-bkovl--dot svg { opacity: 1; }\n@keyframes hwBkPulse { 0%,100% { box-shadow: 0 0 0 4px rgba(50,100,255,.12); } 50% { box-shadow: 0 0 0 7px rgba(50,100,255,.05); } }\n.hw-bkovl--note { margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef1f7; color: #6b7280; font-size: 12.5px; }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
